export interface CarModel {
  id: string;
  name: string;
  fuel: string;
  power: string;
  length: string;
  width: string;
  height: string;
  trunk: string;
  price: string;
  discontinued?: boolean;
  generations?: string;
  years?: string;
  reviewUrl?: string;
}

export interface CarBrand {
  id: string;
  name: string;
  logo: string;
  description: string;
  models: CarModel[];
  discontinuedModels?: CarModel[];
}

export const carBrands: CarBrand[] = [
  {
    "id": "abarth",
    "name": "Abarth",
    "logo": "🏁",
    "description": "Performance italiana",
    "models": [
      {
        "id": "500e",
        "name": "500e",
        "fuel": "Elèctric",
        "power": "155",
        "length": "3.632",
        "width": "1.683",
        "height": "1.527",
        "trunk": "185",
        "price": "37.460€"
      },
      {
        "id": "595",
        "name": "595",
        "fuel": "Gasolina",
        "power": "145 / 165 / 180",
        "length": "3.660",
        "width": "1.627",
        "height": "1.485",
        "trunk": "185",
        "price": "20.200€"
      },
      {
        "id": "600e",
        "name": "600e",
        "fuel": "Elèctric",
        "power": "240 / 280",
        "length": "4.189",
        "width": "1.808",
        "height": "1.505",
        "trunk": "N.D.",
        "price": "45.000€"
      },
      {
        "id": "695-esseesse",
        "name": "695 esseesse",
        "fuel": "Gasolina",
        "power": "180",
        "length": "N.D.",
        "width": "N.D.",
        "height": "N.D.",
        "trunk": "N.D.",
        "price": "33.322€"
      },
      {
        "id": "f595",
        "name": "F595",
        "fuel": "Gasolina",
        "power": "165",
        "length": "3.660",
        "width": "1.627",
        "height": "1.490",
        "trunk": "185",
        "price": "20.200€"
      }
    ]
  },
  {
    "id": "aiways",
    "name": "Aiways",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "u5",
        "name": "U5",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.680",
        "width": "1.865",
        "height": "1.700",
        "trunk": "539–1.555",
        "price": "42.690€"
      },
      {
        "id": "u6",
        "name": "U6",
        "fuel": "Elèctric",
        "power": "N.D.",
        "length": "4.805",
        "width": "1.880",
        "height": "1.641",
        "trunk": "472–1.260",
        "price": "49.540€"
      }
    ]
  },
  {
    "id": "alfa-romeo",
    "name": "Alfa Romeo",
    "logo": "🐍",
    "description": "La meccanica delle emozioni",
    "models": [
      {
        "id": "giulia",
        "name": "Giulia",
        "fuel": "Dièsel",
        "power": "160 / 211",
        "length": "4.643",
        "width": "1.860",
        "height": "1.438",
        "trunk": "480",
        "price": "46.100€"
      },
      {
        "id": "giulia",
        "name": "Giulia",
        "fuel": "Gasolina",
        "power": "280 / 520",
        "length": "4.639",
        "width": "1.874",
        "height": "1.428",
        "trunk": "480",
        "price": "46.100€"
      },
      {
        "id": "giulietta",
        "name": "Giulietta",
        "fuel": "Dièsel",
        "power": "120",
        "length": "4.351",
        "width": "1.798",
        "height": "1.465",
        "trunk": "350–1.518",
        "price": "23.995€"
      },
      {
        "id": "giulietta",
        "name": "Giulietta",
        "fuel": "Gasolina",
        "power": "120",
        "length": "4.351",
        "width": "1.798",
        "height": "1.465",
        "trunk": "350–1.518",
        "price": "23.995€"
      },
      {
        "id": "junior",
        "name": "Junior",
        "fuel": "Elèctric",
        "power": "156 / 280",
        "length": "4.173",
        "width": "1.781",
        "height": "1.532",
        "trunk": "400–1.265",
        "price": "29.000€"
      },
      {
        "id": "junior",
        "name": "Junior",
        "fuel": "Híbrid",
        "power": "136 / 145",
        "length": "4.173",
        "width": "1.781",
        "height": "1.540",
        "trunk": "340–1.205",
        "price": "29.000€"
      },
      {
        "id": "stelvio",
        "name": "Stelvio",
        "fuel": "Dièsel",
        "power": "160 / 210",
        "length": "4.687",
        "width": "1.903",
        "height": "1.632",
        "trunk": "525–1.600",
        "price": "56.000€"
      },
      {
        "id": "stelvio",
        "name": "Stelvio",
        "fuel": "Gasolina",
        "power": "280 / 520",
        "length": "4.687",
        "width": "1.903",
        "height": "1.632",
        "trunk": "525–1.600",
        "price": "56.000€"
      },
      {
        "id": "tonale",
        "name": "Tonale",
        "fuel": "Dièsel",
        "power": "130",
        "length": "4.528",
        "width": "1.841",
        "height": "1.601",
        "trunk": "500–1.550",
        "price": "35.600€"
      },
      {
        "id": "tonale",
        "name": "Tonale",
        "fuel": "Híbrid",
        "power": "130 / 160",
        "length": "4.528",
        "width": "1.841",
        "height": "1.601",
        "trunk": "500–1.550",
        "price": "35.600€"
      },
      {
        "id": "tonale",
        "name": "Tonale",
        "fuel": "PHEV",
        "power": "280",
        "length": "4.528",
        "width": "1.841",
        "height": "1.601",
        "trunk": "385–1.430",
        "price": "35.600€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "145",
        "name": "145",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–2000"
      },
      {
        "id": "146",
        "name": "146",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2000"
      },
      {
        "id": "147",
        "name": "147",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2009"
      },
      {
        "id": "155",
        "name": "155",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1998"
      },
      {
        "id": "156",
        "name": "156",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1997–2005"
      },
      {
        "id": "156-sportwagon",
        "name": "156 Sportwagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2005"
      },
      {
        "id": "159",
        "name": "159",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2011"
      },
      {
        "id": "159-sportwagon",
        "name": "159 Sportwagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2011"
      },
      {
        "id": "164",
        "name": "164",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1998"
      },
      {
        "id": "166",
        "name": "166",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2007"
      },
      {
        "id": "1900",
        "name": "1900",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1950–1959"
      },
      {
        "id": "2000",
        "name": "2000",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1977"
      },
      {
        "id": "24-hp",
        "name": "24 HP",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1910–1913"
      },
      {
        "id": "2600",
        "name": "2600",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1962–1965"
      },
      {
        "id": "33",
        "name": "33",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1983–1994"
      },
      {
        "id": "33-sport-wagon",
        "name": "33 Sport Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1994"
      },
      {
        "id": "4c",
        "name": "4C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2020"
      },
      {
        "id": "4c-spider",
        "name": "4C Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2020"
      },
      {
        "id": "6",
        "name": "6",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1979–1986"
      },
      {
        "id": "6c",
        "name": "6C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1927–1952"
      },
      {
        "id": "75",
        "name": "75",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1992"
      },
      {
        "id": "8c",
        "name": "8C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1931–2010"
      },
      {
        "id": "alfasud",
        "name": "Alfasud",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1972–1983"
      },
      {
        "id": "alfasud-giardinetta",
        "name": "Alfasud Giardinetta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1975–1981"
      },
      {
        "id": "alfasud-sprint",
        "name": "Alfasud Sprint",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–1983"
      },
      {
        "id": "alfasud-ti",
        "name": "Alfasud Ti",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1973–1983"
      },
      {
        "id": "alfetta",
        "name": "Alfetta",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1972–1984"
      },
      {
        "id": "arna",
        "name": "Arna",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1983–1987"
      },
      {
        "id": "brera",
        "name": "Brera",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2010"
      },
      {
        "id": "crosswagon-q4",
        "name": "Crosswagon Q4",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2007"
      },
      {
        "id": "giulia-quadrifoglio",
        "name": "Giulia Quadrifoglio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2022"
      },
      {
        "id": "giulia-veloce",
        "name": "Giulia Veloce",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2022"
      },
      {
        "id": "giulietta-quadrifoglio-verde",
        "name": "Giulietta Quadrifoglio Verde",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2016"
      },
      {
        "id": "gt",
        "name": "GT",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2010"
      },
      {
        "id": "gtv",
        "name": "GTV",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2005"
      },
      {
        "id": "mito",
        "name": "MiTo",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2008–2018"
      },
      {
        "id": "mito-quadrifoglio-verde",
        "name": "MiTo Quadrifoglio Verde",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2016"
      },
      {
        "id": "mito-veloce",
        "name": "MiTo Veloce",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2018"
      },
      {
        "id": "montreal",
        "name": "Montreal",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1970–1977"
      },
      {
        "id": "rl",
        "name": "RL",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1922–1927"
      },
      {
        "id": "rm",
        "name": "RM",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1923–1925"
      },
      {
        "id": "spider",
        "name": "Spider",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1970–2010"
      },
      {
        "id": "sprint",
        "name": "Sprint",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1976–1989"
      },
      {
        "id": "stelvio-quadrifoglio",
        "name": "Stelvio Quadrifoglio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2023"
      },
      {
        "id": "tipo-33",
        "name": "Tipo 33",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1967–1969"
      },
      {
        "id": "torpedo-2030-hp",
        "name": "Torpedo 20–30 HP",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1921–1922"
      }
    ]
  },
  {
    "id": "alpine",
    "name": "Alpine",
    "logo": "⛰️",
    "description": "Esportius francesos",
    "models": [
      {
        "id": "a-110",
        "name": "A 110",
        "fuel": "Gasolina",
        "power": "252",
        "length": "4.180",
        "width": "1.798",
        "height": "1.248",
        "trunk": "N.D.",
        "price": "62.200€"
      },
      {
        "id": "a110-gt",
        "name": "A110 GT",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.180",
        "width": "1.798",
        "height": "1.248",
        "trunk": "N.D.",
        "price": "62.200€"
      },
      {
        "id": "a110-r",
        "name": "A110 R",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.256",
        "width": "1.798",
        "height": "1.252",
        "trunk": "N.D.",
        "price": "62.200€"
      },
      {
        "id": "a290",
        "name": "A290",
        "fuel": "Elèctric",
        "power": "180 / 220",
        "length": "3.997",
        "width": "1.823",
        "height": "1.512",
        "trunk": "326",
        "price": "38.700€"
      },
      {
        "id": "a390",
        "name": "A390",
        "fuel": "Elèctric",
        "power": "400 / 470",
        "length": "4.615",
        "width": "2.055",
        "height": "1.525",
        "trunk": "532–1.643",
        "price": "67.500€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "a106",
        "name": "A106",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1955–1964"
      },
      {
        "id": "a108",
        "name": "A108",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1958–1965"
      }
    ]
  },
  {
    "id": "aston-martin",
    "name": "Aston Martin",
    "logo": "🦅",
    "description": "Power, Beauty and Soul",
    "models": [
      {
        "id": "db11",
        "name": "DB11",
        "fuel": "Gasolina",
        "power": "510 / 630",
        "length": "4.750",
        "width": "1.950",
        "height": "1.290",
        "trunk": "270",
        "price": "185.772€"
      },
      {
        "id": "db12",
        "name": "DB12",
        "fuel": "Gasolina",
        "power": "680",
        "length": "4.725",
        "width": "2.060",
        "height": "1.295",
        "trunk": "N.D.",
        "price": "314.000€"
      },
      {
        "id": "db12-volante",
        "name": "DB12 Volante",
        "fuel": "Gasolina",
        "power": "680",
        "length": "4.725",
        "width": "2.060",
        "height": "1.295",
        "trunk": "N.D.",
        "price": "314.000€"
      },
      {
        "id": "dbs-superleggera-coupe",
        "name": "DBS Superleggera Coupe",
        "fuel": "Gasolina",
        "power": "725",
        "length": "4.712",
        "width": "2.146",
        "height": "1.280",
        "trunk": "N.D.",
        "price": "285.826€"
      },
      {
        "id": "dbs-superleggera-volante",
        "name": "DBS Superleggera Volante",
        "fuel": "Gasolina",
        "power": "725",
        "length": "4.715",
        "width": "1.970",
        "height": "1.295",
        "trunk": "N.D.",
        "price": "285.826€"
      },
      {
        "id": "valhalla",
        "name": "Valhalla",
        "fuel": "PHEV",
        "power": "1079",
        "length": "4.727",
        "width": "2.014",
        "height": "1.161",
        "trunk": "N.D.",
        "price": "1.075.000€"
      },
      {
        "id": "vantage",
        "name": "Vantage",
        "fuel": "Gasolina",
        "power": "700",
        "length": "4.514",
        "width": "1.962",
        "height": "1.274",
        "trunk": "346",
        "price": "142.150€"
      },
      {
        "id": "vantage-coupe",
        "name": "Vantage Coupé",
        "fuel": "Gasolina",
        "power": "510",
        "length": "4.465",
        "width": "1.942",
        "height": "1.273",
        "trunk": "350",
        "price": "142.150€"
      },
      {
        "id": "vantage-roadster",
        "name": "Vantage Roadster",
        "fuel": "Gasolina",
        "power": "510",
        "length": "4.465",
        "width": "2.153",
        "height": "1.273",
        "trunk": "N.D.",
        "price": "142.150€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "cygnet",
        "name": "Cygnet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2013"
      },
      {
        "id": "db-ar1",
        "name": "DB AR1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2004"
      },
      {
        "id": "db-mark-iii",
        "name": "DB Mark III",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1957–1959"
      },
      {
        "id": "db11-volante",
        "name": "DB11 Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2023"
      },
      {
        "id": "db2",
        "name": "DB2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1950–1953"
      },
      {
        "id": "db4",
        "name": "DB4",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1958–1963"
      },
      {
        "id": "db5",
        "name": "DB5",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1963–1965"
      },
      {
        "id": "db6",
        "name": "DB6",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1970"
      },
      {
        "id": "db6-volante",
        "name": "DB6 Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1970"
      },
      {
        "id": "db7",
        "name": "DB7",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1993–2004"
      },
      {
        "id": "db7-volante",
        "name": "DB7 Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2003"
      },
      {
        "id": "db9",
        "name": "DB9",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2004–2016"
      },
      {
        "id": "db9-volante",
        "name": "DB9 Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2004–2015"
      },
      {
        "id": "dbs-volante",
        "name": "DBS Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2012"
      },
      {
        "id": "lagonda",
        "name": "Lagonda",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1976–1989"
      },
      {
        "id": "one-77",
        "name": "One-77",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2012"
      },
      {
        "id": "rapide",
        "name": "Rapide",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2013"
      },
      {
        "id": "rapide-amr",
        "name": "Rapide AMR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "rapide-e",
        "name": "Rapide E",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019"
      },
      {
        "id": "rapide-s",
        "name": "Rapide S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2018"
      },
      {
        "id": "v12-speedster",
        "name": "V12 Speedster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2020–2022"
      },
      {
        "id": "v12-vantage-amr",
        "name": "V12 Vantage AMR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2019"
      },
      {
        "id": "v12-vantage-s-roadster",
        "name": "V12 Vantage S Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "v12-zagato",
        "name": "V12 Zagato",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2013"
      },
      {
        "id": "v8-vantage-s",
        "name": "V8 Vantage S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2017"
      },
      {
        "id": "v8-vantage-s-roadster",
        "name": "V8 Vantage S Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2017"
      },
      {
        "id": "v8-volante",
        "name": "V8 Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1978–2014"
      },
      {
        "id": "vanquish-s",
        "name": "Vanquish S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2018"
      },
      {
        "id": "vantage-gt12",
        "name": "Vantage GT12",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2016"
      },
      {
        "id": "vantage-gt8",
        "name": "Vantage GT8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2017"
      },
      {
        "id": "virage",
        "name": "Virage",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1988–2012"
      },
      {
        "id": "virage-volante",
        "name": "Virage Volante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–2012"
      },
      {
        "id": "vulcan",
        "name": "Vulcan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2016"
      }
    ]
  },
  {
    "id": "audi",
    "name": "Audi",
    "logo": "🔴",
    "description": "Vorsprung durch Technik",
    "models": [
      {
        "id": "a1-allstreet",
        "name": "A1 allstreet",
        "fuel": "Gasolina",
        "power": "95 / 110 / 150",
        "length": "4.046",
        "width": "1.756",
        "height": "1.483",
        "trunk": "335–1.090",
        "price": "23.470€"
      },
      {
        "id": "a1-sportback",
        "name": "A1 Sportback",
        "fuel": "Gasolina",
        "power": "95 / 110 / 150",
        "length": "4.029",
        "width": "1.740",
        "height": "1.433",
        "trunk": "335–1.090",
        "price": "23.470€"
      },
      {
        "id": "a3-allstreet",
        "name": "A3 allstreet",
        "fuel": "Dièsel",
        "power": "150",
        "length": "4.353",
        "width": "1.816",
        "height": "1.486",
        "trunk": "380–1.200",
        "price": "34.010€"
      },
      {
        "id": "a3-allstreet",
        "name": "A3 allstreet",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.353",
        "width": "1.816",
        "height": "1.486",
        "trunk": "380–1.200",
        "price": "34.010€"
      },
      {
        "id": "a3-sportback",
        "name": "A3 Sportback",
        "fuel": "Dièsel",
        "power": "116",
        "length": "4.352",
        "width": "1.816",
        "height": "1.415",
        "trunk": "380–1.200",
        "price": "34.010€"
      },
      {
        "id": "a3-sportback",
        "name": "A3 Sportback",
        "fuel": "Gasolina",
        "power": "116 / 150",
        "length": "4.352",
        "width": "1.816",
        "height": "1.415",
        "trunk": "380–1.200",
        "price": "34.010€"
      },
      {
        "id": "a3-sportback",
        "name": "A3 Sportback",
        "fuel": "Híbrid",
        "power": "116",
        "length": "4.352",
        "width": "1.816",
        "height": "1.415",
        "trunk": "380–1.200",
        "price": "34.010€"
      },
      {
        "id": "a3-sportback",
        "name": "A3 Sportback",
        "fuel": "PHEV",
        "power": "204 / 272",
        "length": "4.352",
        "width": "1.816",
        "height": "1.415",
        "trunk": "280–1.100",
        "price": "34.010€"
      },
      {
        "id": "a4",
        "name": "A4",
        "fuel": "Híbrid",
        "power": "136 / 150 / 163 / 204 / 265",
        "length": "4.762",
        "width": "1.847",
        "height": "1.431",
        "trunk": "480",
        "price": "46.070€"
      },
      {
        "id": "a4-allroad-quattro",
        "name": "A4 allroad quattro",
        "fuel": "Híbrid",
        "power": "204 / 265",
        "length": "4.762",
        "width": "1.847",
        "height": "1.493",
        "trunk": "495–1.495",
        "price": "46.070€"
      },
      {
        "id": "a4-avant",
        "name": "A4 Avant",
        "fuel": "Híbrid",
        "power": "136 / 150 / 163 / 204 / 265",
        "length": "4.762",
        "width": "1.847",
        "height": "1.460",
        "trunk": "495–1.495",
        "price": "46.070€"
      },
      {
        "id": "a5",
        "name": "A5",
        "fuel": "Gasolina",
        "power": "150 / 204",
        "length": "4.829",
        "width": "1.860",
        "height": "1.461",
        "trunk": "445–1.299",
        "price": "51.050€"
      },
      {
        "id": "a5",
        "name": "A5",
        "fuel": "Híbrid",
        "power": "204",
        "length": "4.829",
        "width": "1.860",
        "height": "1.461",
        "trunk": "417–1.271",
        "price": "51.050€"
      },
      {
        "id": "a5",
        "name": "A5",
        "fuel": "PHEV",
        "power": "367",
        "length": "4.829",
        "width": "1.860",
        "height": "1.411",
        "trunk": "331–1.175",
        "price": "51.050€"
      },
      {
        "id": "a6-avant",
        "name": "A6 Avant",
        "fuel": "Híbrid",
        "power": "204 / 272 / 299",
        "length": "4.990",
        "width": "1.880",
        "height": "1.494",
        "trunk": "466–1.497",
        "price": "66.500€"
      },
      {
        "id": "a6-avant",
        "name": "A6 Avant",
        "fuel": "PHEV",
        "power": "299 / 367",
        "length": "4.999",
        "width": "1.875",
        "height": "1.490",
        "trunk": "404–1.423",
        "price": "66.500€"
      },
      {
        "id": "a6-avant-e-tron",
        "name": "A6 Avant e-tron",
        "fuel": "Elèctric",
        "power": "285 / 367 / 428",
        "length": "4.928",
        "width": "1.923",
        "height": "1.493",
        "trunk": "502–1.422",
        "price": "66.500€"
      },
      {
        "id": "a6-sportback-e-tron",
        "name": "A6 Sportback e-tron",
        "fuel": "Elèctric",
        "power": "285 / 367 / 428",
        "length": "4.928",
        "width": "1.923",
        "height": "1.455",
        "trunk": "502–1.330",
        "price": "66.500€"
      },
      {
        "id": "a7-sportback",
        "name": "A7 Sportback",
        "fuel": "Híbrid",
        "power": "204 / 231 / 265 / 286 / 340",
        "length": "4.969",
        "width": "1.908",
        "height": "1.422",
        "trunk": "535–1.390",
        "price": "71.150€"
      },
      {
        "id": "a7-sportback",
        "name": "A7 Sportback",
        "fuel": "PHEV",
        "power": "299 / 367",
        "length": "4.976",
        "width": "1.908",
        "height": "1.419",
        "trunk": "380–1.235",
        "price": "71.150€"
      },
      {
        "id": "a8",
        "name": "A8",
        "fuel": "Híbrid",
        "power": "286",
        "length": "5.190",
        "width": "1.945",
        "height": "1.473",
        "trunk": "505",
        "price": "115.940€"
      },
      {
        "id": "a8",
        "name": "A8",
        "fuel": "PHEV",
        "power": "460",
        "length": "5.190",
        "width": "1.945",
        "height": "1.473",
        "trunk": "390",
        "price": "115.940€"
      },
      {
        "id": "e-tron",
        "name": "e-tron",
        "fuel": "Elèctric",
        "power": "308 / 402",
        "length": "4.901",
        "width": "1.935",
        "height": "1.629",
        "trunk": "660–1.725",
        "price": "73.190€"
      },
      {
        "id": "e-tron-gt",
        "name": "e-tron GT",
        "fuel": "Elèctric",
        "power": "591 / 680 / 925",
        "length": "4.997",
        "width": "1.964",
        "height": "1.369",
        "trunk": "350",
        "price": "111.700€"
      },
      {
        "id": "e-tron-s",
        "name": "e-tron S",
        "fuel": "Elèctric",
        "power": "496",
        "length": "4.902",
        "width": "1.976",
        "height": "1.629",
        "trunk": "660–1.725",
        "price": "73.190€"
      },
      {
        "id": "e-tron-sportback",
        "name": "e-tron Sportback",
        "fuel": "Elèctric",
        "power": "308 / 402",
        "length": "4.901",
        "width": "1.935",
        "height": "1.616",
        "trunk": "615–1.665",
        "price": "75.490€"
      },
      {
        "id": "e-tron-sportback-s",
        "name": "e-tron Sportback S",
        "fuel": "Elèctric",
        "power": "496",
        "length": "4.902",
        "width": "1.976",
        "height": "1.615",
        "trunk": "615–1.665",
        "price": "75.490€"
      },
      {
        "id": "q2",
        "name": "Q2",
        "fuel": "Dièsel",
        "power": "116 / 150",
        "length": "4.208",
        "width": "1.794",
        "height": "1.537",
        "trunk": "405–1.050",
        "price": "30.640€"
      },
      {
        "id": "q2",
        "name": "Q2",
        "fuel": "Gasolina",
        "power": "110 / 150",
        "length": "4.208",
        "width": "1.794",
        "height": "1.537",
        "trunk": "405–1.050",
        "price": "30.640€"
      },
      {
        "id": "q3",
        "name": "Q3",
        "fuel": "Dièsel",
        "power": "150",
        "length": "4.531",
        "width": "1.856",
        "height": "1.588",
        "trunk": "488–1.386",
        "price": "42.780€"
      },
      {
        "id": "q3",
        "name": "Q3",
        "fuel": "Gasolina",
        "power": "204",
        "length": "4.531",
        "width": "1.859",
        "height": "1.588",
        "trunk": "488–1.386",
        "price": "42.780€"
      },
      {
        "id": "q3",
        "name": "Q3",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.531",
        "width": "1.859",
        "height": "1.588",
        "trunk": "488–1.386",
        "price": "42.780€"
      },
      {
        "id": "q3",
        "name": "Q3",
        "fuel": "PHEV",
        "power": "272",
        "length": "4.531",
        "width": "1.859",
        "height": "1.588",
        "trunk": "375–1.293",
        "price": "42.780€"
      },
      {
        "id": "q4-e-tron",
        "name": "Q4 e-tron",
        "fuel": "Elèctric",
        "power": "204 / 286 / 299",
        "length": "4.602",
        "width": "2.108",
        "height": "1.599",
        "trunk": "515–1.487",
        "price": "49.970€"
      },
      {
        "id": "q4-e-tron-sportback",
        "name": "Q4 e-tron Sportback",
        "fuel": "Elèctric",
        "power": "204 / 286 / 299",
        "length": "4.603",
        "width": "2.108",
        "height": "1.620",
        "trunk": "527–1.460",
        "price": "49.970€"
      },
      {
        "id": "q5-sportback",
        "name": "Q5 Sportback",
        "fuel": "Híbrid",
        "power": "204",
        "length": "4.717",
        "width": "1.900",
        "height": "1.619",
        "trunk": "515–1.415",
        "price": "61.600€"
      },
      {
        "id": "q5-sportback",
        "name": "Q5 Sportback",
        "fuel": "PHEV",
        "power": "299 / 367",
        "length": "4.717",
        "width": "1.900",
        "height": "1.622",
        "trunk": "433–1.300",
        "price": "61.600€"
      },
      {
        "id": "q5-suv",
        "name": "Q5 SUV",
        "fuel": "Híbrid",
        "power": "204",
        "length": "4.717",
        "width": "1.900",
        "height": "1.625",
        "trunk": "520–1.473",
        "price": "61.600€"
      },
      {
        "id": "q5-suv",
        "name": "Q5 SUV",
        "fuel": "PHEV",
        "power": "299 / 367",
        "length": "4.717",
        "width": "1.900",
        "height": "1.626",
        "trunk": "438–1.358",
        "price": "61.600€"
      },
      {
        "id": "q6-e-tron",
        "name": "Q6 e-tron",
        "fuel": "Elèctric",
        "power": "297 / 388",
        "length": "4.771",
        "width": "1.939",
        "height": "1.648",
        "trunk": "526–1.529",
        "price": "76.420€"
      },
      {
        "id": "q8",
        "name": "Q8",
        "fuel": "Híbrid",
        "power": "231 / 286 / 340 / 381",
        "length": "4.986",
        "width": "1.995",
        "height": "1.705",
        "trunk": "605–1.755",
        "price": "82.970€"
      },
      {
        "id": "q8",
        "name": "Q8",
        "fuel": "PHEV",
        "power": "381 / 462",
        "length": "4.986",
        "width": "1.995",
        "height": "1.701",
        "trunk": "505–1.625",
        "price": "82.970€"
      },
      {
        "id": "q8-e-tron",
        "name": "Q8 e-tron",
        "fuel": "Elèctric",
        "power": "340 / 408",
        "length": "4.915",
        "width": "1.937",
        "height": "1.619",
        "trunk": "569–1.637",
        "price": "84.610€"
      },
      {
        "id": "q8-e-tron-sportback",
        "name": "Q8 e-tron Sportback",
        "fuel": "Elèctric",
        "power": "340 / 408 / 503",
        "length": "4.915",
        "width": "1.937",
        "height": "1.619",
        "trunk": "528–1.567",
        "price": "84.610€"
      },
      {
        "id": "r8-coupe",
        "name": "R8 Coupé",
        "fuel": "Gasolina",
        "power": "540 / 570 / 620",
        "length": "4.429",
        "width": "1.940",
        "height": "1.236",
        "trunk": "N.D.",
        "price": "168.020€"
      },
      {
        "id": "r8-spyder",
        "name": "R8 Spyder",
        "fuel": "Gasolina",
        "power": "540 / 570 / 620",
        "length": "4.429",
        "width": "1.940",
        "height": "1.242",
        "trunk": "N.D.",
        "price": "168.020€"
      },
      {
        "id": "rs-3-sportback",
        "name": "RS 3 Sportback",
        "fuel": "Gasolina",
        "power": "400",
        "length": "4.389",
        "width": "1.984",
        "height": "1.436",
        "trunk": "282–1.104",
        "price": "34.010€"
      },
      {
        "id": "rs-4-avant",
        "name": "RS 4 Avant",
        "fuel": "Gasolina",
        "power": "450",
        "length": "4.782",
        "width": "1.866",
        "height": "1.438",
        "trunk": "495–1.510",
        "price": "46.070€"
      },
      {
        "id": "rs-5",
        "name": "RS 5",
        "fuel": "PHEV",
        "power": "639",
        "length": "4.896",
        "width": "1.952",
        "height": "1.428",
        "trunk": "331–1.170",
        "price": "51.050€"
      },
      {
        "id": "rs-5-avant",
        "name": "RS 5 Avant",
        "fuel": "PHEV",
        "power": "639",
        "length": "4.896",
        "width": "1.952",
        "height": "1.428",
        "trunk": "331–1.170",
        "price": "51.050€"
      },
      {
        "id": "rs-6-avant",
        "name": "RS 6 Avant",
        "fuel": "Híbrid",
        "power": "630",
        "length": "4.995",
        "width": "1.951",
        "height": "1.460",
        "trunk": "565–1.680",
        "price": "66.500€"
      },
      {
        "id": "rs-7-sportback",
        "name": "RS 7 Sportback",
        "fuel": "Híbrid",
        "power": "600",
        "length": "5.009",
        "width": "1.950",
        "height": "1.424",
        "trunk": "535–1.390",
        "price": "71.150€"
      },
      {
        "id": "rs-q8",
        "name": "RS Q8",
        "fuel": "Gasolina",
        "power": "600",
        "length": "5.012",
        "width": "1.998",
        "height": "N.D.",
        "trunk": "605–1.755",
        "price": "82.970€"
      },
      {
        "id": "s3-sportback",
        "name": "S3 Sportback",
        "fuel": "Gasolina",
        "power": "310",
        "length": "4.351",
        "width": "1.816",
        "height": "1.438",
        "trunk": "325–1.145",
        "price": "34.010€"
      },
      {
        "id": "s4",
        "name": "S4",
        "fuel": "Híbrid",
        "power": "341",
        "length": "4.770",
        "width": "1.847",
        "height": "1.404",
        "trunk": "420",
        "price": "46.070€"
      },
      {
        "id": "s4-avant",
        "name": "S4 Avant",
        "fuel": "Híbrid",
        "power": "341",
        "length": "N.D.",
        "width": "N.D.",
        "height": "1.433",
        "trunk": "420–1.435",
        "price": "46.070€"
      },
      {
        "id": "s6-avant-e-tron",
        "name": "S6 Avant e-tron",
        "fuel": "Elèctric",
        "power": "551",
        "length": "4.928",
        "width": "1.923",
        "height": "1.493",
        "trunk": "502–1.422",
        "price": "66.500€"
      },
      {
        "id": "s6-sportback-e-tron",
        "name": "S6 Sportback e-tron",
        "fuel": "Elèctric",
        "power": "551",
        "length": "4.928",
        "width": "1.923",
        "height": "1.455",
        "trunk": "502–1.330",
        "price": "66.500€"
      },
      {
        "id": "s7-sportback",
        "name": "S7 Sportback",
        "fuel": "Híbrid",
        "power": "344",
        "length": "4.979",
        "width": "1.908",
        "height": "1.417",
        "trunk": "525–1.380",
        "price": "71.150€"
      },
      {
        "id": "s8",
        "name": "S8",
        "fuel": "Híbrid",
        "power": "571",
        "length": "5.190",
        "width": "2.130",
        "height": "1.614",
        "trunk": "505",
        "price": "115.940€"
      },
      {
        "id": "sq2",
        "name": "SQ2",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.216",
        "width": "1.802",
        "height": "1.524",
        "trunk": "355–1.000",
        "price": "30.640€"
      },
      {
        "id": "sq5-sportback",
        "name": "SQ5 Sportback",
        "fuel": "Híbrid",
        "power": "367",
        "length": "4.717",
        "width": "1.900",
        "height": "1.619",
        "trunk": "470–1.388",
        "price": "61.600€"
      },
      {
        "id": "sq5-suv",
        "name": "SQ5 SUV",
        "fuel": "Híbrid",
        "power": "367",
        "length": "4.717",
        "width": "1.900",
        "height": "1.625",
        "trunk": "475–1.446",
        "price": "61.600€"
      },
      {
        "id": "sq6-e-tron",
        "name": "SQ6 e-tron",
        "fuel": "Elèctric",
        "power": "490",
        "length": "4.771",
        "width": "1.939",
        "height": "1.648",
        "trunk": "514–1.517",
        "price": "76.420€"
      },
      {
        "id": "sq8",
        "name": "SQ8",
        "fuel": "Gasolina",
        "power": "507",
        "length": "5.006",
        "width": "1.995",
        "height": "N.D.",
        "trunk": "605–1.755",
        "price": "82.970€"
      },
      {
        "id": "sq8-e-tron-sportback",
        "name": "SQ8 e-tron Sportback",
        "fuel": "Elèctric",
        "power": "503",
        "length": "4.915",
        "width": "1.976",
        "height": "1.617",
        "trunk": "528–1.567",
        "price": "84.610€"
      },
      {
        "id": "tt-coupe",
        "name": "TT Coupé",
        "fuel": "Gasolina",
        "power": "245 / 400",
        "length": "4.201",
        "width": "1.832",
        "height": "1.344",
        "trunk": "305",
        "price": "49.460€"
      },
      {
        "id": "tt-roadster",
        "name": "TT Roadster",
        "fuel": "Gasolina",
        "power": "245",
        "length": "4.191",
        "width": "1.832",
        "height": "1.355",
        "trunk": "N.D.",
        "price": "49.460€"
      },
      {
        "id": "tt-rs-coupe",
        "name": "TT RS Coupé",
        "fuel": "Gasolina",
        "power": "400",
        "length": "4.201",
        "width": "1.832",
        "height": "1.344",
        "trunk": "305–712",
        "price": "49.460€"
      },
      {
        "id": "tt-rs-roadster",
        "name": "TT RS Roadster",
        "fuel": "Gasolina",
        "power": "400",
        "length": "4.201",
        "width": "1.832",
        "height": "1.345",
        "trunk": "N.D.",
        "price": "49.460€"
      },
      {
        "id": "tts-coupe",
        "name": "TTS Coupé",
        "fuel": "Gasolina",
        "power": "320",
        "length": "4.199",
        "width": "1.832",
        "height": "1.366",
        "trunk": "305–712",
        "price": "49.460€"
      },
      {
        "id": "tts-roadster",
        "name": "TTS Roadster",
        "fuel": "Gasolina",
        "power": "320",
        "length": "4.199",
        "width": "1.832",
        "height": "1.345",
        "trunk": "N.D.",
        "price": "49.460€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "100-coupe",
        "name": "100 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1969–1976"
      },
      {
        "id": "100-200",
        "name": "100 / 200",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1968–1994"
      },
      {
        "id": "100-200-avant",
        "name": "100 / 200 Avant",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1983–1994"
      },
      {
        "id": "80-avant-rs2",
        "name": "80 Avant RS2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1996"
      },
      {
        "id": "80-avant-s2",
        "name": "80 Avant S2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "80-s2",
        "name": "80 S2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "80-90",
        "name": "80 / 90",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1984–1995"
      },
      {
        "id": "80-90-avant",
        "name": "80 / 90 Avant",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1995"
      },
      {
        "id": "90",
        "name": "90",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1987–1991"
      },
      {
        "id": "a1-quattro",
        "name": "A1 Quattro",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2013"
      },
      {
        "id": "a2",
        "name": "A2",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2005"
      },
      {
        "id": "a3",
        "name": "A3",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1996–2017"
      },
      {
        "id": "a3-cabriolet",
        "name": "A3 Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2008–2020"
      },
      {
        "id": "a4-cabriolet",
        "name": "A4 Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2008"
      },
      {
        "id": "a4-dtm-edition",
        "name": "A4 DTM Edition",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2007"
      },
      {
        "id": "a5-cabriolet",
        "name": "A5 Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2017"
      },
      {
        "id": "a8-d2",
        "name": "A8 (D2)",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2002"
      },
      {
        "id": "cabriolet",
        "name": "Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–2000"
      },
      {
        "id": "coupe",
        "name": "Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1981–1996"
      },
      {
        "id": "coupe-s2",
        "name": "Coupe S2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1996"
      },
      {
        "id": "quattro",
        "name": "Quattro",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1980–1991"
      },
      {
        "id": "r8-gt-spyder",
        "name": "R8 GT Spyder",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2013"
      },
      {
        "id": "rs-4",
        "name": "RS 4",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2008"
      },
      {
        "id": "rs-4-cabriolet",
        "name": "RS 4 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2009"
      },
      {
        "id": "rs-q3",
        "name": "RS Q3",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2015"
      },
      {
        "id": "rs5-cabriolet",
        "name": "RS5 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2015"
      },
      {
        "id": "rs6",
        "name": "RS6",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2010"
      },
      {
        "id": "s1",
        "name": "S1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "s1-sportback",
        "name": "S1 Sportback",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "s3",
        "name": "S3",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1999–2020"
      },
      {
        "id": "s3-cabriolet",
        "name": "S3 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2020"
      },
      {
        "id": "s4-cabriolet",
        "name": "S4 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2008"
      },
      {
        "id": "s8-plus",
        "name": "S8 Plus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2019"
      },
      {
        "id": "typ-r",
        "name": "Typ R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1927–1932"
      },
      {
        "id": "v8",
        "name": "V8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1994"
      }
    ]
  },
  {
    "id": "bentley",
    "name": "Bentley",
    "logo": "🅱️",
    "description": "Be Extraordinary",
    "models": [
      {
        "id": "bentayga",
        "name": "Bentayga",
        "fuel": "Gasolina",
        "power": "550",
        "length": "5.125",
        "width": "2.222",
        "height": "1.742",
        "trunk": "484",
        "price": "217.200€"
      },
      {
        "id": "continental-gt",
        "name": "Continental GT",
        "fuel": "Gasolina",
        "power": "550",
        "length": "4.850",
        "width": "2.187",
        "height": "1.405",
        "trunk": "358",
        "price": "226.700€"
      },
      {
        "id": "continental-gt-convertible",
        "name": "Continental GT Convertible",
        "fuel": "Gasolina",
        "power": "550",
        "length": "4.850",
        "width": "2.187",
        "height": "1.399",
        "trunk": "235",
        "price": "226.700€"
      },
      {
        "id": "flying-spur",
        "name": "Flying Spur",
        "fuel": "Gasolina",
        "power": "550",
        "length": "5.316",
        "width": "2.220",
        "height": "1.483",
        "trunk": "420",
        "price": "220.322€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "arnage",
        "name": "Arnage",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1999–2009"
      },
      {
        "id": "azure",
        "name": "Azure",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1995–2011"
      },
      {
        "id": "brooklands",
        "name": "Brooklands",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–2011"
      },
      {
        "id": "continental",
        "name": "Continental",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1952–2013"
      },
      {
        "id": "continental-flying-spur",
        "name": "Continental Flying Spur",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2013"
      },
      {
        "id": "mk-vi-saloon",
        "name": "Mk VI Saloon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1946–1953"
      },
      {
        "id": "mulsanne",
        "name": "Mulsanne",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2020"
      },
      {
        "id": "s1",
        "name": "S1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1955–1959"
      },
      {
        "id": "state-limousine",
        "name": "State Limousine",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2002"
      },
      {
        "id": "t1",
        "name": "T1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1976"
      },
      {
        "id": "t2",
        "name": "T2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1977–1980"
      }
    ]
  },
  {
    "id": "bmw",
    "name": "BMW",
    "logo": "🔵",
    "description": "The Ultimate Driving Machine",
    "models": [
      {
        "id": "i4",
        "name": "i4",
        "fuel": "Elèctric",
        "power": "286 / 340 / 544",
        "length": "4.783",
        "width": "1.852",
        "height": "1.448",
        "trunk": "470–1.290",
        "price": "57.350€"
      },
      {
        "id": "i5",
        "name": "i5",
        "fuel": "Elèctric",
        "power": "340 / 601",
        "length": "5.060",
        "width": "1.900",
        "height": "1.505",
        "trunk": "490",
        "price": "76.750€"
      },
      {
        "id": "i5-touring",
        "name": "i5 Touring",
        "fuel": "Elèctric",
        "power": "601",
        "length": "5.060",
        "width": "1.900",
        "height": "1.505",
        "trunk": "570–1.700",
        "price": "76.750€"
      },
      {
        "id": "i7",
        "name": "i7",
        "fuel": "Elèctric",
        "power": "544",
        "length": "5.391",
        "width": "1.950",
        "height": "1.544",
        "trunk": "500",
        "price": "139.350€"
      },
      {
        "id": "ix",
        "name": "iX",
        "fuel": "Elèctric",
        "power": "326 / 523 / 619",
        "length": "4.953",
        "width": "1.967",
        "height": "1.696",
        "trunk": "500–1.750",
        "price": "87.150€"
      },
      {
        "id": "ix1",
        "name": "iX1",
        "fuel": "Elèctric",
        "power": "204 / 313",
        "length": "4.500",
        "width": "1.845",
        "height": "1.616",
        "trunk": "490–1.495",
        "price": "48.900€"
      },
      {
        "id": "ix2",
        "name": "iX2",
        "fuel": "Elèctric",
        "power": "313",
        "length": "4.554",
        "width": "1.845",
        "height": "1.560",
        "trunk": "525–1.400",
        "price": "58.000€"
      },
      {
        "id": "ix3",
        "name": "ix3",
        "fuel": "Elèctric",
        "power": "469",
        "length": "4.782",
        "width": "1.895",
        "height": "1.635",
        "trunk": "520–1.750",
        "price": "69.900€"
      },
      {
        "id": "m2",
        "name": "M2",
        "fuel": "Gasolina",
        "power": "460",
        "length": "4.580",
        "width": "1.887",
        "height": "1.403",
        "trunk": "390",
        "price": "36.000€"
      },
      {
        "id": "m4-cabrio",
        "name": "M4 Cabrio",
        "fuel": "Gasolina",
        "power": "510",
        "length": "4.794",
        "width": "1.887",
        "height": "1.395",
        "trunk": "300–385",
        "price": "53.500€"
      },
      {
        "id": "m4-coupe",
        "name": "M4 Coupé",
        "fuel": "Gasolina",
        "power": "510",
        "length": "4.794",
        "width": "1.887",
        "height": "1.393",
        "trunk": "440",
        "price": "53.500€"
      },
      {
        "id": "m5-berlina",
        "name": "M5 Berlina",
        "fuel": "PHEV",
        "power": "727",
        "length": "5.096",
        "width": "1.970",
        "height": "1.510",
        "trunk": "466",
        "price": "60.050€"
      },
      {
        "id": "m5-touring",
        "name": "M5 Touring",
        "fuel": "PHEV",
        "power": "727",
        "length": "5.096",
        "width": "1.970",
        "height": "1.516",
        "trunk": "500–1.630",
        "price": "60.050€"
      },
      {
        "id": "m8-cabrio",
        "name": "M8 Cabrio",
        "fuel": "Gasolina",
        "power": "625",
        "length": "4.867",
        "width": "1.907",
        "height": "1.353",
        "trunk": "350",
        "price": "103.600€"
      },
      {
        "id": "m8-gran-coupe",
        "name": "M8 Gran Coupé",
        "fuel": "Gasolina",
        "power": "600",
        "length": "5.098",
        "width": "1.943",
        "height": "1.420",
        "trunk": "440",
        "price": "103.600€"
      },
      {
        "id": "serie-1",
        "name": "Serie 1",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.361",
        "width": "1.800",
        "height": "1.459",
        "trunk": "380–1.200",
        "price": "40.500€"
      },
      {
        "id": "serie-1",
        "name": "Serie 1",
        "fuel": "Híbrid",
        "power": "170",
        "length": "4.361",
        "width": "1.800",
        "height": "1.459",
        "trunk": "380–1.200",
        "price": "40.500€"
      },
      {
        "id": "serie-2-active-tourer",
        "name": "Serie 2 Active Tourer",
        "fuel": "Dièsel",
        "power": "150",
        "length": "4.386",
        "width": "1.824",
        "height": "1.576",
        "trunk": "470–1.455",
        "price": "36.000€"
      },
      {
        "id": "serie-2-active-tourer",
        "name": "Serie 2 Active Tourer",
        "fuel": "Gasolina",
        "power": "136",
        "length": "4.386",
        "width": "1.824",
        "height": "1.576",
        "trunk": "470–1.455",
        "price": "36.000€"
      },
      {
        "id": "serie-2-active-tourer",
        "name": "Serie 2 Active Tourer",
        "fuel": "Híbrid",
        "power": "170",
        "length": "4.386",
        "width": "1.824",
        "height": "1.576",
        "trunk": "415–1.405",
        "price": "36.000€"
      },
      {
        "id": "serie-2-active-tourer",
        "name": "Serie 2 Active Tourer",
        "fuel": "PHEV",
        "power": "245 / 326",
        "length": "4.386",
        "width": "1.824",
        "height": "1.576",
        "trunk": "406–1.370",
        "price": "36.000€"
      },
      {
        "id": "serie-2-coupe",
        "name": "Serie 2 Coupé",
        "fuel": "Gasolina",
        "power": "156 / 184 / 245 / 374",
        "length": "4.537",
        "width": "1.838",
        "height": "1.390",
        "trunk": "390",
        "price": "36.000€"
      },
      {
        "id": "serie-2-coupe",
        "name": "Serie 2 Coupé",
        "fuel": "Híbrid",
        "power": "190",
        "length": "4.537",
        "width": "1.838",
        "height": "1.390",
        "trunk": "N.D.",
        "price": "36.000€"
      },
      {
        "id": "serie-2-gran-coupe",
        "name": "Serie 2 Gran Coupé",
        "fuel": "Combustió",
        "power": "136",
        "length": "4.526",
        "width": "1.800",
        "height": "1.420",
        "trunk": "430",
        "price": "36.000€"
      },
      {
        "id": "serie-2-gran-coupe",
        "name": "Serie 2 Gran Coupé",
        "fuel": "Dièsel",
        "power": "116 / 150 / 190",
        "length": "4.526",
        "width": "1.800",
        "height": "1.420",
        "trunk": "430",
        "price": "36.000€"
      },
      {
        "id": "serie-2-gran-coupe",
        "name": "Serie 2 Gran Coupé",
        "fuel": "Gasolina",
        "power": "136 / 178 / 306",
        "length": "4.526",
        "width": "1.800",
        "height": "1.420",
        "trunk": "430",
        "price": "36.000€"
      },
      {
        "id": "serie-3-berlina",
        "name": "Serie 3 Berlina",
        "fuel": "Gasolina",
        "power": "510 / 551",
        "length": "4.794",
        "width": "1.903",
        "height": "1.434",
        "trunk": "480",
        "price": "45.600€"
      },
      {
        "id": "serie-3-berlina",
        "name": "Serie 3 Berlina",
        "fuel": "Híbrid",
        "power": "150 / 184 / 190 / 245 / 340 / 374",
        "length": "4.713",
        "width": "1.827",
        "height": "1.444",
        "trunk": "480",
        "price": "45.600€"
      },
      {
        "id": "serie-3-berlina",
        "name": "Serie 3 Berlina",
        "fuel": "PHEV",
        "power": "204 / 292",
        "length": "4.713",
        "width": "1.827",
        "height": "1.444",
        "trunk": "375",
        "price": "45.600€"
      },
      {
        "id": "serie-3-touring",
        "name": "Serie 3 Touring",
        "fuel": "Gasolina",
        "power": "184 / 245 / 510",
        "length": "4.794",
        "width": "1.903",
        "height": "1.436",
        "trunk": "500–1.510",
        "price": "45.600€"
      },
      {
        "id": "serie-3-touring",
        "name": "Serie 3 Touring",
        "fuel": "Híbrid",
        "power": "150 / 190 / 340 / 374",
        "length": "4.713",
        "width": "1.827",
        "height": "1.445",
        "trunk": "500–1.500",
        "price": "45.600€"
      },
      {
        "id": "serie-3-touring",
        "name": "Serie 3 Touring",
        "fuel": "PHEV",
        "power": "204 / 292",
        "length": "4.709",
        "width": "1.827",
        "height": "1.442",
        "trunk": "410–1.420",
        "price": "45.600€"
      },
      {
        "id": "serie-4-cabrio",
        "name": "Serie 4 Cabrio",
        "fuel": "Gasolina",
        "power": "184 / 258",
        "length": "4.768",
        "width": "1.852",
        "height": "1.384",
        "trunk": "385",
        "price": "53.500€"
      },
      {
        "id": "serie-4-cabrio",
        "name": "Serie 4 Cabrio",
        "fuel": "Híbrid",
        "power": "190 / 340 / 374",
        "length": "4.770",
        "width": "1.852",
        "height": "1.394",
        "trunk": "385",
        "price": "53.500€"
      },
      {
        "id": "serie-4-coupe",
        "name": "Serie 4 Coupé",
        "fuel": "Gasolina",
        "power": "184 / 258",
        "length": "4.768",
        "width": "1.852",
        "height": "1.383",
        "trunk": "440",
        "price": "53.500€"
      },
      {
        "id": "serie-4-coupe",
        "name": "Serie 4 Coupé",
        "fuel": "Híbrid",
        "power": "190 / 286 / 340 / 374",
        "length": "4.770",
        "width": "1.852",
        "height": "1.393",
        "trunk": "440",
        "price": "53.500€"
      },
      {
        "id": "serie-4-gran-coupe",
        "name": "Serie 4 Gran Coupé",
        "fuel": "Gasolina",
        "power": "184 / 245",
        "length": "4.783",
        "width": "1.852",
        "height": "1.442",
        "trunk": "470–1.290",
        "price": "53.500€"
      },
      {
        "id": "serie-4-gran-coupe",
        "name": "Serie 4 Gran Coupé",
        "fuel": "Híbrid",
        "power": "190 / 286 / 374",
        "length": "4.783",
        "width": "1.852",
        "height": "1.442",
        "trunk": "470–1.290",
        "price": "53.500€"
      },
      {
        "id": "serie-5-berlina",
        "name": "Serie 5 Berlina",
        "fuel": "Híbrid",
        "power": "197 / 208",
        "length": "5.060",
        "width": "1.900",
        "height": "1.515",
        "trunk": "520",
        "price": "60.050€"
      },
      {
        "id": "serie-5-berlina",
        "name": "Serie 5 Berlina",
        "fuel": "PHEV",
        "power": "299 / 489",
        "length": "5.060",
        "width": "1.900",
        "height": "1.515",
        "trunk": "520",
        "price": "60.050€"
      },
      {
        "id": "serie-5-touring",
        "name": "Serie 5 Touring",
        "fuel": "Híbrid",
        "power": "197 / 303",
        "length": "5.060",
        "width": "1.900",
        "height": "1.515",
        "trunk": "570–1.700",
        "price": "60.050€"
      },
      {
        "id": "serie-5-touring",
        "name": "Serie 5 Touring",
        "fuel": "PHEV",
        "power": "299",
        "length": "5.060",
        "width": "1.900",
        "height": "1.515",
        "trunk": "570–1.700",
        "price": "60.050€"
      },
      {
        "id": "serie-6-gran-turismo",
        "name": "Serie 6 Gran Turismo",
        "fuel": "Híbrid",
        "power": "190 / 258 / 333 / 340",
        "length": "5.091",
        "width": "1.902",
        "height": "1.538",
        "trunk": "600–1.800",
        "price": "66.550€"
      },
      {
        "id": "serie-7-berlina",
        "name": "Serie 7 berlina",
        "fuel": "Gasolina",
        "power": "530",
        "length": "5.120",
        "width": "1.902",
        "height": "1.467",
        "trunk": "515",
        "price": "101.400€"
      },
      {
        "id": "serie-7-berlina",
        "name": "Serie 7 berlina",
        "fuel": "Híbrid",
        "power": "286 / 340",
        "length": "5.120",
        "width": "1.902",
        "height": "1.467",
        "trunk": "515",
        "price": "101.400€"
      },
      {
        "id": "serie-7-berlina",
        "name": "Serie 7 berlina",
        "fuel": "PHEV",
        "power": "394",
        "length": "5.120",
        "width": "1.902",
        "height": "1.467",
        "trunk": "420",
        "price": "101.400€"
      },
      {
        "id": "serie-8-cabrio",
        "name": "Serie 8 Cabrio",
        "fuel": "Gasolina",
        "power": "530",
        "length": "4.851",
        "width": "1.902",
        "height": "1.345",
        "trunk": "350",
        "price": "103.600€"
      },
      {
        "id": "serie-8-coupe",
        "name": "Serie 8 Coupé",
        "fuel": "Gasolina",
        "power": "530 / 625",
        "length": "4.867",
        "width": "1.907",
        "height": "1.362",
        "trunk": "420",
        "price": "103.600€"
      },
      {
        "id": "serie-8-gran-coupe",
        "name": "Serie 8 Gran Coupé",
        "fuel": "Gasolina",
        "power": "333 / 530",
        "length": "5.074",
        "width": "1.932",
        "height": "1.401",
        "trunk": "440",
        "price": "103.600€"
      },
      {
        "id": "x1",
        "name": "X1",
        "fuel": "Dièsel",
        "power": "150",
        "length": "4.500",
        "width": "1.845",
        "height": "1.642",
        "trunk": "540–1.600",
        "price": "44.000€"
      },
      {
        "id": "x1",
        "name": "X1",
        "fuel": "Gasolina",
        "power": "136 / 300",
        "length": "4.500",
        "width": "1.845",
        "height": "1.642",
        "trunk": "540–1.600",
        "price": "44.000€"
      },
      {
        "id": "x1",
        "name": "X1",
        "fuel": "Híbrid",
        "power": "163 / 170",
        "length": "4.500",
        "width": "1.845",
        "height": "1.642",
        "trunk": "500–1.545",
        "price": "44.000€"
      },
      {
        "id": "x1",
        "name": "X1",
        "fuel": "PHEV",
        "power": "245 / 326",
        "length": "4.500",
        "width": "1.845",
        "height": "1.642",
        "trunk": "490–1.495",
        "price": "44.000€"
      },
      {
        "id": "x2",
        "name": "X2",
        "fuel": "Dièsel",
        "power": "150",
        "length": "4.554",
        "width": "1.845",
        "height": "1.690",
        "trunk": "560–1.470",
        "price": "45.600€"
      },
      {
        "id": "x2",
        "name": "X2",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.567",
        "width": "1.845",
        "height": "1.575",
        "trunk": "560–1.470",
        "price": "45.600€"
      },
      {
        "id": "x2",
        "name": "X2",
        "fuel": "Híbrid",
        "power": "170",
        "length": "4.554",
        "width": "1.845",
        "height": "1.590",
        "trunk": "515–1.400",
        "price": "45.600€"
      },
      {
        "id": "x3",
        "name": "X3",
        "fuel": "Híbrid",
        "power": "197 / 208 / 398",
        "length": "4.755",
        "width": "1.920",
        "height": "1.660",
        "trunk": "570–1.700",
        "price": "63.100€"
      },
      {
        "id": "x3",
        "name": "X3",
        "fuel": "PHEV",
        "power": "299",
        "length": "4.755",
        "width": "1.920",
        "height": "1.660",
        "trunk": "460–1.600",
        "price": "63.100€"
      },
      {
        "id": "x4",
        "name": "X4",
        "fuel": "Híbrid",
        "power": "185 / 190 / 245 / 286 / 340 / 360",
        "length": "4.752",
        "width": "1.938",
        "height": "1.621",
        "trunk": "525–1.430",
        "price": "57.400€"
      },
      {
        "id": "x4-m",
        "name": "X4 M",
        "fuel": "Gasolina",
        "power": "510",
        "length": "4.754",
        "width": "1.927",
        "height": "1.620",
        "trunk": "525–1.430",
        "price": "57.400€"
      },
      {
        "id": "x5",
        "name": "X5",
        "fuel": "Dièsel",
        "power": "231",
        "length": "4.922",
        "width": "2.004",
        "height": "1.745",
        "trunk": "650–1.870",
        "price": "71.900€"
      },
      {
        "id": "x5",
        "name": "X5",
        "fuel": "Gasolina",
        "power": "530",
        "length": "4.922",
        "width": "2.004",
        "height": "1.745",
        "trunk": "650–1.870",
        "price": "71.900€"
      },
      {
        "id": "x5",
        "name": "X5",
        "fuel": "Híbrid",
        "power": "286 / 333",
        "length": "4.922",
        "width": "2.004",
        "height": "1.745",
        "trunk": "650–1.870",
        "price": "71.900€"
      },
      {
        "id": "x5",
        "name": "X5",
        "fuel": "PHEV",
        "power": "394",
        "length": "4.922",
        "width": "2.004",
        "height": "1.745",
        "trunk": "500–1.720",
        "price": "71.900€"
      },
      {
        "id": "x5-m",
        "name": "X5 M",
        "fuel": "Gasolina",
        "power": "600",
        "length": "4.938",
        "width": "2.015",
        "height": "1.747",
        "trunk": "650–1.870",
        "price": "71.900€"
      },
      {
        "id": "x6",
        "name": "X6",
        "fuel": "Dièsel",
        "power": "530",
        "length": "4.935",
        "width": "2.004",
        "height": "1.696",
        "trunk": "580–1.530",
        "price": "84.900€"
      },
      {
        "id": "x6",
        "name": "X6",
        "fuel": "Gasolina",
        "power": "600",
        "length": "4.941",
        "width": "2.019",
        "height": "1.692",
        "trunk": "580–1.530",
        "price": "84.900€"
      },
      {
        "id": "x6",
        "name": "X6",
        "fuel": "Híbrid",
        "power": "286 / 333 / 340",
        "length": "4.935",
        "width": "2.004",
        "height": "1.696",
        "trunk": "580–1.530",
        "price": "84.900€"
      },
      {
        "id": "x7",
        "name": "X7",
        "fuel": "Gasolina",
        "power": "530",
        "length": "5.151",
        "width": "2.000",
        "height": "1.805",
        "trunk": "750–2.120",
        "price": "104.600€"
      },
      {
        "id": "x7",
        "name": "X7",
        "fuel": "Híbrid",
        "power": "333 / 340",
        "length": "5.151",
        "width": "2.000",
        "height": "1.805",
        "trunk": "750–2.120",
        "price": "104.600€"
      },
      {
        "id": "z4",
        "name": "Z4",
        "fuel": "Gasolina",
        "power": "197 / 258 / 340",
        "length": "4.324",
        "width": "1.864",
        "height": "1.304",
        "trunk": "281",
        "price": "51.300€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "1-series-3-doors",
        "name": "1 Series 3 doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2007–2019"
      },
      {
        "id": "1-series-cabriolet",
        "name": "1 Series Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2013"
      },
      {
        "id": "1-series-coupe",
        "name": "1 Series Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2013"
      },
      {
        "id": "1-series-m-coupe",
        "name": "1 Series M Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2012"
      },
      {
        "id": "1-series-sedan",
        "name": "1 Series Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2023"
      },
      {
        "id": "1500-1600",
        "name": "1500 / 1600",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1962–1975"
      },
      {
        "id": "2-series-convertible",
        "name": "2 Series Convertible",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2021"
      },
      {
        "id": "2-series-gran-tourer",
        "name": "2 Series Gran Tourer",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2015–2021"
      },
      {
        "id": "2000-cs",
        "name": "2000 CS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1969"
      },
      {
        "id": "2002",
        "name": "2002",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1968–1975"
      },
      {
        "id": "2800-cs",
        "name": "2800 CS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1968–1971"
      },
      {
        "id": "3-series-cabriolet",
        "name": "3 Series Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1986–2013"
      },
      {
        "id": "3-series-compact",
        "name": "3 Series Compact",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2005"
      },
      {
        "id": "3-series-coupe",
        "name": "3 Series Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1975–2013"
      },
      {
        "id": "3-series-gran-turismo",
        "name": "3 Series Gran Turismo",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2020"
      },
      {
        "id": "30-csi",
        "name": "3.0 CSi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1975"
      },
      {
        "id": "30-csl",
        "name": "3.0 CSL",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1975"
      },
      {
        "id": "315-ps",
        "name": "3/15 PS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1929–1932"
      },
      {
        "id": "320-ps",
        "name": "3/20 PS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1932–1934"
      },
      {
        "id": "303",
        "name": "303",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1933–1934"
      },
      {
        "id": "3200",
        "name": "3200",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1962–1965"
      },
      {
        "id": "326",
        "name": "326",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1936–1941"
      },
      {
        "id": "327",
        "name": "327",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1938–1941"
      },
      {
        "id": "328",
        "name": "328",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1936–1939"
      },
      {
        "id": "335",
        "name": "335",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1939–1941"
      },
      {
        "id": "5-series-gran-turismo",
        "name": "5 Series Gran Turismo",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2017"
      },
      {
        "id": "501-502",
        "name": "501 / 502",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1952–1964"
      },
      {
        "id": "502-coupe",
        "name": "502 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1954–1955"
      },
      {
        "id": "503",
        "name": "503",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1956–1959"
      },
      {
        "id": "507",
        "name": "507",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1955–1959"
      },
      {
        "id": "6-series-convertible",
        "name": "6 Series Convertible",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2004–2018"
      },
      {
        "id": "6-series-coupe",
        "name": "6 Series Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1976–2018"
      },
      {
        "id": "6-series-gran-coupe",
        "name": "6 Series Gran Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2018"
      },
      {
        "id": "8-series",
        "name": "8 Series",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1999"
      },
      {
        "id": "8-series-gran-coupe",
        "name": "8 Series Gran Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2022"
      },
      {
        "id": "i3",
        "name": "i3",
        "fuel": "Elèctric / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2013–2022"
      },
      {
        "id": "i8",
        "name": "i8",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2020"
      },
      {
        "id": "i8-roadster",
        "name": "i8 Roadster",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2020"
      },
      {
        "id": "isetta",
        "name": "Isetta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1955–1962"
      },
      {
        "id": "m1",
        "name": "M1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1978–1981"
      },
      {
        "id": "m3-cabriolet",
        "name": "M3 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1994–2013"
      },
      {
        "id": "m3-coupe",
        "name": "M3 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1986–2013"
      },
      {
        "id": "m4-gts",
        "name": "M4 GTS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2016"
      },
      {
        "id": "m6-cabrio",
        "name": "M6 Cabrio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2006–2018"
      },
      {
        "id": "m6-coupe",
        "name": "M6 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1984–2018"
      },
      {
        "id": "m6-gran-coupe",
        "name": "M6 Gran Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2018"
      },
      {
        "id": "z1",
        "name": "Z1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1991"
      },
      {
        "id": "z3-coupe",
        "name": "Z3 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2002"
      },
      {
        "id": "z3-roadster",
        "name": "Z3 Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2003"
      },
      {
        "id": "z4-coupe",
        "name": "Z4 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2009"
      },
      {
        "id": "z8",
        "name": "Z8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2003"
      }
    ]
  },
  {
    "id": "bugatti",
    "name": "Bugatti",
    "logo": "🏁",
    "description": "Performance et Luxe",
    "models": [
      {
        "id": "chiron",
        "name": "Chiron",
        "fuel": "Gasolina",
        "power": "1500",
        "length": "4.544",
        "width": "2.038",
        "height": "1.212",
        "trunk": "N.D.",
        "price": "2.496.409€"
      },
      {
        "id": "chiron-super-sport",
        "name": "Chiron Super Sport",
        "fuel": "Gasolina",
        "power": "1600",
        "length": "4.733",
        "width": "2.183",
        "height": "1.212",
        "trunk": "N.D.",
        "price": "2.496.409€"
      },
      {
        "id": "divo",
        "name": "Divo",
        "fuel": "Gasolina",
        "power": "1500",
        "length": "4.641",
        "width": "2.018",
        "height": "1.212",
        "trunk": "N.D.",
        "price": "5.000.000€"
      }
    ]
  },
  {
    "id": "byd",
    "name": "BYD",
    "logo": "⚡",
    "description": "Build Your Dreams",
    "models": [
      {
        "id": "atto-2",
        "name": "ATTO 2",
        "fuel": "Elèctric",
        "power": "177 / 204",
        "length": "4.310",
        "width": "1.570",
        "height": "1.675",
        "trunk": "400–1.340",
        "price": "28.200€"
      },
      {
        "id": "atto-2-dm-i",
        "name": "ATTO 2 DM-i",
        "fuel": "PHEV",
        "power": "166 / 212",
        "length": "4.330",
        "width": "1.830",
        "height": "1.675",
        "trunk": "425–1.335",
        "price": "28.200€"
      },
      {
        "id": "atto-3-evo",
        "name": "Atto 3 EVO",
        "fuel": "Elèctric",
        "power": "313 / 449",
        "length": "4.455",
        "width": "1.875",
        "height": "1.615",
        "trunk": "490–1.360",
        "price": "41.690€"
      },
      {
        "id": "dolphin",
        "name": "Dolphin",
        "fuel": "Elèctric",
        "power": "95 / 177 / 204",
        "length": "4.290",
        "width": "1.770",
        "height": "1.570",
        "trunk": "345–1.310",
        "price": "29.990€"
      },
      {
        "id": "dolphin-g-dm-i",
        "name": "Dolphin G DM-i",
        "fuel": "PHEV",
        "power": "175 / 212",
        "length": "4.160",
        "width": "1.825",
        "height": "1.575",
        "trunk": "425–1.225",
        "price": "25.200€"
      },
      {
        "id": "dolphin-surf",
        "name": "Dolphin Surf",
        "fuel": "Elèctric",
        "power": "88 / 156",
        "length": "3.990",
        "width": "1.970",
        "height": "1.590",
        "trunk": "308–1.037",
        "price": "19.990€"
      },
      {
        "id": "han",
        "name": "HAN",
        "fuel": "Elèctric",
        "power": "517",
        "length": "4.995",
        "width": "1.910",
        "height": "1.495",
        "trunk": "410",
        "price": "N.D.€"
      },
      {
        "id": "seal",
        "name": "Seal",
        "fuel": "Elèctric",
        "power": "313 / 530",
        "length": "4.800",
        "width": "1.875",
        "height": "1.460",
        "trunk": "400",
        "price": "48.990€"
      },
      {
        "id": "seal-6-dm-i",
        "name": "Seal 6 DM-i",
        "fuel": "PHEV",
        "power": "184 / 212",
        "length": "4.480",
        "width": "1.875",
        "height": "1.495",
        "trunk": "491–1.370",
        "price": "37.000€"
      },
      {
        "id": "seal-6-dm-i-touring",
        "name": "Seal 6 DM-i Touring",
        "fuel": "PHEV",
        "power": "197 / 212",
        "length": "4.840",
        "width": "1.875",
        "height": "1.505",
        "trunk": "500–1.535",
        "price": "37.000€"
      },
      {
        "id": "seal-u",
        "name": "Seal U",
        "fuel": "Elèctric",
        "power": "218",
        "length": "4.785",
        "width": "1.890",
        "height": "1.668",
        "trunk": "552–1.440",
        "price": "38.500€"
      },
      {
        "id": "seal-u-dm-i",
        "name": "SEAL U DM-i",
        "fuel": "PHEV",
        "power": "218 / 324",
        "length": "4.775",
        "width": "1.890",
        "height": "1.670",
        "trunk": "425–1.440",
        "price": "38.500€"
      },
      {
        "id": "sealion-7",
        "name": "Sealion 7",
        "fuel": "Elèctric",
        "power": "313 / 530",
        "length": "4.380",
        "width": "1.925",
        "height": "1.620",
        "trunk": "520–1.789",
        "price": "47.990€"
      },
      {
        "id": "tang",
        "name": "TANG",
        "fuel": "Elèctric",
        "power": "517",
        "length": "4.970",
        "width": "1.955",
        "height": "1.745",
        "trunk": "235–1.655",
        "price": "72.000€"
      }
    ]
  },
  {
    "id": "changan-deepal",
    "name": "Changan Deepal",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "s05",
        "name": "S05",
        "fuel": "Elèctric",
        "power": "272",
        "length": "4.598",
        "width": "1.900",
        "height": "1.600",
        "trunk": "492",
        "price": "33.990€"
      },
      {
        "id": "s05",
        "name": "S05",
        "fuel": "PHEV",
        "power": "258",
        "length": "4.598",
        "width": "1.900",
        "height": "1.600",
        "trunk": "552–1.310",
        "price": "33.990€"
      },
      {
        "id": "s07",
        "name": "S07",
        "fuel": "Elèctric",
        "power": "218",
        "length": "4.750",
        "width": "1.930",
        "height": "1.625",
        "trunk": "N.D.",
        "price": "44.990€"
      }
    ]
  },
  {
    "id": "citroen",
    "name": "Citroën",
    "logo": "⚡",
    "description": "Inspired by You",
    "models": [
      {
        "id": "ami",
        "name": "Ami",
        "fuel": "Elèctric",
        "power": "8",
        "length": "2.410",
        "width": "1.390",
        "height": "1.520",
        "trunk": "N.D.",
        "price": "6.900€"
      },
      {
        "id": "c3",
        "name": "C3",
        "fuel": "Dièsel",
        "power": "100",
        "length": "3.996",
        "width": "1.749",
        "height": "1.490",
        "trunk": "300–922",
        "price": "12.649€"
      },
      {
        "id": "c3",
        "name": "C3",
        "fuel": "Gasolina",
        "power": "83 / 110",
        "length": "3.996",
        "width": "1.749",
        "height": "1.474",
        "trunk": "300–922",
        "price": "12.649€"
      },
      {
        "id": "c3-aircross",
        "name": "C3 Aircross",
        "fuel": "Gasolina",
        "power": "100",
        "length": "4.395",
        "width": "1.795",
        "height": "1.633",
        "trunk": "460–1.600",
        "price": "19.540€"
      },
      {
        "id": "c3-aircross",
        "name": "C3 Aircross",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.395",
        "width": "1.795",
        "height": "1.633",
        "trunk": "460–1.600",
        "price": "19.540€"
      },
      {
        "id": "c4",
        "name": "C4",
        "fuel": "Híbrid",
        "power": "100 / 136",
        "length": "4.350",
        "width": "1.800",
        "height": "1.525",
        "trunk": "380–1.250",
        "price": "23.450€"
      },
      {
        "id": "c4-x",
        "name": "C4 X",
        "fuel": "Dièsel",
        "power": "131",
        "length": "4.600",
        "width": "1.800",
        "height": "1.525",
        "trunk": "510",
        "price": "22.785€"
      },
      {
        "id": "c4-x",
        "name": "C4 X",
        "fuel": "Gasolina",
        "power": "102 / 131",
        "length": "4.600",
        "width": "1.800",
        "height": "1.525",
        "trunk": "510",
        "price": "22.785€"
      },
      {
        "id": "c5-aircross",
        "name": "C5 Aircross",
        "fuel": "PHEV",
        "power": "230",
        "length": "4.650",
        "width": "1.870",
        "height": "1.695",
        "trunk": "565–1.668",
        "price": "29.995€"
      },
      {
        "id": "c5-x",
        "name": "C5 X",
        "fuel": "Gasolina",
        "power": "130 / 180",
        "length": "4.805",
        "width": "1.815",
        "height": "1.485",
        "trunk": "545",
        "price": "34.400€"
      },
      {
        "id": "c5-x",
        "name": "C5 X",
        "fuel": "PHEV",
        "power": "225",
        "length": "4.805",
        "width": "1.815",
        "height": "1.485",
        "trunk": "545",
        "price": "34.400€"
      },
      {
        "id": "spacetourer",
        "name": "Spacetourer",
        "fuel": "Dièsel",
        "power": "120 / 140 / 180",
        "length": "4.959",
        "width": "1.920",
        "height": "1.899",
        "trunk": "1.556",
        "price": "34.206€"
      },
      {
        "id": "e-c3",
        "name": "ë-C3",
        "fuel": "Elèctric",
        "power": "113",
        "length": "4.015",
        "width": "1.755",
        "height": "1.567",
        "trunk": "310",
        "price": "12.649€"
      },
      {
        "id": "e-c3-aircross",
        "name": "ë-C3 Aircross",
        "fuel": "Elèctric",
        "power": "113",
        "length": "4.395",
        "width": "1.795",
        "height": "1.633",
        "trunk": "460–1.600",
        "price": "19.540€"
      },
      {
        "id": "e-c4",
        "name": "Ë-C4",
        "fuel": "Elèctric",
        "power": "136 / 156",
        "length": "4.360",
        "width": "1.800",
        "height": "1.525",
        "trunk": "380–1.250",
        "price": "35.405€"
      },
      {
        "id": "e-jumpy",
        "name": "Ë-Jumpy",
        "fuel": "Elèctric",
        "power": "136",
        "length": "4.959",
        "width": "1.920",
        "height": "1.940",
        "trunk": "N.D.",
        "price": "50.534€"
      },
      {
        "id": "e-spacetourer",
        "name": "ë-SpaceTourer",
        "fuel": "Elèctric",
        "power": "136",
        "length": "4.959",
        "width": "1.920",
        "height": "1.899",
        "trunk": "1.700",
        "price": "34.206€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "traction",
        "name": "Traction",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1934–1957"
      },
      {
        "id": "2cv",
        "name": "2CV",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1949–1990"
      },
      {
        "id": "ds",
        "name": "DS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1955–1976"
      },
      {
        "id": "sm",
        "name": "SM",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1970–1975"
      },
      {
        "id": "cx",
        "name": "CX",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1974–1989"
      },
      {
        "id": "cx-break",
        "name": "CX Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1976–1991"
      },
      {
        "id": "visa",
        "name": "Visa",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1978–1988"
      },
      {
        "id": "lna",
        "name": "LNA",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1978–1984"
      },
      {
        "id": "gsa",
        "name": "GSA",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1979–1986"
      },
      {
        "id": "dyane",
        "name": "Dyane",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1983"
      },
      {
        "id": "visa-decouvrable",
        "name": "Visa Decouvrable",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1985"
      },
      {
        "id": "axel",
        "name": "Axel",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1989"
      },
      {
        "id": "bx",
        "name": "BX",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1983–1993"
      },
      {
        "id": "bx-break",
        "name": "BX Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1985–1994"
      },
      {
        "id": "ax-3-doors",
        "name": "AX 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1986–1998"
      },
      {
        "id": "ax-5-doors",
        "name": "AX 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1988–1998"
      },
      {
        "id": "xm",
        "name": "XM",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1989–2000"
      },
      {
        "id": "xm-break",
        "name": "XM Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1992–2000"
      },
      {
        "id": "zx-5-doors",
        "name": "ZX 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1991–1997"
      },
      {
        "id": "zx-3-doors",
        "name": "ZX 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1992–1997"
      },
      {
        "id": "zx-break",
        "name": "ZX Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–1998"
      },
      {
        "id": "xantia",
        "name": "Xantia",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–2001"
      },
      {
        "id": "xantia-break",
        "name": "Xantia Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2001"
      },
      {
        "id": "evasion",
        "name": "Evasion",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2002"
      },
      {
        "id": "saxo-3-doors",
        "name": "Saxo 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1996–2003"
      },
      {
        "id": "saxo-5-doors",
        "name": "Saxo 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2002"
      },
      {
        "id": "xsara",
        "name": "Xsara",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2004"
      },
      {
        "id": "xsara-coupe",
        "name": "Xsara Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1998–2003"
      },
      {
        "id": "xsara-picasso",
        "name": "Xsara Picasso",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1999–2012"
      },
      {
        "id": "xsara-break",
        "name": "Xsara Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2005"
      },
      {
        "id": "c5-estate",
        "name": "C5 Estate",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2001–2019"
      },
      {
        "id": "c5-liftback",
        "name": "C5 Liftback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2008"
      },
      {
        "id": "c8",
        "name": "C8",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2014"
      },
      {
        "id": "c2",
        "name": "C2",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2003–2010"
      },
      {
        "id": "c3-pluriel",
        "name": "C3 Pluriel",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2010"
      },
      {
        "id": "c4-coupe",
        "name": "C4 Coupe",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2010"
      },
      {
        "id": "c4-hatchback",
        "name": "C4 Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2004–2013"
      },
      {
        "id": "c6",
        "name": "C6",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2012"
      },
      {
        "id": "c1-3-doors",
        "name": "C1 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2005–2022"
      },
      {
        "id": "c1-5-doors",
        "name": "C1 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2005–2022"
      },
      {
        "id": "grand-c4-picasso",
        "name": "Grand C4 Picasso",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2006–2018"
      },
      {
        "id": "c4-picasso",
        "name": "C4 Picasso",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2007–2018"
      },
      {
        "id": "c4-sedan",
        "name": "C4 Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2012"
      },
      {
        "id": "c-crosser",
        "name": "C-Crosser",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2012"
      },
      {
        "id": "nemo",
        "name": "Nemo",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2015"
      },
      {
        "id": "ds3",
        "name": "DS3",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2014"
      },
      {
        "id": "ds4",
        "name": "DS4",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2014"
      },
      {
        "id": "c-zero",
        "name": "C-Zero",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2020"
      },
      {
        "id": "ds5",
        "name": "DS5",
        "fuel": "Gasolina / Dièsel / Híbrid dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2018"
      },
      {
        "id": "c-elysee",
        "name": "C-Elysee",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      },
      {
        "id": "c4-aircross",
        "name": "C4 Aircross",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "c5-sedan",
        "name": "C5 Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2017"
      },
      {
        "id": "c5-crosstourer",
        "name": "C5 Crosstourer",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2019"
      },
      {
        "id": "e-mehari",
        "name": "E-Mehari",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2019"
      }
    ]
  },
  {
    "id": "cupra",
    "name": "Cupra",
    "logo": "🦈",
    "description": "Another way to race",
    "models": [
      {
        "id": "ateca",
        "name": "Ateca",
        "fuel": "Gasolina",
        "power": "190 / 300",
        "length": "4.381",
        "width": "1.841",
        "height": "1.611",
        "trunk": "485",
        "price": "46.450€"
      },
      {
        "id": "born",
        "name": "Born",
        "fuel": "Elèctric",
        "power": "204 / 231 / 326",
        "length": "4.322",
        "width": "1.809",
        "height": "1.540",
        "trunk": "385",
        "price": "42.920€"
      },
      {
        "id": "formentor",
        "name": "Formentor",
        "fuel": "Dièsel",
        "power": "150 / 245",
        "length": "4.450",
        "width": "1.839",
        "height": "1.511",
        "trunk": "420",
        "price": "35.550€"
      },
      {
        "id": "formentor",
        "name": "Formentor",
        "fuel": "Gasolina",
        "power": "150 / 190 / 310 / 333",
        "length": "4.451",
        "width": "1.839",
        "height": "1.520",
        "trunk": "450",
        "price": "35.550€"
      },
      {
        "id": "formentor",
        "name": "Formentor",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.451",
        "width": "1.839",
        "height": "1.520",
        "trunk": "450",
        "price": "35.550€"
      },
      {
        "id": "formentor",
        "name": "Formentor",
        "fuel": "PHEV",
        "power": "204 / 245",
        "length": "4.450",
        "width": "1.839",
        "height": "1.510",
        "trunk": "345",
        "price": "35.550€"
      },
      {
        "id": "formentor-vz5",
        "name": "Formentor VZ5",
        "fuel": "Gasolina",
        "power": "390",
        "length": "4.468",
        "width": "1.852",
        "height": "1.505",
        "trunk": "410",
        "price": "35.550€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.398",
        "width": "1.799",
        "height": "1.442",
        "trunk": "380",
        "price": "33.340€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.398",
        "width": "1.799",
        "height": "1.442",
        "trunk": "N.D.",
        "price": "33.340€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "PHEV",
        "power": "245 / 272",
        "length": "4.399",
        "width": "1.799",
        "height": "1.467",
        "trunk": "270",
        "price": "33.340€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "Gasolina",
        "power": "310",
        "length": "4.642",
        "width": "1.800",
        "height": "1.448",
        "trunk": "N.D.",
        "price": "33.340€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.657",
        "width": "1.799",
        "height": "1.463",
        "trunk": "N.D.",
        "price": "33.340€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "PHEV",
        "power": "245",
        "length": "4.657",
        "width": "1.799",
        "height": "1.463",
        "trunk": "470",
        "price": "33.340€"
      },
      {
        "id": "raval",
        "name": "Raval",
        "fuel": "Elèctric",
        "power": "211 / 226",
        "length": "4.046",
        "width": "1.784",
        "height": "1.514",
        "trunk": "441",
        "price": "33.275€"
      },
      {
        "id": "tavascan",
        "name": "Tavascan",
        "fuel": "Elèctric",
        "power": "286 / 340",
        "length": "4.644",
        "width": "2.108",
        "height": "1.597",
        "trunk": "540",
        "price": "52.010€"
      },
      {
        "id": "terramar",
        "name": "Terramar",
        "fuel": "Gasolina",
        "power": "265",
        "length": "4.519",
        "width": "1.863",
        "height": "1.584",
        "trunk": "540",
        "price": "44.310€"
      },
      {
        "id": "terramar",
        "name": "Terramar",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.519",
        "width": "1.863",
        "height": "1.584",
        "trunk": "540",
        "price": "44.310€"
      },
      {
        "id": "terramar",
        "name": "Terramar",
        "fuel": "PHEV",
        "power": "204 / 272",
        "length": "4.519",
        "width": "1.863",
        "height": "1.584",
        "trunk": "400",
        "price": "44.310€"
      }
    ],
    "discontinuedModels": []
  },
  {
    "id": "dacia",
    "name": "Dacia",
    "logo": "🚙",
    "description": "Simple et fiable",
    "models": [
      {
        "id": "bigster",
        "name": "Bigster",
        "fuel": "Híbrid",
        "power": "130 / 140 / 155",
        "length": "4.570",
        "width": "1.812",
        "height": "1.662",
        "trunk": "667–1.937",
        "price": "24.590€"
      },
      {
        "id": "duster",
        "name": "Duster",
        "fuel": "GLP",
        "power": "100",
        "length": "4.340",
        "width": "1.810",
        "height": "1.660",
        "trunk": "472",
        "price": "19.290€"
      },
      {
        "id": "duster",
        "name": "Duster",
        "fuel": "Híbrid",
        "power": "130 / 140",
        "length": "4.340",
        "width": "1.810",
        "height": "1.660",
        "trunk": "472",
        "price": "19.290€"
      },
      {
        "id": "jogger",
        "name": "Jogger",
        "fuel": "Gasolina",
        "power": "110",
        "length": "4.547",
        "width": "1.784",
        "height": "1.632",
        "trunk": "607–1.819",
        "price": "18.340€"
      },
      {
        "id": "jogger",
        "name": "Jogger",
        "fuel": "GLP",
        "power": "101",
        "length": "4.547",
        "width": "1.804",
        "height": "1.693",
        "trunk": "607–1.819",
        "price": "18.340€"
      },
      {
        "id": "jogger",
        "name": "Jogger",
        "fuel": "Híbrid",
        "power": "140",
        "length": "4.547",
        "width": "1.784",
        "height": "1.632",
        "trunk": "607–1.819",
        "price": "18.340€"
      },
      {
        "id": "sandero",
        "name": "Sandero",
        "fuel": "Gasolina",
        "power": "90",
        "length": "4.088",
        "width": "1.848",
        "height": "1.499",
        "trunk": "328–1.108",
        "price": "13.190€"
      },
      {
        "id": "sandero",
        "name": "Sandero",
        "fuel": "GLP",
        "power": "100",
        "length": "4.088",
        "width": "1.848",
        "height": "1.499",
        "trunk": "328–1.108",
        "price": "13.190€"
      },
      {
        "id": "sandero-stepway",
        "name": "Sandero Stepway",
        "fuel": "Gasolina",
        "power": "90 / 110",
        "length": "4.099",
        "width": "1.848",
        "height": "1.535",
        "trunk": "328–1.108",
        "price": "13.190€"
      },
      {
        "id": "sandero-stepway",
        "name": "Sandero Stepway",
        "fuel": "GLP",
        "power": "100",
        "length": "4.099",
        "width": "1.848",
        "height": "1.535",
        "trunk": "328–1.108",
        "price": "13.190€"
      },
      {
        "id": "spring",
        "name": "Spring",
        "fuel": "Elèctric",
        "power": "45 / 65",
        "length": "3.734",
        "width": "1.622",
        "height": "1.579",
        "trunk": "290–620",
        "price": "20.555€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "1100",
        "name": "1100",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1968–1971"
      },
      {
        "id": "1300",
        "name": "1300",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1979"
      },
      {
        "id": "1300-break",
        "name": "1300 Break",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–1980"
      },
      {
        "id": "1310",
        "name": "1310",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1979–2005"
      },
      {
        "id": "1310-break",
        "name": "1310 Break",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1980–2004"
      },
      {
        "id": "500",
        "name": "500",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1992"
      },
      {
        "id": "13101410-sport",
        "name": "1310/1410 Sport",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1992"
      },
      {
        "id": "1320",
        "name": "1320",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1991"
      },
      {
        "id": "1325",
        "name": "1325",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1996"
      },
      {
        "id": "nova",
        "name": "Nova",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–1999"
      },
      {
        "id": "supernova",
        "name": "SuperNova",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2003"
      },
      {
        "id": "solenza",
        "name": "Solenza",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2005"
      },
      {
        "id": "logan-mcv",
        "name": "Logan MCV",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2006–2020"
      },
      {
        "id": "logan-pick-up",
        "name": "Logan Pick-Up",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2012"
      },
      {
        "id": "logan-van",
        "name": "Logan Van",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2012"
      },
      {
        "id": "dokker",
        "name": "Dokker",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2021"
      },
      {
        "id": "dokker-van",
        "name": "Dokker Van",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2021"
      },
      {
        "id": "lodgy",
        "name": "Lodgy",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2022"
      },
      {
        "id": "logan-mcv-stepway",
        "name": "Logan MCV Stepway",
        "fuel": "Gasolina / Gas natural / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      }
    ]
  },
  {
    "id": "denza",
    "name": "Denza",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "d9",
        "name": "D9",
        "fuel": "PHEV",
        "power": "353",
        "length": "5.250",
        "width": "1.960",
        "height": "1.920",
        "trunk": "430–2.310",
        "price": "78.500€"
      },
      {
        "id": "z9-gt",
        "name": "Z9 GT",
        "fuel": "Elèctric",
        "power": "1156",
        "length": "5.180",
        "width": "1.990",
        "height": "1.500",
        "trunk": "495–1.680",
        "price": "103.500€"
      },
      {
        "id": "z9-gt",
        "name": "Z9 GT",
        "fuel": "PHEV",
        "power": "775",
        "length": "5.195",
        "width": "1.990",
        "height": "1.500",
        "trunk": "478–1.663",
        "price": "103.500€"
      }
    ]
  },
  {
    "id": "dfsk",
    "name": "DFSK",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "500",
        "name": "500",
        "fuel": "Gasolina",
        "power": "106",
        "length": "4.385",
        "width": "1.850",
        "height": "1.650",
        "trunk": "318",
        "price": "18.495€"
      },
      {
        "id": "580",
        "name": "580",
        "fuel": "Gasolina",
        "power": "146",
        "length": "4.680",
        "width": "1.845",
        "height": "1.715",
        "trunk": "N.D.",
        "price": "24.495€"
      },
      {
        "id": "e5",
        "name": "E5",
        "fuel": "PHEV",
        "power": "217",
        "length": "4.760",
        "width": "1.865",
        "height": "1.710",
        "trunk": "465–1.432",
        "price": "30.499€"
      },
      {
        "id": "f5",
        "name": "F5",
        "fuel": "Gasolina",
        "power": "137",
        "length": "4.685",
        "width": "1.865",
        "height": "1.645",
        "trunk": "379–1.420",
        "price": "28.995€"
      },
      {
        "id": "f5",
        "name": "F5",
        "fuel": "GLP",
        "power": "137",
        "length": "4.685",
        "width": "1.865",
        "height": "1.645",
        "trunk": "379–1.420",
        "price": "28.995€"
      }
    ]
  },
  {
    "id": "dodge",
    "name": "Dodge",
    "logo": "🐏",
    "description": "Brotherhood of Muscle",
    "models": [
      {
        "id": "challenger",
        "name": "Challenger",
        "fuel": "Gasolina",
        "power": "303 / 375 / 485 / 727 / 797 / 808",
        "length": "5.027",
        "width": "1.923",
        "height": "1.460",
        "trunk": "459",
        "price": "62.500€"
      },
      {
        "id": "charger",
        "name": "Charger",
        "fuel": "Gasolina",
        "power": "485 / 717 / 797",
        "length": "5.105",
        "width": "2.100",
        "height": "1.462",
        "trunk": "467",
        "price": "93.500€"
      },
      {
        "id": "durango",
        "name": "Durango",
        "fuel": "Gasolina",
        "power": "295 / 360 / 475 / 710",
        "length": "5.101",
        "width": "2.172",
        "height": "1.851",
        "trunk": "N.D.",
        "price": "79.700€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "polara",
        "name": "Polara",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1962–1965"
      },
      {
        "id": "viper",
        "name": "Viper",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "9",
        "years": "1991–2017"
      },
      {
        "id": "ram",
        "name": "Ram",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–2013"
      },
      {
        "id": "neon",
        "name": "Neon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1994–2005"
      },
      {
        "id": "stratus",
        "name": "Stratus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2005"
      },
      {
        "id": "dakota",
        "name": "Dakota",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2004"
      },
      {
        "id": "magnum",
        "name": "Magnum",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2008"
      },
      {
        "id": "magnum-srt8",
        "name": "Magnum SRT8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2008"
      },
      {
        "id": "caliber",
        "name": "Caliber",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2011"
      },
      {
        "id": "nitro",
        "name": "Nitro",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2012"
      },
      {
        "id": "journey",
        "name": "Journey",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2008–2020"
      },
      {
        "id": "avenger",
        "name": "Avenger",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2014"
      },
      {
        "id": "charger-srt",
        "name": "Charger SRT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2006–2023"
      },
      {
        "id": "caliber-srt4",
        "name": "Caliber SRT4",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2009"
      },
      {
        "id": "caravan",
        "name": "Caravan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1983–2014"
      },
      {
        "id": "dakota-club-cab",
        "name": "Dakota Club Cab",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2011"
      },
      {
        "id": "dakota-quad-cab",
        "name": "Dakota Quad Cab",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2011"
      },
      {
        "id": "stratus-coupe",
        "name": "Stratus Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2005"
      },
      {
        "id": "aries-coupe",
        "name": "Aries Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1989"
      },
      {
        "id": "dart",
        "name": "Dart",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2014"
      }
    ]
  },
  {
    "id": "dongfeng",
    "name": "Dongfeng",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "box",
        "name": "Box",
        "fuel": "Elèctric",
        "power": "95",
        "length": "4.030",
        "width": "1.810",
        "height": "1.570",
        "trunk": "326–945",
        "price": "23.859€"
      },
      {
        "id": "mage-phev",
        "name": "Mage PHEV",
        "fuel": "PHEV",
        "power": "299",
        "length": "4.685",
        "width": "1.900",
        "height": "1.615",
        "trunk": "525–1.876",
        "price": "31.990€"
      },
      {
        "id": "vigo",
        "name": "Vigo",
        "fuel": "Elèctric",
        "power": "163",
        "length": "4.306",
        "width": "1.868",
        "height": "1.654",
        "trunk": "500–1.040",
        "price": "29.990€"
      }
    ]
  },
  {
    "id": "ds",
    "name": "DS",
    "logo": "💎",
    "description": "Spirit of Avant-Garde",
    "models": [
      {
        "id": "3",
        "name": "3",
        "fuel": "Elèctric",
        "power": "156",
        "length": "4.118",
        "width": "1.791",
        "height": "1.534",
        "trunk": "350–1.050",
        "price": "33.500€"
      },
      {
        "id": "3",
        "name": "3",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.118",
        "width": "1.791",
        "height": "1.534",
        "trunk": "350–1.050",
        "price": "33.500€"
      },
      {
        "id": "ds-9",
        "name": "DS 9",
        "fuel": "Gasolina",
        "power": "224",
        "length": "4.934",
        "width": "1.855",
        "height": "1.460",
        "trunk": "510",
        "price": "54.032€"
      },
      {
        "id": "ds-9-e-tense",
        "name": "DS 9 E-TENSE",
        "fuel": "PHEV",
        "power": "224 / 360",
        "length": "4.934",
        "width": "1.855",
        "height": "1.460",
        "trunk": "510",
        "price": "54.032€"
      },
      {
        "id": "n-8",
        "name": "Nº 8",
        "fuel": "Elèctric",
        "power": "350",
        "length": "4.820",
        "width": "1.900",
        "height": "1.580",
        "trunk": "620",
        "price": "74.200€"
      },
      {
        "id": "n7",
        "name": "Nº7",
        "fuel": "Elèctric",
        "power": "230 / 245 / 350",
        "length": "4.660",
        "width": "1.900",
        "height": "1.625",
        "trunk": "560–1.570",
        "price": "43.727€"
      },
      {
        "id": "n7",
        "name": "Nº7",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.660",
        "width": "1.900",
        "height": "1.625",
        "trunk": "560–1.570",
        "price": "43.727€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "ds-5ls",
        "name": "DS 5LS",
        "fuel": "Gasolina / Dièsel / Híbrid dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "ds-3-cabrio",
        "name": "DS 3 Cabrio",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2018"
      },
      {
        "id": "ds-5",
        "name": "DS 5",
        "fuel": "Gasolina / Dièsel / Híbrid dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2018"
      },
      {
        "id": "ds-3-crossback",
        "name": "DS 3 Crossback",
        "fuel": "Gasolina / Dièsel / Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2022"
      }
    ]
  },
  {
    "id": "ebro",
    "name": "EBRO",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "s400",
        "name": "s400",
        "fuel": "Híbrid",
        "power": "211",
        "length": "4.320",
        "width": "1.831",
        "height": "1.646",
        "trunk": "430–1.155",
        "price": "27.490€"
      },
      {
        "id": "s700",
        "name": "s700",
        "fuel": "Gasolina",
        "power": "147",
        "length": "4.553",
        "width": "1.862",
        "height": "1.696",
        "trunk": "500–1.305",
        "price": "28.990€"
      },
      {
        "id": "s700",
        "name": "s700",
        "fuel": "Híbrid",
        "power": "224",
        "length": "4.553",
        "width": "1.862",
        "height": "1.696",
        "trunk": "369–1.289",
        "price": "28.990€"
      },
      {
        "id": "s700",
        "name": "s700",
        "fuel": "PHEV",
        "power": "347",
        "length": "4.553",
        "width": "1.862",
        "height": "1.696",
        "trunk": "500–1.305",
        "price": "28.990€"
      },
      {
        "id": "s800",
        "name": "S800",
        "fuel": "Gasolina",
        "power": "147",
        "length": "4.725",
        "width": "1.860",
        "height": "1.705",
        "trunk": "889–1.930",
        "price": "36.990€"
      },
      {
        "id": "s800",
        "name": "S800",
        "fuel": "PHEV",
        "power": "347",
        "length": "4.725",
        "width": "1.860",
        "height": "1.705",
        "trunk": "889–1.930",
        "price": "36.990€"
      },
      {
        "id": "s900",
        "name": "s900",
        "fuel": "PHEV",
        "power": "425",
        "length": "4.810",
        "width": "1.925",
        "height": "1.741",
        "trunk": "N.D.",
        "price": "38.900€"
      }
    ]
  },
  {
    "id": "ferrari",
    "name": "Ferrari",
    "logo": "🐎",
    "description": "The Prancing Horse",
    "models": [
      {
        "id": "296-gtb",
        "name": "296 GTB",
        "fuel": "Híbrid",
        "power": "830",
        "length": "4.565",
        "width": "1.958",
        "height": "1.187",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "296-gts",
        "name": "296 GTS",
        "fuel": "PHEV",
        "power": "830",
        "length": "4.565",
        "width": "1.958",
        "height": "1.191",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "458-italia",
        "name": "458 Italia",
        "fuel": "Gasolina",
        "power": "570 / 605",
        "length": "4.527",
        "width": "1.937",
        "height": "1.213",
        "trunk": "230",
        "price": "230.985€"
      },
      {
        "id": "458-spider",
        "name": "458 Spider",
        "fuel": "Gasolina",
        "power": "570 / 605",
        "length": "4.527",
        "width": "1.937",
        "height": "1.211",
        "trunk": "230",
        "price": "230.985€"
      },
      {
        "id": "488-gtb",
        "name": "488 GTB",
        "fuel": "Gasolina",
        "power": "670",
        "length": "4.568",
        "width": "1.952",
        "height": "1.213",
        "trunk": "N.D.",
        "price": "238.077€"
      },
      {
        "id": "488-gtb-spider",
        "name": "488 GTB Spider",
        "fuel": "Gasolina",
        "power": "670",
        "length": "4.568",
        "width": "1.952",
        "height": "1.211",
        "trunk": "230",
        "price": "238.077€"
      },
      {
        "id": "812-gts",
        "name": "812 GTS",
        "fuel": "Gasolina",
        "power": "800",
        "length": "4.693",
        "width": "1.971",
        "height": "1.276",
        "trunk": "210",
        "price": "N.D.€"
      },
      {
        "id": "812-superfast",
        "name": "812 Superfast",
        "fuel": "Gasolina",
        "power": "799",
        "length": "4.657",
        "width": "1.971",
        "height": "1.276",
        "trunk": "N.D.",
        "price": "339.000€"
      },
      {
        "id": "california-t",
        "name": "California T",
        "fuel": "Gasolina",
        "power": "560",
        "length": "4.570",
        "width": "1.910",
        "height": "1.322",
        "trunk": "240–340",
        "price": "214.448€"
      },
      {
        "id": "f12-berlinetta",
        "name": "F12 Berlinetta",
        "fuel": "Gasolina",
        "power": "740 / 780",
        "length": "4.656",
        "width": "1.961",
        "height": "1.273",
        "trunk": "N.D.",
        "price": "311.217€"
      },
      {
        "id": "f8-spider",
        "name": "F8 Spider",
        "fuel": "Gasolina",
        "power": "720",
        "length": "4.611",
        "width": "1.979",
        "height": "1.206",
        "trunk": "200",
        "price": "N.D.€"
      },
      {
        "id": "f8-tributo",
        "name": "F8 Tributo",
        "fuel": "Gasolina",
        "power": "720",
        "length": "5",
        "width": "2",
        "height": "1",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "gtc4-lusso",
        "name": "GTC4 Lusso",
        "fuel": "Gasolina",
        "power": "689",
        "length": "4.922",
        "width": "1.980",
        "height": "1.383",
        "trunk": "450",
        "price": "302.508€"
      },
      {
        "id": "gtc4-lusso-t",
        "name": "GTC4 Lusso T",
        "fuel": "Gasolina",
        "power": "610",
        "length": "4.922",
        "width": "1.980",
        "height": "1.383",
        "trunk": "450",
        "price": "302.508€"
      },
      {
        "id": "laferrari",
        "name": "LaFerrari",
        "fuel": "Híbrid",
        "power": "800",
        "length": "4.702",
        "width": "1.992",
        "height": "1.116",
        "trunk": "N.D.",
        "price": "1.300.000€"
      },
      {
        "id": "luce",
        "name": "Luce",
        "fuel": "Elèctric",
        "power": "1050",
        "length": "5.026",
        "width": "1.999",
        "height": "1.544",
        "trunk": "597",
        "price": "N.D.€"
      },
      {
        "id": "purosangue",
        "name": "Purosangue",
        "fuel": "Gasolina",
        "power": "725",
        "length": "4.973",
        "width": "2.028",
        "height": "1.589",
        "trunk": "473",
        "price": "N.D.€"
      },
      {
        "id": "roma",
        "name": "Roma",
        "fuel": "Gasolina",
        "power": "620",
        "length": "4.656",
        "width": "1.974",
        "height": "1.301",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "sf90-spider",
        "name": "SF90 Spider",
        "fuel": "Híbrid",
        "power": "1001",
        "length": "4.704",
        "width": "1.973",
        "height": "1.191",
        "trunk": "74",
        "price": "N.D.€"
      },
      {
        "id": "sf90-spider",
        "name": "SF90 Spider",
        "fuel": "PHEV",
        "power": "797",
        "length": "4.850",
        "width": "2.014",
        "height": "1.225",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "sf90-stradale",
        "name": "SF90 Stradale",
        "fuel": "Híbrid",
        "power": "1000",
        "length": "4.710",
        "width": "1.972",
        "height": "1.186",
        "trunk": "74",
        "price": "N.D.€"
      },
      {
        "id": "sf90-xx-stradale",
        "name": "SF90 XX Stradale",
        "fuel": "PHEV",
        "power": "797",
        "length": "4.850",
        "width": "2.014",
        "height": "1.225",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "125159-s",
        "name": "125/159 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1947–1948"
      },
      {
        "id": "166-spider-corsa",
        "name": "166 Spider Corsa",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1947–1950"
      },
      {
        "id": "166-sport",
        "name": "166 Sport",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1948–1950"
      },
      {
        "id": "195",
        "name": "195",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1950–1951"
      },
      {
        "id": "212",
        "name": "212",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1951–1953"
      },
      {
        "id": "250",
        "name": "250",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1953–1964"
      },
      {
        "id": "275",
        "name": "275",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1964–1968"
      },
      {
        "id": "365",
        "name": "365",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1968–1974"
      },
      {
        "id": "dino",
        "name": "Dino",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1968–1980"
      },
      {
        "id": "365gt4-bb",
        "name": "365GT4 BB",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1973–1976"
      },
      {
        "id": "512-bb",
        "name": "512 BB",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–1981"
      },
      {
        "id": "512-bbi",
        "name": "512 BBi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1984"
      },
      {
        "id": "308-gtb",
        "name": "308 GTB",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1975–1985"
      },
      {
        "id": "308-gts",
        "name": "308 GTS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1977–1985"
      },
      {
        "id": "400",
        "name": "400",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1976–1989"
      },
      {
        "id": "mondial",
        "name": "Mondial",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1980–1993"
      },
      {
        "id": "mondial-cabriolet",
        "name": "Mondial Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1983–1993"
      },
      {
        "id": "288-gto",
        "name": "288 GTO",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1986"
      },
      {
        "id": "328-gtb",
        "name": "328 GTB",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1989"
      },
      {
        "id": "328-gts",
        "name": "328 GTS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1989"
      },
      {
        "id": "f40",
        "name": "F40",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1987–1992"
      },
      {
        "id": "348",
        "name": "348",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1989–1994"
      },
      {
        "id": "348-spider",
        "name": "348 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "f355",
        "name": "F355",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–1999"
      },
      {
        "id": "f355-spider",
        "name": "F355 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–1999"
      },
      {
        "id": "550-maranello",
        "name": "550 Maranello",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2001"
      },
      {
        "id": "f50",
        "name": "F50",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–1997"
      },
      {
        "id": "360-modena",
        "name": "360 Modena",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2004"
      },
      {
        "id": "360-spider",
        "name": "360 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2005"
      },
      {
        "id": "550-barchetta",
        "name": "550 Barchetta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2001"
      },
      {
        "id": "456-gt",
        "name": "456 GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–2003"
      },
      {
        "id": "360-challenge-stradale",
        "name": "360 Challenge Stradale",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2005"
      },
      {
        "id": "612-scaglietti",
        "name": "612 Scaglietti",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2011"
      },
      {
        "id": "f430",
        "name": "F430",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2009"
      },
      {
        "id": "f430-spider",
        "name": "F430 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2009"
      },
      {
        "id": "fxx",
        "name": "FXX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2007"
      },
      {
        "id": "599",
        "name": "599",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2012"
      },
      {
        "id": "scuderia-spider",
        "name": "Scuderia Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2009"
      },
      {
        "id": "california",
        "name": "California",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2014"
      },
      {
        "id": "ff",
        "name": "FF",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2016"
      },
      {
        "id": "458-speciale",
        "name": "458 Speciale",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2015"
      },
      {
        "id": "458-speciale-a",
        "name": "458 Speciale A",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2015"
      },
      {
        "id": "f12-trs",
        "name": "F12 TRS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2014"
      },
      {
        "id": "f60-america",
        "name": "F60 America",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2016"
      },
      {
        "id": "f12tdf",
        "name": "F12tdf",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2017"
      },
      {
        "id": "488-spider",
        "name": "488 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2019"
      },
      {
        "id": "gtc4lusso",
        "name": "GTC4Lusso",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2020"
      },
      {
        "id": "gtc4lusso-t",
        "name": "GTC4Lusso T",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2020"
      },
      {
        "id": "488-pista",
        "name": "488 Pista",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2020"
      },
      {
        "id": "monza",
        "name": "Monza",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2018–2022"
      },
      {
        "id": "812",
        "name": "812",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2017–2024"
      },
      {
        "id": "f8",
        "name": "F8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2019–2023"
      },
      {
        "id": "enzo",
        "name": "Enzo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2004"
      },
      {
        "id": "575m-maranello",
        "name": "575M Maranello",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2006"
      },
      {
        "id": "575m-superamerica",
        "name": "575M Superamerica",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2006"
      }
    ]
  },
  {
    "id": "fiat",
    "name": "Fiat",
    "logo": "🇮🇹",
    "description": "Driven by Passion",
    "models": [
      {
        "id": "500",
        "name": "500",
        "fuel": "Híbrid",
        "power": "65",
        "length": "3.631",
        "width": "1.684",
        "height": "1.532",
        "trunk": "183",
        "price": "19.750€"
      },
      {
        "id": "500-cabrio",
        "name": "500 Cabrio",
        "fuel": "Híbrid",
        "power": "65",
        "length": "3.631",
        "width": "1.684",
        "height": "1.532",
        "trunk": "183",
        "price": "19.750€"
      },
      {
        "id": "500x",
        "name": "500X",
        "fuel": "Dièsel",
        "power": "95 / 120 / 140",
        "length": "4.264",
        "width": "1.796",
        "height": "1.595",
        "trunk": "350–1.000",
        "price": "18.050€"
      },
      {
        "id": "500x",
        "name": "500X",
        "fuel": "Gasolina",
        "power": "110 / 120 / 140 / 150 / 170",
        "length": "4.264",
        "width": "1.796",
        "height": "1.595",
        "trunk": "350–1.000",
        "price": "18.050€"
      },
      {
        "id": "500x",
        "name": "500X",
        "fuel": "Híbrid",
        "power": "130",
        "length": "4.264",
        "width": "1.796",
        "height": "1.595",
        "trunk": "245–910",
        "price": "18.050€"
      },
      {
        "id": "500x-sport",
        "name": "500X Sport",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.269",
        "width": "1.796",
        "height": "1.595",
        "trunk": "350–1.000",
        "price": "18.050€"
      },
      {
        "id": "600-hybrid",
        "name": "600 Hybrid",
        "fuel": "Híbrid",
        "power": "100 / 136",
        "length": "4.178",
        "width": "1.779",
        "height": "1.525",
        "trunk": "N.D.",
        "price": "24.900€"
      },
      {
        "id": "600e",
        "name": "600e",
        "fuel": "Elèctric",
        "power": "156",
        "length": "4.171",
        "width": "1.781",
        "height": "1.523",
        "trunk": "360–1.231",
        "price": "24.900€"
      },
      {
        "id": "e-ulysse",
        "name": "E-Ulysse",
        "fuel": "Elèctric",
        "power": "136",
        "length": "0",
        "width": "0",
        "height": "0",
        "trunk": "N.D.",
        "price": "62.700€"
      },
      {
        "id": "grande-panda",
        "name": "Grande Panda",
        "fuel": "Combustió",
        "power": "100",
        "length": "3.999",
        "width": "1.763",
        "height": "1.570",
        "trunk": "412–1.366",
        "price": "18.150€"
      },
      {
        "id": "grande-panda",
        "name": "Grande Panda",
        "fuel": "Elèctric",
        "power": "113",
        "length": "3.999",
        "width": "1.763",
        "height": "1.570",
        "trunk": "350–1.315",
        "price": "18.150€"
      },
      {
        "id": "grande-panda",
        "name": "Grande Panda",
        "fuel": "Híbrid",
        "power": "110",
        "length": "3.999",
        "width": "1.763",
        "height": "1.586",
        "trunk": "350–1.304",
        "price": "18.150€"
      },
      {
        "id": "panda",
        "name": "Panda",
        "fuel": "Híbrid",
        "power": "70",
        "length": "3.653",
        "width": "1.643",
        "height": "1.551",
        "trunk": "225",
        "price": "16.400€"
      },
      {
        "id": "pandina",
        "name": "Pandina",
        "fuel": "Híbrid",
        "power": "70",
        "length": "3.705",
        "width": "1.882",
        "height": "1.605",
        "trunk": "225",
        "price": "16.400€"
      },
      {
        "id": "tipo",
        "name": "Tipo",
        "fuel": "Dièsel",
        "power": "95 / 130",
        "length": "4.368",
        "width": "1.792",
        "height": "1.495",
        "trunk": "440",
        "price": "19.600€"
      },
      {
        "id": "tipo",
        "name": "Tipo",
        "fuel": "Gasolina",
        "power": "100",
        "length": "4.368",
        "width": "1.792",
        "height": "1.495",
        "trunk": "440",
        "price": "19.600€"
      },
      {
        "id": "tipo-cross",
        "name": "Tipo Cross",
        "fuel": "Dièsel",
        "power": "95 / 130",
        "length": "4.386",
        "width": "1.802",
        "height": "1.556",
        "trunk": "440",
        "price": "19.600€"
      },
      {
        "id": "tipo-cross",
        "name": "Tipo Cross",
        "fuel": "Gasolina",
        "power": "100",
        "length": "4.386",
        "width": "1.802",
        "height": "1.556",
        "trunk": "440",
        "price": "19.600€"
      },
      {
        "id": "topolino",
        "name": "Topolino",
        "fuel": "Elèctric",
        "power": "8",
        "length": "2.535",
        "width": "1.400",
        "height": "1.530",
        "trunk": "N.D.",
        "price": "9.890€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "3-12-hp",
        "name": "3 1/2 HP",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1899–1900"
      },
      {
        "id": "12-hp",
        "name": "12 HP",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1901–1902"
      },
      {
        "id": "16-20-hp",
        "name": "16-20 HP",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1903–1906"
      },
      {
        "id": "brevetti",
        "name": "Brevetti",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1905–1908"
      },
      {
        "id": "15-25-hp-brevetti-tipo-2",
        "name": "15-25 HP Brevetti Tipo 2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1908–1912"
      },
      {
        "id": "12-15-hp-zero",
        "name": "12-15 HP Zero",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1912–1915"
      },
      {
        "id": "501",
        "name": "501",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1919–1926"
      },
      {
        "id": "501-s",
        "name": "501 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1919–1926"
      },
      {
        "id": "505",
        "name": "505",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1919–1925"
      },
      {
        "id": "519-berlina",
        "name": "519 Berlina",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1922–1924"
      },
      {
        "id": "519-coupe",
        "name": "519 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1922–1924"
      },
      {
        "id": "519-s",
        "name": "519 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1922–1924"
      },
      {
        "id": "502",
        "name": "502",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1923–1926"
      },
      {
        "id": "509",
        "name": "509",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1925–1929"
      },
      {
        "id": "509-s",
        "name": "509 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1925–1928"
      },
      {
        "id": "503-torpedo",
        "name": "503 Torpedo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1926–1927"
      },
      {
        "id": "507",
        "name": "507",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1926–1927"
      },
      {
        "id": "507-touring",
        "name": "507 Touring",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1926–1927"
      },
      {
        "id": "514",
        "name": "514",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1929–1932"
      },
      {
        "id": "514-spider",
        "name": "514 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1929–1932"
      },
      {
        "id": "521",
        "name": "521",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1928–1931"
      },
      {
        "id": "525",
        "name": "525",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1928–1929"
      },
      {
        "id": "522-c",
        "name": "522 C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1931–1933"
      },
      {
        "id": "524-c",
        "name": "524 C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1931–1934"
      },
      {
        "id": "527",
        "name": "527",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1934–1936"
      },
      {
        "id": "1500",
        "name": "1500",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1935–1968"
      },
      {
        "id": "2800",
        "name": "2800",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1938–1944"
      },
      {
        "id": "1100-s",
        "name": "1100 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1947–1950"
      },
      {
        "id": "1100-e",
        "name": "1100 E",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1949–1953"
      },
      {
        "id": "1400",
        "name": "1400",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1950–1954"
      },
      {
        "id": "1400-cabriolet",
        "name": "1400 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1950–1954"
      },
      {
        "id": "8v",
        "name": "8V",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1952–1954"
      },
      {
        "id": "600-multipla",
        "name": "600 Multipla",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1955–1960"
      },
      {
        "id": "campagnola",
        "name": "Campagnola",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1955–1979"
      },
      {
        "id": "1100-tv-spider",
        "name": "1100 TV Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1955–1960"
      },
      {
        "id": "1200",
        "name": "1200",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1957–1961"
      },
      {
        "id": "1200-spider",
        "name": "1200 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1957–1960"
      },
      {
        "id": "1800-2100",
        "name": "1800 / 2100",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1959–1961"
      },
      {
        "id": "500-k-giardiniera",
        "name": "500 K / Giardiniera",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1960–1977"
      },
      {
        "id": "2300-coupe",
        "name": "2300 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1961–1962"
      },
      {
        "id": "2300-saloon",
        "name": "2300 Saloon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1961–1968"
      },
      {
        "id": "2300-station-wagon",
        "name": "2300 Station Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1961–1968"
      },
      {
        "id": "1100-d",
        "name": "1100 D",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1962–1966"
      },
      {
        "id": "1100-d-station-wagon",
        "name": "1100 D Station Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1962–1968"
      },
      {
        "id": "850",
        "name": "850",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1964–1971"
      },
      {
        "id": "600-d",
        "name": "600 D",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1964–1969"
      },
      {
        "id": "850-coupe",
        "name": "850 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1965–1971"
      },
      {
        "id": "850-spider",
        "name": "850 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1965–1968"
      },
      {
        "id": "124-saloon",
        "name": "124 Saloon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1966–1974"
      },
      {
        "id": "124-familiale",
        "name": "124 Familiale",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1966–1970"
      },
      {
        "id": "124-coupe",
        "name": "124 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1967–1976"
      },
      {
        "id": "124-spider",
        "name": "124 Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1966–2021"
      },
      {
        "id": "125",
        "name": "125",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1967–1972"
      },
      {
        "id": "dino-coupe",
        "name": "Dino Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1967–1972"
      },
      {
        "id": "dino-spider",
        "name": "Dino Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1967–1972"
      },
      {
        "id": "128-saloon",
        "name": "128 Saloon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1976"
      },
      {
        "id": "130-limousine",
        "name": "130 Limousine",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1976"
      },
      {
        "id": "130-coupe",
        "name": "130 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1972"
      },
      {
        "id": "127",
        "name": "127",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1971–1981"
      },
      {
        "id": "126",
        "name": "126",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–2000"
      },
      {
        "id": "128-coupe",
        "name": "128 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–1974"
      },
      {
        "id": "132",
        "name": "132",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–1981"
      },
      {
        "id": "x19",
        "name": "X1/9",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–1989"
      },
      {
        "id": "131-4-doors",
        "name": "131 4 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1974–1981"
      },
      {
        "id": "ritmo",
        "name": "Ritmo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1978–1982"
      },
      {
        "id": "argenta",
        "name": "Argenta",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1981–1985"
      },
      {
        "id": "uno-3-doors",
        "name": "Uno 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1983–1994"
      },
      {
        "id": "uno-5-doors",
        "name": "Uno 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1983–1994"
      },
      {
        "id": "mille",
        "name": "Mille",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1983–2013"
      },
      {
        "id": "regata",
        "name": "Regata",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1989"
      },
      {
        "id": "regata-weekend",
        "name": "Regata Weekend",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1989"
      },
      {
        "id": "croma",
        "name": "Croma",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1986–2011"
      },
      {
        "id": "tempra",
        "name": "Tempra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1998"
      },
      {
        "id": "tempra-sw",
        "name": "Tempra SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1998"
      },
      {
        "id": "cinquecento",
        "name": "Cinquecento",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1998"
      },
      {
        "id": "tipo-3-doors",
        "name": "Tipo 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "tipo-5-doors",
        "name": "Tipo 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1988–2021"
      },
      {
        "id": "punto-3-doors",
        "name": "Punto 3 Doors",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1994–2018"
      },
      {
        "id": "punto-5-doors",
        "name": "Punto 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1994–2018"
      },
      {
        "id": "punto-cabrio",
        "name": "Punto Cabrio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1999"
      },
      {
        "id": "coupe",
        "name": "Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–2000"
      },
      {
        "id": "barchetta",
        "name": "Barchetta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2005"
      },
      {
        "id": "brava",
        "name": "Brava",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2001"
      },
      {
        "id": "bravo",
        "name": "Bravo",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2010"
      },
      {
        "id": "marea",
        "name": "Marea",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2002"
      },
      {
        "id": "marea-weekend",
        "name": "Marea Weekend",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2002"
      },
      {
        "id": "seicento",
        "name": "Seicento",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2006"
      },
      {
        "id": "multipla",
        "name": "Multipla",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2010"
      },
      {
        "id": "doblo",
        "name": "Doblo",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2001–2022"
      },
      {
        "id": "albea-siena",
        "name": "Albea / Siena",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2012"
      },
      {
        "id": "idea",
        "name": "Idea",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2016"
      },
      {
        "id": "grande-punto-punto-evo-3-doors",
        "name": "Grande Punto / Punto Evo 3 Doors",
        "fuel": "Gasolina / Dièsel / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2005–2012"
      },
      {
        "id": "grande-punto-punto-evo-5-doors",
        "name": "Grande Punto / Punto Evo 5 Doors",
        "fuel": "Gasolina / Dièsel / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2012"
      },
      {
        "id": "linea",
        "name": "Linea",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2015"
      },
      {
        "id": "sedici",
        "name": "Sedici",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2014"
      },
      {
        "id": "ulysse",
        "name": "Ulysse",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1994–2007"
      },
      {
        "id": "qubo",
        "name": "Qubo",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2019"
      },
      {
        "id": "uno",
        "name": "Uno",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2021"
      },
      {
        "id": "freemont",
        "name": "Freemont",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2018"
      },
      {
        "id": "500l",
        "name": "500L",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "500l-living",
        "name": "500L Living",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2022"
      },
      {
        "id": "500l-trekking",
        "name": "500L Trekking",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2017"
      },
      {
        "id": "500l-urban",
        "name": "500L Urban",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2022"
      },
      {
        "id": "palio",
        "name": "Palio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2016"
      },
      {
        "id": "palio-weekend",
        "name": "Palio Weekend",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2019"
      },
      {
        "id": "500e",
        "name": "500e",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2020"
      },
      {
        "id": "viaggio",
        "name": "Viaggio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2017"
      },
      {
        "id": "fullback",
        "name": "Fullback",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2016–2019"
      },
      {
        "id": "argo",
        "name": "Argo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "n.d."
      },
      {
        "id": "panda-4x4",
        "name": "Panda 4X4",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1986–2023"
      },
      {
        "id": "panda-cross",
        "name": "Panda Cross",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2017"
      },
      {
        "id": "panda-city-cross",
        "name": "Panda City Cross",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "tipo-station-wagon",
        "name": "Tipo Station Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2021"
      }
    ]
  },
  {
    "id": "ford",
    "name": "Ford",
    "logo": "🔵",
    "description": "Built Ford Tough",
    "models": [
      {
        "id": "b-max",
        "name": "B-Max",
        "fuel": "Dièsel",
        "power": "95",
        "length": "4.077",
        "width": "1.751",
        "height": "1.604",
        "trunk": "318–1.386",
        "price": "15.400€"
      },
      {
        "id": "b-max",
        "name": "B-Max",
        "fuel": "Gasolina",
        "power": "90 / 100 / 105 / 125 / 140",
        "length": "4.077",
        "width": "1.751",
        "height": "1.604",
        "trunk": "318–1.386",
        "price": "15.400€"
      },
      {
        "id": "b-max",
        "name": "B-Max",
        "fuel": "GLP",
        "power": "86",
        "length": "4.077",
        "width": "1.751",
        "height": "1.604",
        "trunk": "267",
        "price": "15.400€"
      },
      {
        "id": "bronco",
        "name": "Bronco",
        "fuel": "Gasolina",
        "power": "334",
        "length": "4.811",
        "width": "1.928",
        "height": "1.854",
        "trunk": "N.D.",
        "price": "86.900€"
      },
      {
        "id": "c-max",
        "name": "C-Max",
        "fuel": "Dièsel",
        "power": "95 / 105 / 120 / 150",
        "length": "4.379",
        "width": "1.828",
        "height": "1.610",
        "trunk": "471–1.684",
        "price": "21.715€"
      },
      {
        "id": "c-max",
        "name": "C-Max",
        "fuel": "Gasolina",
        "power": "100 / 125 / 150",
        "length": "4.379",
        "width": "1.828",
        "height": "1.610",
        "trunk": "471–1.684",
        "price": "21.715€"
      },
      {
        "id": "capri",
        "name": "Capri",
        "fuel": "Elèctric",
        "power": "170 / 286 / 340",
        "length": "4.634",
        "width": "1.946",
        "height": "1.626",
        "trunk": "622–1.510",
        "price": "47.216€"
      },
      {
        "id": "e-transit",
        "name": "e-Transit",
        "fuel": "Elèctric",
        "power": "184",
        "length": "5.981",
        "width": "2.474",
        "height": "2.682",
        "trunk": "N.D.",
        "price": "71.770€"
      },
      {
        "id": "ecosport",
        "name": "EcoSport",
        "fuel": "Dièsel",
        "power": "100",
        "length": "4.096",
        "width": "1.765",
        "height": "1.653",
        "trunk": "334–1.238",
        "price": "19.835€"
      },
      {
        "id": "ecosport",
        "name": "EcoSport",
        "fuel": "Gasolina",
        "power": "125 / 140",
        "length": "4.096",
        "width": "1.765",
        "height": "1.653",
        "trunk": "334–1.238",
        "price": "19.835€"
      },
      {
        "id": "edge",
        "name": "Edge",
        "fuel": "Dièsel",
        "power": "180 / 190 / 210",
        "length": "4.808",
        "width": "1.928",
        "height": "1.707",
        "trunk": "507–1.847",
        "price": "44.575€"
      },
      {
        "id": "edge-vignale",
        "name": "Edge Vignale",
        "fuel": "Dièsel",
        "power": "180 / 210",
        "length": "4.808",
        "width": "1.928",
        "height": "1.692",
        "trunk": "602–1.847",
        "price": "44.575€"
      },
      {
        "id": "explorer",
        "name": "Explorer",
        "fuel": "Elèctric",
        "power": "170 / 286 / 340",
        "length": "4.468",
        "width": "2.063",
        "height": "1.630",
        "trunk": "525–1.455",
        "price": "38.700€"
      },
      {
        "id": "fiesta",
        "name": "Fiesta",
        "fuel": "Híbrid",
        "power": "155",
        "length": "4.069",
        "width": "1.735",
        "height": "1.484",
        "trunk": "311–1.093",
        "price": "18.494€"
      },
      {
        "id": "fiesta-st",
        "name": "Fiesta ST",
        "fuel": "Gasolina",
        "power": "200",
        "length": "4.091",
        "width": "1.735",
        "height": "1.487",
        "trunk": "311–1.093",
        "price": "18.494€"
      },
      {
        "id": "focus",
        "name": "Focus",
        "fuel": "Dièsel",
        "power": "115",
        "length": "4.392",
        "width": "1.825",
        "height": "1.451",
        "trunk": "392–1.354",
        "price": "31.034€"
      },
      {
        "id": "focus",
        "name": "Focus",
        "fuel": "Gasolina",
        "power": "280",
        "length": "4.392",
        "width": "1.825",
        "height": "1.451",
        "trunk": "358–1.320",
        "price": "31.034€"
      },
      {
        "id": "focus",
        "name": "Focus",
        "fuel": "Híbrid",
        "power": "125 / 155",
        "length": "4.392",
        "width": "1.825",
        "height": "1.451",
        "trunk": "392–1.354",
        "price": "31.034€"
      },
      {
        "id": "focus-sportbrake",
        "name": "Focus Sportbrake",
        "fuel": "Dièsel",
        "power": "115",
        "length": "4.392",
        "width": "1.825",
        "height": "1.451",
        "trunk": "635–1.653",
        "price": "31.034€"
      },
      {
        "id": "focus-sportbrake",
        "name": "Focus Sportbrake",
        "fuel": "Gasolina",
        "power": "280",
        "length": "4.672",
        "width": "1.825",
        "height": "1.487",
        "trunk": "593–1.620",
        "price": "31.034€"
      },
      {
        "id": "focus-sportbrake",
        "name": "Focus Sportbrake",
        "fuel": "Híbrid",
        "power": "125 / 155",
        "length": "4.672",
        "width": "1.825",
        "height": "1.487",
        "trunk": "635–1.653",
        "price": "31.034€"
      },
      {
        "id": "grand-c-max",
        "name": "Grand C-Max",
        "fuel": "Dièsel",
        "power": "95 / 120 / 150",
        "length": "4.519",
        "width": "1.828",
        "height": "1.642",
        "trunk": "475–1.867",
        "price": "21.715€"
      },
      {
        "id": "grand-c-max",
        "name": "Grand C-Max",
        "fuel": "Gasolina",
        "power": "100 / 125 / 150",
        "length": "4.519",
        "width": "1.828",
        "height": "1.612",
        "trunk": "475–1.867",
        "price": "21.715€"
      },
      {
        "id": "gt",
        "name": "GT",
        "fuel": "Gasolina",
        "power": "647",
        "length": "4.779",
        "width": "2.003",
        "height": "1.109",
        "trunk": "N.D.",
        "price": "388.000€"
      },
      {
        "id": "ka-",
        "name": "Ka +",
        "fuel": "Gasolina",
        "power": "70 / 85 / 95",
        "length": "3.929",
        "width": "1.695",
        "height": "1.524",
        "trunk": "270",
        "price": "9.725€"
      },
      {
        "id": "kuga",
        "name": "Kuga",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.604",
        "width": "1.882",
        "height": "1.675",
        "trunk": "412–1.534",
        "price": "31.622€"
      },
      {
        "id": "kuga",
        "name": "Kuga",
        "fuel": "Híbrid",
        "power": "180 / 183",
        "length": "4.615",
        "width": "1.882",
        "height": "1.673",
        "trunk": "395–1.517",
        "price": "31.622€"
      },
      {
        "id": "kuga",
        "name": "Kuga",
        "fuel": "PHEV",
        "power": "243",
        "length": "4.604",
        "width": "1.882",
        "height": "1.675",
        "trunk": "395–1.517",
        "price": "31.622€"
      },
      {
        "id": "mustang-convertible-gt",
        "name": "Mustang Convertible GT",
        "fuel": "Gasolina",
        "power": "450",
        "length": "4.810",
        "width": "1.916",
        "height": "1.388",
        "trunk": "310",
        "price": "57.580€"
      },
      {
        "id": "mustang-dark-horse",
        "name": "Mustang Dark Horse",
        "fuel": "Gasolina",
        "power": "460",
        "length": "4.819",
        "width": "1.917",
        "height": "1.403",
        "trunk": "381",
        "price": "57.580€"
      },
      {
        "id": "mustang-gt",
        "name": "Mustang GT",
        "fuel": "Gasolina",
        "power": "450",
        "length": "4.810",
        "width": "1.916",
        "height": "1.394",
        "trunk": "381",
        "price": "57.580€"
      },
      {
        "id": "mustang-mach-1",
        "name": "Mustang Mach 1",
        "fuel": "Gasolina",
        "power": "460",
        "length": "4.797",
        "width": "2.081",
        "height": "1.382",
        "trunk": "408",
        "price": "57.580€"
      },
      {
        "id": "mustang-mach-e",
        "name": "Mustang Mach-E",
        "fuel": "Elèctric",
        "power": "269 / 294 / 351 / 487",
        "length": "4.712",
        "width": "1.881",
        "height": "1.597",
        "trunk": "502–1.420",
        "price": "63.767€"
      },
      {
        "id": "puma",
        "name": "Puma",
        "fuel": "Híbrid",
        "power": "125 / 155",
        "length": "4.207",
        "width": "1.805",
        "height": "1.534",
        "trunk": "401–1.161",
        "price": "27.539€"
      },
      {
        "id": "puma-gen-e",
        "name": "Puma Gen-E",
        "fuel": "Elèctric",
        "power": "168",
        "length": "4.214",
        "width": "1.805",
        "height": "1.555",
        "trunk": "574–1.283",
        "price": "27.539€"
      },
      {
        "id": "puma-st",
        "name": "Puma ST",
        "fuel": "Híbrid",
        "power": "170",
        "length": "4.225",
        "width": "1.805",
        "height": "1.533",
        "trunk": "456–1.216",
        "price": "27.539€"
      },
      {
        "id": "ranger",
        "name": "Ranger",
        "fuel": "Dièsel",
        "power": "170 / 205 / 240",
        "length": "5.370",
        "width": "1.918",
        "height": "1.868",
        "trunk": "N.D.",
        "price": "28.839€"
      },
      {
        "id": "ranger-raptor",
        "name": "Ranger Raptor",
        "fuel": "Dièsel",
        "power": "210",
        "length": "5.370",
        "width": "1.918",
        "height": "1.884",
        "trunk": "N.D.",
        "price": "28.839€"
      },
      {
        "id": "ranger-raptor",
        "name": "Ranger Raptor",
        "fuel": "Gasolina",
        "power": "292",
        "length": "5.360",
        "width": "2.028",
        "height": "1.926",
        "trunk": "N.D.",
        "price": "28.839€"
      },
      {
        "id": "s-max",
        "name": "S-Max",
        "fuel": "Híbrid",
        "power": "190",
        "length": "4.804",
        "width": "1.916",
        "height": "1.684",
        "trunk": "185–2.339",
        "price": "N.D.€"
      },
      {
        "id": "tourneo-courier",
        "name": "Tourneo Courier",
        "fuel": "Gasolina",
        "power": "125",
        "length": "4.337",
        "width": "1.800",
        "height": "1.817",
        "trunk": "N.D.",
        "price": "26.912€"
      },
      {
        "id": "tourneo-custom-phev",
        "name": "Tourneo Custom PHEV",
        "fuel": "PHEV",
        "power": "126",
        "length": "4.973",
        "width": "1.986",
        "height": "2.000",
        "trunk": "922–5.520",
        "price": "N.D.€"
      },
      {
        "id": "transit-custom-phev",
        "name": "Transit Custom PHEV",
        "fuel": "PHEV",
        "power": "N.D.",
        "length": "4.973",
        "width": "2.272",
        "height": "2.000",
        "trunk": "N.D.",
        "price": "71.770€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "model-a",
        "name": "Model A",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1903–1905"
      },
      {
        "id": "model-t",
        "name": "Model T",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1908–1927"
      },
      {
        "id": "deluxe",
        "name": "Deluxe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1932–1938"
      },
      {
        "id": "crestliner",
        "name": "Crestliner",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1949–1951"
      },
      {
        "id": "consul",
        "name": "Consul",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1950–1956"
      },
      {
        "id": "crestline",
        "name": "Crestline",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1952–1954"
      },
      {
        "id": "taunus",
        "name": "Taunus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1952–1959"
      },
      {
        "id": "taunus-cabrio",
        "name": "Taunus Cabrio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1952–1968"
      },
      {
        "id": "anglia-100e",
        "name": "Anglia 100E",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1953–1959"
      },
      {
        "id": "thunderbird",
        "name": "Thunderbird",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "16",
        "years": "1955–2005"
      },
      {
        "id": "anglia-105e",
        "name": "Anglia 105E",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1959–1967"
      },
      {
        "id": "cortina",
        "name": "Cortina",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1962–1979"
      },
      {
        "id": "zodiac",
        "name": "Zodiac",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1962–1972"
      },
      {
        "id": "corsair",
        "name": "Corsair",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1964–1970"
      },
      {
        "id": "pinto",
        "name": "Pinto",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1980"
      },
      {
        "id": "fiesta-3-doors",
        "name": "Fiesta 3 Doors",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "11",
        "years": "1976–2022"
      },
      {
        "id": "escort-3-doors",
        "name": "Escort 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1980–2000"
      },
      {
        "id": "orion",
        "name": "Orion",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1993"
      },
      {
        "id": "sierra-3-doors",
        "name": "Sierra 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1993"
      },
      {
        "id": "sierra-5-doors",
        "name": "Sierra 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1993"
      },
      {
        "id": "sierra-sedan",
        "name": "Sierra Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1993"
      },
      {
        "id": "galaxy",
        "name": "Galaxy",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1995–2022"
      },
      {
        "id": "taurus",
        "name": "Taurus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1995–2019"
      },
      {
        "id": "taurus-wagon",
        "name": "Taurus Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2007"
      },
      {
        "id": "maverick-lwb",
        "name": "Maverick LWB",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–1998"
      },
      {
        "id": "maverick-swb",
        "name": "Maverick SWB",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–1998"
      },
      {
        "id": "probe",
        "name": "Probe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1998"
      },
      {
        "id": "escort-5-doors",
        "name": "Escort 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1990–2000"
      },
      {
        "id": "escort-4-doors",
        "name": "Escort 4 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–2000"
      },
      {
        "id": "escort-cabrio",
        "name": "Escort Cabrio",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–1998"
      },
      {
        "id": "escort-clipper",
        "name": "Escort Clipper",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1992"
      },
      {
        "id": "escort-wagon",
        "name": "Escort Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2000"
      },
      {
        "id": "ka",
        "name": "Ka",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2015"
      },
      {
        "id": "cougar",
        "name": "Cougar",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2001"
      },
      {
        "id": "crown-victoria",
        "name": "Crown Victoria",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2007"
      },
      {
        "id": "windstar",
        "name": "Windstar",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2004"
      },
      {
        "id": "econovan",
        "name": "Econovan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2005"
      },
      {
        "id": "focus-3-doors",
        "name": "Focus 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1998–2011"
      },
      {
        "id": "focus-sedan",
        "name": "Focus Sedan",
        "fuel": "Gasolina / Dièsel / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1999–2018"
      },
      {
        "id": "focus-us",
        "name": "Focus US",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2010"
      },
      {
        "id": "focus-cc",
        "name": "Focus CC",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2011"
      },
      {
        "id": "focus-rs",
        "name": "Focus RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2002–2018"
      },
      {
        "id": "explorer-sport",
        "name": "Explorer Sport",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2005"
      },
      {
        "id": "explorer-sport-trac",
        "name": "Explorer Sport Trac",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2010"
      },
      {
        "id": "fusion-european",
        "name": "Fusion European",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2012"
      },
      {
        "id": "freestar",
        "name": "Freestar",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2007"
      },
      {
        "id": "sportka",
        "name": "SportKa",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2008"
      },
      {
        "id": "streetka",
        "name": "StreetKa",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2006"
      },
      {
        "id": "five-hundred",
        "name": "Five Hundred",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2007"
      },
      {
        "id": "freestyle",
        "name": "Freestyle",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2007"
      },
      {
        "id": "fusion-north-american",
        "name": "Fusion North American",
        "fuel": "Gasolina / Híbrid / Etanol",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "9",
        "years": "2005–2020"
      },
      {
        "id": "scorpio-sedan",
        "name": "Scorpio Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1990–1997"
      },
      {
        "id": "scorpio-wagon",
        "name": "Scorpio Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–1997"
      },
      {
        "id": "flex",
        "name": "Flex",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2019"
      },
      {
        "id": "fiesta-sedan",
        "name": "Fiesta Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2017"
      },
      {
        "id": "focus-st-wagon",
        "name": "Focus ST Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2014"
      },
      {
        "id": "ka",
        "name": "Ka+",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2019"
      },
      {
        "id": "ka-active",
        "name": "Ka+ Active",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2019"
      },
      {
        "id": "edge-st",
        "name": "Edge ST",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2024"
      },
      {
        "id": "excursion",
        "name": "Excursion",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2005"
      },
      {
        "id": "ranger-regular-cab",
        "name": "Ranger Regular Cab",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2000–2017"
      },
      {
        "id": "ranger-super-cab",
        "name": "Ranger Super Cab",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2000–2017"
      },
      {
        "id": "raptor-ranger",
        "name": "Raptor Ranger",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2022"
      },
      {
        "id": "territory",
        "name": "Territory",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2022"
      },
      {
        "id": "tourneo",
        "name": "Tourneo",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "2003–2024"
      },
      {
        "id": "transit-connect-wagon",
        "name": "Transit Connect Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2023"
      },
      {
        "id": "transit-custom",
        "name": "Transit Custom",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2023"
      }
    ]
  },
  {
    "id": "gac",
    "name": "GAC",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "aion-ut",
        "name": "AION UT",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.270",
        "width": "1.850",
        "height": "1.575",
        "trunk": "440–1.600",
        "price": "30.995€"
      }
    ]
  },
  {
    "id": "geely",
    "name": "Geely",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "e2",
        "name": "E2",
        "fuel": "Elèctric",
        "power": "80 / 115",
        "length": "4.135",
        "width": "1.805",
        "height": "1.580",
        "trunk": "375–1.320",
        "price": "20.990€"
      },
      {
        "id": "e5",
        "name": "E5",
        "fuel": "Elèctric",
        "power": "218",
        "length": "4.615",
        "width": "1.901",
        "height": "1.670",
        "trunk": "461",
        "price": "37.490€"
      },
      {
        "id": "monjaro-em-i",
        "name": "Monjaro EM-i",
        "fuel": "PHEV",
        "power": "334",
        "length": "4.800",
        "width": "1.895",
        "height": "1.700",
        "trunk": "633–2.183",
        "price": "37.990€"
      },
      {
        "id": "starray-em-i",
        "name": "Starray EM-i",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.740",
        "width": "1.905",
        "height": "1.685",
        "trunk": "528–2.065",
        "price": "33.490€"
      }
    ]
  },
  {
    "id": "genesis",
    "name": "Genesis",
    "logo": "🅖",
    "description": "Luxury Redefined",
    "models": [
      {
        "id": "gv80",
        "name": "GV80",
        "fuel": "Dièsel",
        "power": "278",
        "length": "4.945",
        "width": "1.975",
        "height": "1.715",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ]
  },
  {
    "id": "gwm",
    "name": "GWM",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "ora-5",
        "name": "Ora 5",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.471",
        "width": "1.833",
        "height": "1.641",
        "trunk": "422–1.120",
        "price": "26.950€"
      },
      {
        "id": "ora-5",
        "name": "Ora 5",
        "fuel": "Gasolina",
        "power": "160",
        "length": "4.471",
        "width": "1.833",
        "height": "1.641",
        "trunk": "422–1.120",
        "price": "26.950€"
      },
      {
        "id": "ora-5",
        "name": "Ora 5",
        "fuel": "Híbrid",
        "power": "223",
        "length": "4.471",
        "width": "1.833",
        "height": "1.641",
        "trunk": "390–1.088",
        "price": "26.950€"
      }
    ]
  },
  {
    "id": "hispano-suiza",
    "name": "Hispano Suiza",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "carmen",
        "name": "Carmen",
        "fuel": "Elèctric",
        "power": "1019",
        "length": "4.733",
        "width": "2.040",
        "height": "1.242",
        "trunk": "N.D.",
        "price": "1.815.000€"
      },
      {
        "id": "carmen-boulogne",
        "name": "Carmen Boulogne",
        "fuel": "Elèctric",
        "power": "1114",
        "length": "4.733",
        "width": "2.040",
        "height": "1.242",
        "trunk": "N.D.",
        "price": "1.815.000€"
      }
    ]
  },
  {
    "id": "honda",
    "name": "Honda",
    "logo": "🅷",
    "description": "The Power of Dreams",
    "models": [
      {
        "id": "civic",
        "name": "Civic",
        "fuel": "Híbrid",
        "power": "184",
        "length": "4.551",
        "width": "1.802",
        "height": "1.408",
        "trunk": "410–1.220",
        "price": "35.000€"
      },
      {
        "id": "civic-type-r",
        "name": "Civic Type R",
        "fuel": "Gasolina",
        "power": "329",
        "length": "4.594",
        "width": "1.890",
        "height": "1.407",
        "trunk": "410–1.212",
        "price": "35.000€"
      },
      {
        "id": "cr-v",
        "name": "CR-V",
        "fuel": "Híbrid",
        "power": "184",
        "length": "4.706",
        "width": "1.866",
        "height": "1.674",
        "trunk": "587–1.651",
        "price": "51.545€"
      },
      {
        "id": "cr-v",
        "name": "CR-V",
        "fuel": "PHEV",
        "power": "184",
        "length": "4.706",
        "width": "1.866",
        "height": "1.673",
        "trunk": "617–1.728",
        "price": "51.545€"
      },
      {
        "id": "crosstar",
        "name": "Crosstar",
        "fuel": "Híbrid",
        "power": "122",
        "length": "4.105",
        "width": "1.725",
        "height": "1.556",
        "trunk": "304–1.205",
        "price": "27.050€"
      },
      {
        "id": "e",
        "name": "e",
        "fuel": "Elèctric",
        "power": "136 / 154",
        "length": "3.895",
        "width": "1.750",
        "height": "1.512",
        "trunk": "171–861",
        "price": "33.300€"
      },
      {
        "id": "eny1",
        "name": "e:Ny1",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.387",
        "width": "1.790",
        "height": "1.584",
        "trunk": "361–1.176",
        "price": "50.400€"
      },
      {
        "id": "h-rv",
        "name": "H-RV",
        "fuel": "Híbrid",
        "power": "131",
        "length": "4.355",
        "width": "1.790",
        "height": "1.582",
        "trunk": "335–1.289",
        "price": "32.460€"
      },
      {
        "id": "jazz",
        "name": "Jazz",
        "fuel": "Híbrid",
        "power": "109",
        "length": "4.044",
        "width": "1.694",
        "height": "1.526",
        "trunk": "304–1.205",
        "price": "27.050€"
      },
      {
        "id": "zr-v",
        "name": "ZR-V",
        "fuel": "Híbrid",
        "power": "184",
        "length": "4.568",
        "width": "1.840",
        "height": "1.613",
        "trunk": "380–1.322",
        "price": "N.D.€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "l700",
        "name": "L700",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1967"
      },
      {
        "id": "s500",
        "name": "S500",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1963–1964"
      },
      {
        "id": "s600",
        "name": "S600",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1964–1966"
      },
      {
        "id": "s800",
        "name": "S800",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1966–1970"
      },
      {
        "id": "s800c",
        "name": "S800C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1966–1970"
      },
      {
        "id": "n360",
        "name": "N360",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1967–1972"
      },
      {
        "id": "n600",
        "name": "N600",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1972"
      },
      {
        "id": "1300-sedan",
        "name": "1300 Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1973"
      },
      {
        "id": "1300-coupe",
        "name": "1300 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1970–1973"
      },
      {
        "id": "civic-3-doors",
        "name": "Civic 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "11",
        "years": "1972–2011"
      },
      {
        "id": "accord-3-doors",
        "name": "Accord 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1976–1985"
      },
      {
        "id": "jazz-city",
        "name": "Jazz / City",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1983–1986"
      },
      {
        "id": "civic-shuttle",
        "name": "Civic Shuttle",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1987–1993"
      },
      {
        "id": "legend-sedan",
        "name": "Legend Sedan",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1987–2017"
      },
      {
        "id": "legend-coupe",
        "name": "Legend Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1988–1996"
      },
      {
        "id": "civic-crx",
        "name": "Civic CRX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1993"
      },
      {
        "id": "concerto",
        "name": "Concerto",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1994"
      },
      {
        "id": "beat",
        "name": "Beat",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1996"
      },
      {
        "id": "nsx",
        "name": "NSX",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1991–2021"
      },
      {
        "id": "crx-del-sol",
        "name": "CRX Del Sol",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1997"
      },
      {
        "id": "accord-tourer",
        "name": "Accord Tourer",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1993–2012"
      },
      {
        "id": "accord-coupe",
        "name": "Accord Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1994–2016"
      },
      {
        "id": "logo-fit",
        "name": "Logo / Fit",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2001"
      },
      {
        "id": "civic-coupe",
        "name": "Civic Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "13",
        "years": "1994–2020"
      },
      {
        "id": "accord-euro",
        "name": "Accord Euro",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1998–2010"
      },
      {
        "id": "accord-type-r",
        "name": "Accord Type R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2005"
      },
      {
        "id": "civic-aero-deck",
        "name": "Civic Aero Deck",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2001"
      },
      {
        "id": "hr-v-3-doors",
        "name": "HR-V 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1999–2006"
      },
      {
        "id": "insight",
        "name": "Insight",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1999–2022"
      },
      {
        "id": "s2000",
        "name": "S2000",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2009"
      },
      {
        "id": "avancier",
        "name": "Avancier",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2003"
      },
      {
        "id": "stream",
        "name": "Stream",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2009"
      },
      {
        "id": "mobilio",
        "name": "Mobilio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2008"
      },
      {
        "id": "shuttle",
        "name": "Shuttle",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2001"
      },
      {
        "id": "element",
        "name": "Element",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2011"
      },
      {
        "id": "fr-v-edix",
        "name": "FR-V / Edix",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2011"
      },
      {
        "id": "airwave",
        "name": "Airwave",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2010"
      },
      {
        "id": "civic-sedan-us",
        "name": "Civic Sedan US",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2005–2012"
      },
      {
        "id": "clarity",
        "name": "Clarity",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2014"
      },
      {
        "id": "accord-crosstour",
        "name": "Accord Crosstour",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2016"
      },
      {
        "id": "cr-z",
        "name": "CR-Z",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2016"
      },
      {
        "id": "fit-ev",
        "name": "Fit EV",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2014"
      },
      {
        "id": "civic-tourer",
        "name": "Civic Tourer",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2017"
      },
      {
        "id": "s660",
        "name": "S660",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2022"
      },
      {
        "id": "thats",
        "name": "That's",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2007"
      },
      {
        "id": "mdx",
        "name": "MDX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2006"
      }
    ]
  },
  {
    "id": "hyundai",
    "name": "Hyundai",
    "logo": "🅗",
    "description": "New Thinking New Possibilities",
    "models": [
      {
        "id": "bayon",
        "name": "Bayon",
        "fuel": "Gasolina",
        "power": "79",
        "length": "4.180",
        "width": "1.775",
        "height": "1.500",
        "trunk": "411–1.205",
        "price": "23.455€"
      },
      {
        "id": "bayon",
        "name": "Bayon",
        "fuel": "Híbrid",
        "power": "100",
        "length": "4.180",
        "width": "1.775",
        "height": "1.500",
        "trunk": "334–1.128",
        "price": "23.455€"
      },
      {
        "id": "i10",
        "name": "i10",
        "fuel": "Gasolina",
        "power": "66 / 67 / 84 / 87",
        "length": "3.670",
        "width": "1.680",
        "height": "1.480",
        "trunk": "252–1.050",
        "price": "12.315€"
      },
      {
        "id": "i20",
        "name": "i20",
        "fuel": "Gasolina",
        "power": "84 / 100",
        "length": "4.065",
        "width": "1.775",
        "height": "1.450",
        "trunk": "351",
        "price": "19.640€"
      },
      {
        "id": "i20",
        "name": "i20",
        "fuel": "Híbrid",
        "power": "100",
        "length": "4.065",
        "width": "1.775",
        "height": "1.450",
        "trunk": "351",
        "price": "19.640€"
      },
      {
        "id": "i30",
        "name": "i30",
        "fuel": "Gasolina",
        "power": "110 / 120",
        "length": "4.340",
        "width": "1.795",
        "height": "1.455",
        "trunk": "395–1.301",
        "price": "22.420€"
      },
      {
        "id": "i30",
        "name": "i30",
        "fuel": "Híbrid",
        "power": "120 / 160",
        "length": "4.340",
        "width": "1.795",
        "height": "1.455",
        "trunk": "395–1.301",
        "price": "22.420€"
      },
      {
        "id": "i30-cw",
        "name": "i30 CW",
        "fuel": "Gasolina",
        "power": "120",
        "length": "4.585",
        "width": "1.795",
        "height": "1.465",
        "trunk": "602–1.650",
        "price": "22.420€"
      },
      {
        "id": "i30-cw",
        "name": "i30 CW",
        "fuel": "Híbrid",
        "power": "120 / 160",
        "length": "4.585",
        "width": "1.795",
        "height": "1.465",
        "trunk": "602–1.650",
        "price": "22.420€"
      },
      {
        "id": "i30-fastback",
        "name": "i30 Fastback",
        "fuel": "Gasolina",
        "power": "120",
        "length": "4.455",
        "width": "1.795",
        "height": "1.425",
        "trunk": "450–1.351",
        "price": "22.420€"
      },
      {
        "id": "i30-fastback",
        "name": "i30 Fastback",
        "fuel": "Híbrid",
        "power": "117 / 157",
        "length": "4.455",
        "width": "1.795",
        "height": "1.425",
        "trunk": "450–1.351",
        "price": "22.420€"
      },
      {
        "id": "i30-n",
        "name": "i30 N",
        "fuel": "Gasolina",
        "power": "250 / 280",
        "length": "4.340",
        "width": "1.795",
        "height": "1.455",
        "trunk": "381–1.284",
        "price": "22.420€"
      },
      {
        "id": "i30-n-fastback",
        "name": "i30 N Fastback",
        "fuel": "Gasolina",
        "power": "280",
        "length": "4.455",
        "width": "1.795",
        "height": "1.419",
        "trunk": "381–1.284",
        "price": "22.420€"
      },
      {
        "id": "i40-berlina",
        "name": "i40 Berlina",
        "fuel": "Dièsel",
        "power": "115 / 141",
        "length": "4.745",
        "width": "1.815",
        "height": "1.470",
        "trunk": "505",
        "price": "23.865€"
      },
      {
        "id": "i40-berlina",
        "name": "i40 Berlina",
        "fuel": "Gasolina",
        "power": "135",
        "length": "4.745",
        "width": "1.815",
        "height": "1.470",
        "trunk": "505",
        "price": "23.865€"
      },
      {
        "id": "i40-cw",
        "name": "i40 CW",
        "fuel": "Dièsel",
        "power": "115 / 141",
        "length": "4.775",
        "width": "1.815",
        "height": "1.470",
        "trunk": "553–1.719",
        "price": "23.865€"
      },
      {
        "id": "inster",
        "name": "Inster",
        "fuel": "Elèctric",
        "power": "97 / 115",
        "length": "3.825",
        "width": "1.610",
        "height": "1.575",
        "trunk": "280–1.059",
        "price": "24.990€"
      },
      {
        "id": "ioniq",
        "name": "Ioniq",
        "fuel": "Elèctric",
        "power": "136",
        "length": "4.470",
        "width": "1.820",
        "height": "1.475",
        "trunk": "455–1.410",
        "price": "27.045€"
      },
      {
        "id": "ioniq",
        "name": "Ioniq",
        "fuel": "Híbrid",
        "power": "141",
        "length": "4.470",
        "width": "1.820",
        "height": "1.450",
        "trunk": "563–1.518",
        "price": "27.045€"
      },
      {
        "id": "ioniq",
        "name": "Ioniq",
        "fuel": "PHEV",
        "power": "141",
        "length": "4.470",
        "width": "1.820",
        "height": "1.450",
        "trunk": "446–1.401",
        "price": "27.045€"
      },
      {
        "id": "ioniq-3",
        "name": "IONIQ 3",
        "fuel": "Elèctric",
        "power": "135 / 147",
        "length": "4.155",
        "width": "1.800",
        "height": "1.505",
        "trunk": "441–1.213",
        "price": "29.995€"
      },
      {
        "id": "ioniq-5",
        "name": "IONIQ 5",
        "fuel": "Elèctric",
        "power": "170 / 228 / 305",
        "length": "4.635",
        "width": "1.890",
        "height": "1.605",
        "trunk": "527–1.587",
        "price": "48.520€"
      },
      {
        "id": "ioniq-6",
        "name": "IONIQ 6",
        "fuel": "Elèctric",
        "power": "170 / 325",
        "length": "4.925",
        "width": "1.880",
        "height": "1.495",
        "trunk": "401",
        "price": "44.650€"
      },
      {
        "id": "ioniq-9",
        "name": "IONIQ 9",
        "fuel": "Elèctric",
        "power": "218 / 313",
        "length": "5.060",
        "width": "1.980",
        "height": "1.790",
        "trunk": "908–2.419",
        "price": "69.900€"
      },
      {
        "id": "kona",
        "name": "Kona",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.355",
        "width": "1.825",
        "height": "1.580",
        "trunk": "466–1.300",
        "price": "28.490€"
      },
      {
        "id": "kona",
        "name": "Kona",
        "fuel": "Gasolina",
        "power": "120 / 198",
        "length": "4.350",
        "width": "1.825",
        "height": "1.570",
        "trunk": "466–1.300",
        "price": "28.490€"
      },
      {
        "id": "kona",
        "name": "Kona",
        "fuel": "Híbrid",
        "power": "120 / 141",
        "length": "4.350",
        "width": "1.825",
        "height": "1.570",
        "trunk": "466–1.300",
        "price": "28.490€"
      },
      {
        "id": "nexo",
        "name": "Nexo",
        "fuel": "Elèctric",
        "power": "240",
        "length": "4.750",
        "width": "1.640",
        "height": "1.865",
        "trunk": "510–1.630",
        "price": "69.000€"
      },
      {
        "id": "santa-fe",
        "name": "Santa Fe",
        "fuel": "Híbrid",
        "power": "215",
        "length": "4.830",
        "width": "1.900",
        "height": "1.770",
        "trunk": "N.D.",
        "price": "57.020€"
      },
      {
        "id": "santa-fe",
        "name": "Santa Fe",
        "fuel": "PHEV",
        "power": "253",
        "length": "4.830",
        "width": "1.900",
        "height": "1.720",
        "trunk": "N.D.",
        "price": "57.020€"
      },
      {
        "id": "staria",
        "name": "Staria",
        "fuel": "Híbrid",
        "power": "225",
        "length": "5.253",
        "width": "1.997",
        "height": "1.990",
        "trunk": "117–831",
        "price": "48.640€"
      },
      {
        "id": "tucson",
        "name": "Tucson",
        "fuel": "Dièsel",
        "power": "116",
        "length": "4.500",
        "width": "1.865",
        "height": "1.650",
        "trunk": "598–1.777",
        "price": "30.325€"
      },
      {
        "id": "tucson",
        "name": "Tucson",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.500",
        "width": "1.865",
        "height": "1.650",
        "trunk": "620–1.799",
        "price": "30.325€"
      },
      {
        "id": "tucson",
        "name": "Tucson",
        "fuel": "Híbrid",
        "power": "136 / 150 / 160 / 230",
        "length": "4.510",
        "width": "1.865",
        "height": "1.650",
        "trunk": "577",
        "price": "30.325€"
      },
      {
        "id": "tucson",
        "name": "Tucson",
        "fuel": "PHEV",
        "power": "265",
        "length": "4.500",
        "width": "1.865",
        "height": "1.650",
        "trunk": "558–1.737",
        "price": "30.325€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "scoupe",
        "name": "Scoupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1990–1996"
      },
      {
        "id": "lantra",
        "name": "Lantra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1991–2000"
      },
      {
        "id": "pony-3-doors",
        "name": "Pony 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1994"
      },
      {
        "id": "pony-5-doors",
        "name": "Pony 5 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1994"
      },
      {
        "id": "excel-sedan",
        "name": "Excel Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1989–2000"
      },
      {
        "id": "excel-3-doors",
        "name": "Excel 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2000"
      },
      {
        "id": "excel-5-doors",
        "name": "Excel 5 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2000"
      },
      {
        "id": "accent-3-doors",
        "name": "Accent 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1999–2011"
      },
      {
        "id": "accent-5-doors",
        "name": "Accent 5 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1999–2017"
      },
      {
        "id": "accent-sedan",
        "name": "Accent Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1999–2023"
      },
      {
        "id": "xg",
        "name": "XG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1999–2005"
      },
      {
        "id": "atos-multi",
        "name": "Atos Multi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2003"
      },
      {
        "id": "atos-spirit",
        "name": "Atos Spirit",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2003"
      },
      {
        "id": "atos",
        "name": "Atos",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2008"
      },
      {
        "id": "coupe-tiburon",
        "name": "Coupe / Tiburon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1996–2009"
      },
      {
        "id": "lantra-wagon",
        "name": "Lantra Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2001"
      },
      {
        "id": "satellite",
        "name": "Satellite",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1997–2000"
      },
      {
        "id": "trajet",
        "name": "Trajet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2000–2008"
      },
      {
        "id": "matrix",
        "name": "Matrix",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2010"
      },
      {
        "id": "terracan",
        "name": "Terracan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2007"
      },
      {
        "id": "getz-3-doors",
        "name": "Getz 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2011"
      },
      {
        "id": "getz-5-doors",
        "name": "Getz 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2011"
      },
      {
        "id": "elantra-5-doors",
        "name": "Elantra 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2015"
      },
      {
        "id": "genesis",
        "name": "Genesis",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2016"
      },
      {
        "id": "genesis-coupe",
        "name": "Genesis Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2016"
      },
      {
        "id": "i800-h-1",
        "name": "i800 / H-1",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2018"
      },
      {
        "id": "ix55-veracruz",
        "name": "ix55 / Veracruz",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2012"
      },
      {
        "id": "elantra-touring",
        "name": "Elantra Touring",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2012"
      },
      {
        "id": "ix20",
        "name": "ix20",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2010–2019"
      },
      {
        "id": "sonata-hybrid",
        "name": "Sonata Hybrid",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2010–2019"
      },
      {
        "id": "equus",
        "name": "Equus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2010–2016"
      },
      {
        "id": "veloster",
        "name": "Veloster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2011–2021"
      },
      {
        "id": "i40",
        "name": "i40",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2018"
      },
      {
        "id": "i30-coupe",
        "name": "i30 Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2015"
      },
      {
        "id": "elantra-coupe",
        "name": "Elantra Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2014"
      },
      {
        "id": "elantra-gt",
        "name": "Elantra GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2012–2020"
      },
      {
        "id": "i40-wagon",
        "name": "i40 Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2020"
      },
      {
        "id": "i20-coupe",
        "name": "i20 Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2018"
      },
      {
        "id": "i20-active",
        "name": "i20 Active",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2015–2020"
      },
      {
        "id": "mistra",
        "name": "Mistra",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2017"
      },
      {
        "id": "kona-n",
        "name": "Kona N",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2021–2023"
      }
    ]
  },
  {
    "id": "ineos",
    "name": "INEOS",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "grenadier-quartermaster",
        "name": "Grenadier Quartermaster",
        "fuel": "Dièsel",
        "power": "249",
        "length": "5.440",
        "width": "2.146",
        "height": "2.019",
        "trunk": "N.D.",
        "price": "73.943€"
      },
      {
        "id": "grenadier-quartermaster",
        "name": "Grenadier Quartermaster",
        "fuel": "Gasolina",
        "power": "286",
        "length": "5.440",
        "width": "2.146",
        "height": "2.019",
        "trunk": "N.D.",
        "price": "83.343€"
      },
      {
        "id": "grenadier-sation-wagon",
        "name": "Grenadier Sation Wagon",
        "fuel": "Dièsel",
        "power": "249",
        "length": "4.895",
        "width": "2.146",
        "height": "2.050",
        "trunk": "N.D.",
        "price": "73.243€"
      },
      {
        "id": "grenadier-sation-wagon",
        "name": "Grenadier Sation Wagon",
        "fuel": "Gasolina",
        "power": "286",
        "length": "4.895",
        "width": "2.146",
        "height": "2.050",
        "trunk": "N.D.",
        "price": "73.243€"
      },
      {
        "id": "grenadier-utility-wagon",
        "name": "Grenadier Utility Wagon",
        "fuel": "Dièsel",
        "power": "249",
        "length": "4.895",
        "width": "2.146",
        "height": "2.050",
        "trunk": "N.D.",
        "price": "73.243€"
      },
      {
        "id": "grenadier-utility-wagon",
        "name": "Grenadier Utility Wagon",
        "fuel": "Gasolina",
        "power": "286",
        "length": "4.895",
        "width": "2.146",
        "height": "2.050",
        "trunk": "N.D.",
        "price": "73.243€"
      }
    ]
  },
  {
    "id": "isuzu",
    "name": "Isuzu",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "d-max",
        "name": "D-Max",
        "fuel": "Dièsel",
        "power": "164",
        "length": "5.280",
        "width": "1.870",
        "height": "1.495",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ]
  },
  {
    "id": "jaecoo",
    "name": "Jaecoo",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "5",
        "name": "5",
        "fuel": "Gasolina",
        "power": "145",
        "length": "4.380",
        "width": "1.860",
        "height": "1.650",
        "trunk": "N.D.",
        "price": "27.500€"
      },
      {
        "id": "7",
        "name": "7",
        "fuel": "Gasolina",
        "power": "145",
        "length": "4.500",
        "width": "1.865",
        "height": "1.680",
        "trunk": "424–1.349",
        "price": "33.900€"
      },
      {
        "id": "7",
        "name": "7",
        "fuel": "PHEV",
        "power": "340",
        "length": "4.500",
        "width": "1.865",
        "height": "1.680",
        "trunk": "N.D.",
        "price": "33.900€"
      },
      {
        "id": "8-shs",
        "name": "8 SHS",
        "fuel": "PHEV",
        "power": "428",
        "length": "4.820",
        "width": "1.930",
        "height": "1.710",
        "trunk": "488",
        "price": "52.900€"
      }
    ]
  },
  {
    "id": "jaguar",
    "name": "Jaguar",
    "logo": "🐆",
    "description": "Grace, Space, Pace",
    "models": [
      {
        "id": "f-pace",
        "name": "F-PACE",
        "fuel": "Gasolina",
        "power": "550",
        "length": "4.762",
        "width": "2.175",
        "height": "1.670",
        "trunk": "613–1.440",
        "price": "120.220€"
      },
      {
        "id": "f-type",
        "name": "F-TYPE",
        "fuel": "Gasolina",
        "power": "300 / 450 / 575",
        "length": "4.470",
        "width": "2.042",
        "height": "1.311",
        "trunk": "299–509",
        "price": "65.700€"
      },
      {
        "id": "f-type-coupe",
        "name": "F-Type Coupe",
        "fuel": "Gasolina",
        "power": "300 / 340 / 380",
        "length": "4.482",
        "width": "1.923",
        "height": "1.310",
        "trunk": "310–408",
        "price": "65.700€"
      },
      {
        "id": "f-type-coupe-r",
        "name": "F-Type Coupe R",
        "fuel": "Gasolina",
        "power": "550 / 575",
        "length": "4.475",
        "width": "1.923",
        "height": "1.314",
        "trunk": "315–407",
        "price": "65.700€"
      },
      {
        "id": "f-type-roadster",
        "name": "F-Type Roadster",
        "fuel": "Gasolina",
        "power": "300 / 340 / 380",
        "length": "4.470",
        "width": "1.923",
        "height": "1.308",
        "trunk": "196",
        "price": "65.700€"
      },
      {
        "id": "f-type-roadster-r",
        "name": "F-Type Roadster R",
        "fuel": "Gasolina",
        "power": "550 / 575",
        "length": "4.475",
        "width": "1.923",
        "height": "1.308",
        "trunk": "207",
        "price": "65.700€"
      },
      {
        "id": "i-pace",
        "name": "I-Pace",
        "fuel": "Elèctric",
        "power": "400",
        "length": "4.682",
        "width": "1.895",
        "height": "1.565",
        "trunk": "505–1.163",
        "price": "88.400€"
      },
      {
        "id": "xj",
        "name": "XJ",
        "fuel": "Dièsel",
        "power": "300",
        "length": "5.130",
        "width": "1.899",
        "height": "1.460",
        "trunk": "520",
        "price": "94.300€"
      },
      {
        "id": "xj",
        "name": "XJ",
        "fuel": "Gasolina",
        "power": "340",
        "length": "5.130",
        "width": "1.899",
        "height": "1.460",
        "trunk": "520",
        "price": "94.300€"
      },
      {
        "id": "xj-l",
        "name": "XJ L",
        "fuel": "Dièsel",
        "power": "300",
        "length": "5.255",
        "width": "1.899",
        "height": "1.460",
        "trunk": "520",
        "price": "94.300€"
      },
      {
        "id": "xj-l",
        "name": "XJ L",
        "fuel": "Gasolina",
        "power": "340",
        "length": "5.255",
        "width": "1.899",
        "height": "1.460",
        "trunk": "520",
        "price": "94.300€"
      },
      {
        "id": "xj-r",
        "name": "XJ R",
        "fuel": "Gasolina",
        "power": "550",
        "length": "5.130",
        "width": "1.899",
        "height": "1.460",
        "trunk": "520",
        "price": "94.300€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "xjr",
        "name": "XJR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1990–2019"
      },
      {
        "id": "xj220",
        "name": "XJ220",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1994"
      },
      {
        "id": "xk",
        "name": "XK",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1996–2014"
      },
      {
        "id": "xk-convertible",
        "name": "XK Convertible",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1996–2014"
      },
      {
        "id": "xkr",
        "name": "XKR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1998–2014"
      },
      {
        "id": "xkr-convertible",
        "name": "XKR Convertible",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1998–2014"
      },
      {
        "id": "s-type",
        "name": "S-Type",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1999–2007"
      },
      {
        "id": "x-type",
        "name": "X-Type",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2009"
      },
      {
        "id": "s-type-r",
        "name": "S-Type R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2007"
      },
      {
        "id": "x-type-estate",
        "name": "X-Type Estate",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2009"
      },
      {
        "id": "xfr",
        "name": "XFR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2011"
      },
      {
        "id": "xe",
        "name": "XE",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2015–2024"
      },
      {
        "id": "xe-sv",
        "name": "XE SV",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2019"
      },
      {
        "id": "e-pace",
        "name": "E-Pace",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2024"
      },
      {
        "id": "f-type-svr",
        "name": "F-Type SVR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2020"
      },
      {
        "id": "f-type-svr-coupe",
        "name": "F-Type SVR Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2020"
      }
    ]
  },
  {
    "id": "jeep",
    "name": "Jeep",
    "logo": "🚜",
    "description": "Go Anywhere, Do Anything",
    "models": [
      {
        "id": "avenger",
        "name": "Avenger",
        "fuel": "Elèctric",
        "power": "136 / 156",
        "length": "4.088",
        "width": "1.776",
        "height": "1.541",
        "trunk": "218–325",
        "price": "23.300€"
      },
      {
        "id": "avenger",
        "name": "Avenger",
        "fuel": "Gasolina",
        "power": "100",
        "length": "4.084",
        "width": "1.776",
        "height": "1.528",
        "trunk": "380",
        "price": "23.300€"
      },
      {
        "id": "avenger",
        "name": "Avenger",
        "fuel": "Híbrid",
        "power": "100",
        "length": "4.084",
        "width": "1.776",
        "height": "1.528",
        "trunk": "380",
        "price": "23.300€"
      },
      {
        "id": "gladiator",
        "name": "Gladiator",
        "fuel": "Dièsel",
        "power": "264",
        "length": "5.591",
        "width": "1.894",
        "height": "1.843",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "grand-cherokee",
        "name": "Grand Cherokee",
        "fuel": "PHEV",
        "power": "380",
        "length": "4.914",
        "width": "1.968",
        "height": "1.795",
        "trunk": "533–1.463",
        "price": "83.250€"
      },
      {
        "id": "renegade",
        "name": "Renegade",
        "fuel": "Dièsel",
        "power": "130",
        "length": "4.236",
        "width": "1.805",
        "height": "1.667",
        "trunk": "351–1.297",
        "price": "23.000€"
      },
      {
        "id": "renegade",
        "name": "Renegade",
        "fuel": "Gasolina",
        "power": "120",
        "length": "4.236",
        "width": "1.805",
        "height": "1.667",
        "trunk": "351–1.297",
        "price": "23.000€"
      },
      {
        "id": "renegade",
        "name": "Renegade",
        "fuel": "Híbrid",
        "power": "130",
        "length": "4.236",
        "width": "1.805",
        "height": "1.684",
        "trunk": "351–1.297",
        "price": "23.000€"
      },
      {
        "id": "renegade",
        "name": "Renegade",
        "fuel": "PHEV",
        "power": "190 / 240",
        "length": "4.236",
        "width": "1.805",
        "height": "1.718",
        "trunk": "330–1.277",
        "price": "23.000€"
      },
      {
        "id": "wrangler-4xe",
        "name": "Wrangler 4xe",
        "fuel": "PHEV",
        "power": "380",
        "length": "4.882",
        "width": "1.894",
        "height": "1.838",
        "trunk": "533–1.910",
        "price": "68.900€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "cherokeeliberty",
        "name": "Cherokee/Liberty",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1984–2012"
      },
      {
        "id": "wrangler-unlimited",
        "name": "Wrangler Unlimited",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2004–2024"
      },
      {
        "id": "commander",
        "name": "Commander",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2010"
      },
      {
        "id": "patriot",
        "name": "Patriot",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2014"
      }
    ]
  },
  {
    "id": "kgm",
    "name": "KGM",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "korando",
        "name": "Korando",
        "fuel": "Dièsel",
        "power": "136",
        "length": "4.550",
        "width": "1.870",
        "height": "1.620",
        "trunk": "551–1.248",
        "price": "21.300€"
      },
      {
        "id": "korando",
        "name": "Korando",
        "fuel": "Elèctric",
        "power": "N.D.",
        "length": "4.465",
        "width": "1.870",
        "height": "1.635",
        "trunk": "420–1.250",
        "price": "21.300€"
      },
      {
        "id": "korando",
        "name": "Korando",
        "fuel": "Gasolina",
        "power": "149 / 163",
        "length": "4.550",
        "width": "1.870",
        "height": "1.620",
        "trunk": "551–1.248",
        "price": "21.300€"
      },
      {
        "id": "korando",
        "name": "Korando",
        "fuel": "GLP",
        "power": "149 / 163",
        "length": "4.550",
        "width": "1.870",
        "height": "1.620",
        "trunk": "551–1.248",
        "price": "21.300€"
      },
      {
        "id": "musso",
        "name": "Musso",
        "fuel": "Dièsel",
        "power": "202",
        "length": "5.150",
        "width": "1.950",
        "height": "1.840",
        "trunk": "N.D.",
        "price": "32.500€"
      },
      {
        "id": "musso-evx",
        "name": "Musso EVX",
        "fuel": "Elèctric",
        "power": "207 / 237",
        "length": "5.160",
        "width": "1.920",
        "height": "1.740",
        "trunk": "N.D.",
        "price": "36.179€"
      },
      {
        "id": "rexton",
        "name": "Rexton",
        "fuel": "Dièsel",
        "power": "202",
        "length": "4.850",
        "width": "1.960",
        "height": "1.825",
        "trunk": "N.D.",
        "price": "37.200€"
      },
      {
        "id": "ssangyong-torres",
        "name": "SsangYong Torres",
        "fuel": "Gasolina",
        "power": "163",
        "length": "4.700",
        "width": "1.890",
        "height": "1.710",
        "trunk": "839–1.660",
        "price": "34.000€"
      },
      {
        "id": "ssangyong-torres",
        "name": "SsangYong Torres",
        "fuel": "Híbrid",
        "power": "204",
        "length": "4.705",
        "width": "1.890",
        "height": "1.720",
        "trunk": "839–1.662",
        "price": "34.000€"
      },
      {
        "id": "tivoli",
        "name": "Tivoli",
        "fuel": "Dièsel",
        "power": "136",
        "length": "4.225",
        "width": "1.810",
        "height": "1.613",
        "trunk": "427–1.115",
        "price": "17.100€"
      },
      {
        "id": "tivoli",
        "name": "Tivoli",
        "fuel": "Gasolina",
        "power": "128 / 163",
        "length": "4.225",
        "width": "1.810",
        "height": "1.613",
        "trunk": "427–1.115",
        "price": "17.100€"
      },
      {
        "id": "tivoli",
        "name": "Tivoli",
        "fuel": "GLP",
        "power": "128 / 163",
        "length": "4.225",
        "width": "1.810",
        "height": "1.613",
        "trunk": "427–1.115",
        "price": "17.100€"
      },
      {
        "id": "tivoli-grand",
        "name": "Tivoli Grand",
        "fuel": "Gasolina",
        "power": "163",
        "length": "4.480",
        "width": "1.810",
        "height": "1.646",
        "trunk": "574–1.440",
        "price": "19.900€"
      },
      {
        "id": "tivoli-grand",
        "name": "Tivoli Grand",
        "fuel": "GLP",
        "power": "163",
        "length": "4.480",
        "width": "1.810",
        "height": "1.646",
        "trunk": "574–1.440",
        "price": "19.900€"
      },
      {
        "id": "torres-evx",
        "name": "Torres EVX",
        "fuel": "Elèctric",
        "power": "207",
        "length": "4.715",
        "width": "1.890",
        "height": "1.715",
        "trunk": "839–1.662",
        "price": "34.000€"
      }
    ]
  },
  {
    "id": "kia",
    "name": "KIA",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "carens",
        "name": "Carens",
        "fuel": "Dièsel",
        "power": "115 / 141",
        "length": "4.525",
        "width": "1.805",
        "height": "1.610",
        "trunk": "536–1.694",
        "price": "20.750€"
      },
      {
        "id": "carens",
        "name": "Carens",
        "fuel": "Gasolina",
        "power": "135",
        "length": "4.525",
        "width": "1.805",
        "height": "1.610",
        "trunk": "536–1.694",
        "price": "20.750€"
      },
      {
        "id": "ceed",
        "name": "Ceed",
        "fuel": "Gasolina",
        "power": "120 / 204",
        "length": "4.315",
        "width": "1.800",
        "height": "1.442",
        "trunk": "395–1.291",
        "price": "20.100€"
      },
      {
        "id": "ceed",
        "name": "Ceed",
        "fuel": "Híbrid",
        "power": "120 / 136 / 160",
        "length": "4.315",
        "width": "1.800",
        "height": "1.442",
        "trunk": "357–1.253",
        "price": "20.100€"
      },
      {
        "id": "ceed-tourer",
        "name": "Ceed Tourer",
        "fuel": "Gasolina",
        "power": "120 / 160",
        "length": "4.600",
        "width": "1.800",
        "height": "1.465",
        "trunk": "1.349–1.475",
        "price": "20.100€"
      },
      {
        "id": "ceed-tourer",
        "name": "Ceed Tourer",
        "fuel": "Híbrid",
        "power": "120 / 136",
        "length": "4.600",
        "width": "1.800",
        "height": "1.465",
        "trunk": "512–1.581",
        "price": "20.100€"
      },
      {
        "id": "ceed-tourer",
        "name": "Ceed Tourer",
        "fuel": "PHEV",
        "power": "141",
        "length": "4.600",
        "width": "1.800",
        "height": "1.465",
        "trunk": "437–1.506",
        "price": "20.100€"
      },
      {
        "id": "e-soul",
        "name": "e-Soul",
        "fuel": "Elèctric",
        "power": "136 / 204",
        "length": "4.195",
        "width": "1.605",
        "height": "1.800",
        "trunk": "315–1.339",
        "price": "18.125€"
      },
      {
        "id": "ev2",
        "name": "EV2",
        "fuel": "Elèctric",
        "power": "147",
        "length": "4.060",
        "width": "1.800",
        "height": "1.575",
        "trunk": "362–1.201",
        "price": "29.450€"
      },
      {
        "id": "ev3",
        "name": "EV3",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.300",
        "width": "1.850",
        "height": "1.560",
        "trunk": "460–1.250",
        "price": "36.930€"
      },
      {
        "id": "ev4",
        "name": "EV4",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.430",
        "width": "1.860",
        "height": "1.485",
        "trunk": "435",
        "price": "37.951€"
      },
      {
        "id": "ev4-fastback",
        "name": "EV4 Fastback",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.730",
        "width": "1.860",
        "height": "1.485",
        "trunk": "590",
        "price": "37.951€"
      },
      {
        "id": "ev5",
        "name": "EV5",
        "fuel": "Elèctric",
        "power": "218",
        "length": "4.610",
        "width": "1.875",
        "height": "1.675",
        "trunk": "566–1.650",
        "price": "N.D.€"
      },
      {
        "id": "ev6",
        "name": "EV6",
        "fuel": "Elèctric",
        "power": "170 / 229 / 325 / 585",
        "length": "4.695",
        "width": "1.890",
        "height": "1.550",
        "trunk": "N.D.",
        "price": "46.450€"
      },
      {
        "id": "ev9",
        "name": "EV9",
        "fuel": "Elèctric",
        "power": "384",
        "length": "5.015",
        "width": "2.047",
        "height": "1.780",
        "trunk": "312–2.393",
        "price": "85.100€"
      },
      {
        "id": "k4",
        "name": "K4",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.440",
        "width": "1.850",
        "height": "1.435",
        "trunk": "438–1.217",
        "price": "30.770€"
      },
      {
        "id": "k4",
        "name": "K4",
        "fuel": "Híbrid",
        "power": "115",
        "length": "4.440",
        "width": "1.850",
        "height": "1.435",
        "trunk": "328–1.107",
        "price": "30.770€"
      },
      {
        "id": "niro",
        "name": "Niro",
        "fuel": "Combustió",
        "power": "102",
        "length": "4.430",
        "width": "1.825",
        "height": "1.545",
        "trunk": "430–1.424",
        "price": "28.750€"
      },
      {
        "id": "optima-berlina",
        "name": "Optima Berlina",
        "fuel": "Dièsel",
        "power": "141",
        "length": "4.855",
        "width": "1.860",
        "height": "1.465",
        "trunk": "510",
        "price": "29.780€"
      },
      {
        "id": "optima-berlina",
        "name": "Optima Berlina",
        "fuel": "Gasolina",
        "power": "245",
        "length": "4.855",
        "width": "1.860",
        "height": "1.455",
        "trunk": "510",
        "price": "29.780€"
      },
      {
        "id": "optima-hybrid",
        "name": "Optima Hybrid",
        "fuel": "Híbrid",
        "power": "205",
        "length": "4.855",
        "width": "1.860",
        "height": "1.465",
        "trunk": "307",
        "price": "29.780€"
      },
      {
        "id": "optima-sportswagon",
        "name": "Optima SportsWagon",
        "fuel": "Dièsel",
        "power": "141",
        "length": "4.855",
        "width": "1.860",
        "height": "1.470",
        "trunk": "552",
        "price": "29.780€"
      },
      {
        "id": "optima-sportswagon",
        "name": "Optima SportsWagon",
        "fuel": "Gasolina",
        "power": "245",
        "length": "4.855",
        "width": "1.860",
        "height": "1.460",
        "trunk": "552",
        "price": "29.780€"
      },
      {
        "id": "picanto",
        "name": "Picanto",
        "fuel": "Gasolina",
        "power": "63 / 79",
        "length": "3.605",
        "width": "1.595",
        "height": "1.485",
        "trunk": "250–1.010",
        "price": "17.015€"
      },
      {
        "id": "proceed",
        "name": "ProCeed",
        "fuel": "Gasolina",
        "power": "120 / 294",
        "length": "4.605",
        "width": "1.800",
        "height": "1.422",
        "trunk": "594–1.545",
        "price": "20.100€"
      },
      {
        "id": "pv5",
        "name": "PV5",
        "fuel": "Elèctric",
        "power": "122 / 163",
        "length": "4.695",
        "width": "1.895",
        "height": "1.899",
        "trunk": "N.D.",
        "price": "38.690€"
      },
      {
        "id": "rio",
        "name": "Rio",
        "fuel": "Gasolina",
        "power": "84",
        "length": "4.065",
        "width": "1.725",
        "height": "1.450",
        "trunk": "325–1.103",
        "price": "15.950€"
      },
      {
        "id": "rio",
        "name": "Rio",
        "fuel": "Híbrid",
        "power": "100 / 120",
        "length": "4.065",
        "width": "1.725",
        "height": "1.450",
        "trunk": "325–1.103",
        "price": "15.950€"
      },
      {
        "id": "sorento",
        "name": "Sorento",
        "fuel": "Gasolina",
        "power": "194",
        "length": "4.815",
        "width": "1.900",
        "height": "1.700",
        "trunk": "179–1.996",
        "price": "45.725€"
      },
      {
        "id": "sorento",
        "name": "Sorento",
        "fuel": "Híbrid",
        "power": "215",
        "length": "4.815",
        "width": "1.900",
        "height": "1.700",
        "trunk": "179–1.996",
        "price": "45.725€"
      },
      {
        "id": "sorento",
        "name": "Sorento",
        "fuel": "PHEV",
        "power": "253",
        "length": "4.815",
        "width": "1.900",
        "height": "1.700",
        "trunk": "179–1.996",
        "price": "45.725€"
      },
      {
        "id": "soul",
        "name": "Soul",
        "fuel": "Dièsel",
        "power": "136",
        "length": "4.140",
        "width": "1.800",
        "height": "1.605",
        "trunk": "238–1.367",
        "price": "18.125€"
      },
      {
        "id": "soul",
        "name": "Soul",
        "fuel": "Elèctric",
        "power": "N.D.",
        "length": "4.140",
        "width": "1.800",
        "height": "1.605",
        "trunk": "281",
        "price": "18.125€"
      },
      {
        "id": "soul",
        "name": "Soul",
        "fuel": "Gasolina",
        "power": "132 / 204",
        "length": "4.140",
        "width": "1.800",
        "height": "1.605",
        "trunk": "238–1.367",
        "price": "18.125€"
      },
      {
        "id": "sportage",
        "name": "Sportage",
        "fuel": "Dièsel",
        "power": "115",
        "length": "4.515",
        "width": "1.865",
        "height": "1.645",
        "trunk": "571–1.760",
        "price": "28.300€"
      },
      {
        "id": "sportage",
        "name": "Sportage",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.515",
        "width": "1.865",
        "height": "1.645",
        "trunk": "591–1.780",
        "price": "28.300€"
      },
      {
        "id": "sportage",
        "name": "Sportage",
        "fuel": "Híbrid",
        "power": "136 / 150 / 180 / 230",
        "length": "4.515",
        "width": "1.865",
        "height": "1.645",
        "trunk": "562–1.751",
        "price": "28.300€"
      },
      {
        "id": "sportage",
        "name": "Sportage",
        "fuel": "PHEV",
        "power": "265",
        "length": "4.515",
        "width": "1.865",
        "height": "1.650",
        "trunk": "540–1.715",
        "price": "28.300€"
      },
      {
        "id": "stonic",
        "name": "Stonic",
        "fuel": "Gasolina",
        "power": "100",
        "length": "4.165",
        "width": "1.760",
        "height": "1.500",
        "trunk": "352–1.155",
        "price": "17.400€"
      },
      {
        "id": "stonic",
        "name": "Stonic",
        "fuel": "Híbrid",
        "power": "115",
        "length": "4.165",
        "width": "1.760",
        "height": "1.500",
        "trunk": "352–1.155",
        "price": "17.400€"
      },
      {
        "id": "venga",
        "name": "Venga",
        "fuel": "Dièsel",
        "power": "90 / 115 / 128",
        "length": "4.075",
        "width": "1.765",
        "height": "1.600",
        "trunk": "440–1.486",
        "price": "16.060€"
      },
      {
        "id": "venga",
        "name": "Venga",
        "fuel": "Gasolina",
        "power": "90 / 125",
        "length": "4.075",
        "width": "1.765",
        "height": "1.600",
        "trunk": "440–1.486",
        "price": "16.060€"
      },
      {
        "id": "xceed",
        "name": "XCeed",
        "fuel": "Gasolina",
        "power": "120 / 204",
        "length": "4.395",
        "width": "1.826",
        "height": "1.483",
        "trunk": "426–1.378",
        "price": "22.300€"
      },
      {
        "id": "xceed",
        "name": "XCeed",
        "fuel": "Híbrid",
        "power": "115 / 136 / 160",
        "length": "4.380",
        "width": "1.826",
        "height": "1.483",
        "trunk": "380–1.332",
        "price": "22.300€"
      },
      {
        "id": "xceed",
        "name": "XCeed",
        "fuel": "PHEV",
        "power": "141",
        "length": "4.395",
        "width": "1.826",
        "height": "1.483",
        "trunk": "291–1.243",
        "price": "22.300€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "shuma",
        "name": "Shuma",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2004"
      },
      {
        "id": "joice",
        "name": "Joice",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2003"
      },
      {
        "id": "opirus-amanti",
        "name": "Opirus / Amanti",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2010"
      },
      {
        "id": "cerato-spectra",
        "name": "Cerato / Spectra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2004–2009"
      },
      {
        "id": "rio-sedan",
        "name": "Rio Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2005–2016"
      },
      {
        "id": "ceed-sw",
        "name": "cee'd SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2018"
      },
      {
        "id": "rondo",
        "name": "Rondo",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2016"
      },
      {
        "id": "borrego-mohave",
        "name": "Borrego / Mohave",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      },
      {
        "id": "forte-koup",
        "name": "Forte Koup",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2016"
      },
      {
        "id": "forte-5-door",
        "name": "Forte 5 Door",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2010–2018"
      },
      {
        "id": "k9",
        "name": "K9",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2021"
      },
      {
        "id": "ceratoforte",
        "name": "Cerato/Forte",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2018"
      },
      {
        "id": "k7-cadenza",
        "name": "K7 / Cadenza",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2019"
      },
      {
        "id": "pro_ceed-gt",
        "name": "pro_cee’d GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2018"
      },
      {
        "id": "picanto-x-line",
        "name": "Picanto X-Line",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      }
    ]
  },
  {
    "id": "lamborghini",
    "name": "Lamborghini",
    "logo": "🐂",
    "description": "Expect the Unexpected",
    "models": [
      {
        "id": "aventador-svj",
        "name": "Aventador SVJ",
        "fuel": "Gasolina",
        "power": "770",
        "length": "4.963",
        "width": "2.098",
        "height": "1.136",
        "trunk": "N.D.",
        "price": "422.290€"
      },
      {
        "id": "aventador-ultimae-coupe",
        "name": "Aventador Ultimae Coupé",
        "fuel": "Gasolina",
        "power": "780",
        "length": "4.868",
        "width": "2.098",
        "height": "1.136",
        "trunk": "N.D.",
        "price": "422.290€"
      },
      {
        "id": "aventador-ultimae-roadster",
        "name": "Aventador Ultimae Roadster",
        "fuel": "Gasolina",
        "power": "780",
        "length": "4.868",
        "width": "2.098",
        "height": "1.136",
        "trunk": "N.D.",
        "price": "422.290€"
      },
      {
        "id": "countach",
        "name": "Countach",
        "fuel": "Híbrid",
        "power": "780",
        "length": "4.870",
        "width": "2.099",
        "height": "1.139",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "fenomeno",
        "name": "Fenomeno",
        "fuel": "Híbrid",
        "power": "1080",
        "length": "5.014",
        "width": "2.076",
        "height": "1.161",
        "trunk": "N.D.",
        "price": "3.000.000€"
      },
      {
        "id": "huracan-evo",
        "name": "Huracán EVO",
        "fuel": "Gasolina",
        "power": "640",
        "length": "4.520",
        "width": "1.933",
        "height": "1.165",
        "trunk": "N.D.",
        "price": "192.900€"
      },
      {
        "id": "huracan-evo-rwd",
        "name": "Huracán EVO RWD",
        "fuel": "Gasolina",
        "power": "610",
        "length": "4.520",
        "width": "1.933",
        "height": "1.165",
        "trunk": "N.D.",
        "price": "192.900€"
      },
      {
        "id": "huracan-evo-rwd-spyder",
        "name": "Huracán EVO RWD Spyder",
        "fuel": "Gasolina",
        "power": "610",
        "length": "4.520",
        "width": "1.933",
        "height": "1.180",
        "trunk": "N.D.",
        "price": "192.900€"
      },
      {
        "id": "huracan-evo-spyder",
        "name": "Huracán EVO Spyder",
        "fuel": "Gasolina",
        "power": "640",
        "length": "4.520",
        "width": "1.933",
        "height": "1.180",
        "trunk": "N.D.",
        "price": "192.900€"
      },
      {
        "id": "huracan-sterrato",
        "name": "Huracán Sterrato",
        "fuel": "Gasolina",
        "power": "610",
        "length": "4.525",
        "width": "1.956",
        "height": "1.248",
        "trunk": "N.D.",
        "price": "192.900€"
      },
      {
        "id": "huracan-sto",
        "name": "Huracán STO",
        "fuel": "Gasolina",
        "power": "640",
        "length": "4.549",
        "width": "1.945",
        "height": "1.220",
        "trunk": "38",
        "price": "192.900€"
      },
      {
        "id": "revuelto",
        "name": "Revuelto",
        "fuel": "PHEV",
        "power": "1015",
        "length": "4.947",
        "width": "2.033",
        "height": "1.160",
        "trunk": "N.D.",
        "price": "508.200€"
      },
      {
        "id": "temerario",
        "name": "Temerario",
        "fuel": "PHEV",
        "power": "920",
        "length": "4.706",
        "width": "1.996",
        "height": "1.201",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "urus-performante",
        "name": "Urus Performante",
        "fuel": "Gasolina",
        "power": "666",
        "length": "5.137",
        "width": "2.026",
        "height": "1.618",
        "trunk": "616",
        "price": "265.442€"
      },
      {
        "id": "urus-s",
        "name": "Urus S",
        "fuel": "Gasolina",
        "power": "666",
        "length": "5.112",
        "width": "2.018",
        "height": "1.638",
        "trunk": "616",
        "price": "265.442€"
      },
      {
        "id": "urus-se",
        "name": "Urus SE",
        "fuel": "PHEV",
        "power": "800",
        "length": "5.123",
        "width": "2.022",
        "height": "1.638",
        "trunk": "N.D.",
        "price": "265.442€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "350-gt",
        "name": "350 GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1964–1966"
      },
      {
        "id": "400-gt",
        "name": "400 GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1966–1968"
      },
      {
        "id": "350-gts",
        "name": "350 GTS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "n.d."
      },
      {
        "id": "miura",
        "name": "Miura",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1966–1987"
      },
      {
        "id": "islero",
        "name": "Islero",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1968–1969"
      },
      {
        "id": "espada",
        "name": "Espada",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1968–1976"
      },
      {
        "id": "jarama",
        "name": "Jarama",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1970–1976"
      },
      {
        "id": "urraco",
        "name": "Urraco",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–1979"
      },
      {
        "id": "silhouette",
        "name": "Silhouette",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–1979"
      },
      {
        "id": "jalpa",
        "name": "Jalpa",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1988"
      },
      {
        "id": "lm-002",
        "name": "LM 002",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1993"
      },
      {
        "id": "diablo",
        "name": "Diablo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1990–2001"
      },
      {
        "id": "diablo-roadster",
        "name": "Diablo Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2000"
      },
      {
        "id": "murcielago",
        "name": "Murciélago",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2001–2010"
      },
      {
        "id": "gallardo",
        "name": "Gallardo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "10",
        "years": "2003–2014"
      },
      {
        "id": "murcielago-roadster",
        "name": "Murciélago Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2010"
      },
      {
        "id": "gallardo-spyder",
        "name": "Gallardo Spyder",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2006–2013"
      },
      {
        "id": "reventon",
        "name": "Reventón",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2009"
      },
      {
        "id": "veneno",
        "name": "Veneno",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2014"
      },
      {
        "id": "veneno-roadster",
        "name": "Veneno Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2014"
      },
      {
        "id": "huracan-spyder",
        "name": "Huracán Spyder",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2015–2023"
      },
      {
        "id": "centenario",
        "name": "Centenario",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2017"
      },
      {
        "id": "centenario-roadster",
        "name": "Centenario Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2017"
      },
      {
        "id": "sian",
        "name": "Sián",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2022"
      }
    ]
  },
  {
    "id": "lancia",
    "name": "Lancia",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "gamma",
        "name": "Gamma",
        "fuel": "Elèctric",
        "power": "260 / 280 / 375",
        "length": "4.672",
        "width": "1.898",
        "height": "1.664",
        "trunk": "N.D.",
        "price": "39.900€"
      },
      {
        "id": "gamma",
        "name": "Gamma",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.672",
        "width": "1.898",
        "height": "1.665",
        "trunk": "N.D.",
        "price": "39.900€"
      },
      {
        "id": "ypsilon",
        "name": "Ypsilon",
        "fuel": "Elèctric",
        "power": "156 / 280",
        "length": "4.080",
        "width": "1.755",
        "height": "1.455",
        "trunk": "352",
        "price": "23.900€"
      },
      {
        "id": "ypsilon",
        "name": "Ypsilon",
        "fuel": "Híbrid",
        "power": "100",
        "length": "4.075",
        "width": "1.755",
        "height": "1.435",
        "trunk": "309",
        "price": "23.900€"
      },
      {
        "id": "ypsilon-hf-line",
        "name": "Ypsilon HF Line",
        "fuel": "Elèctric",
        "power": "156",
        "length": "4.080",
        "width": "1.755",
        "height": "1.455",
        "trunk": "309",
        "price": "23.900€"
      },
      {
        "id": "ypsilon-hf-line",
        "name": "Ypsilon HF Line",
        "fuel": "Híbrid",
        "power": "110",
        "length": "4.080",
        "width": "1.755",
        "height": "1.455",
        "trunk": "352",
        "price": "23.900€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "alpha",
        "name": "Alpha",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1907–1909"
      },
      {
        "id": "beta",
        "name": "Beta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1909–1982"
      },
      {
        "id": "theta",
        "name": "Theta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1913–1919"
      },
      {
        "id": "lambda",
        "name": "Lambda",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1922–1931"
      },
      {
        "id": "dilambda",
        "name": "Dilambda",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1928–1933"
      },
      {
        "id": "astura",
        "name": "Astura",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1931–1937"
      },
      {
        "id": "augusta",
        "name": "Augusta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1933–1937"
      },
      {
        "id": "artena",
        "name": "Artena",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1934–1936"
      },
      {
        "id": "aprilia",
        "name": "Aprilia",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1937–1939"
      },
      {
        "id": "ardea",
        "name": "Ardea",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1939–1953"
      },
      {
        "id": "flaminia-coupe",
        "name": "Flaminia Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1958–1967"
      },
      {
        "id": "flavia-convertible",
        "name": "Flavia Convertible",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1960–2015"
      },
      {
        "id": "flavia-sedan",
        "name": "Flavia Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1960–1970"
      },
      {
        "id": "flaminia-sedan",
        "name": "Flaminia Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1963–1970"
      },
      {
        "id": "fulvia-berlina",
        "name": "Fulvia Berlina",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1963–1972"
      },
      {
        "id": "fulvia-coupe",
        "name": "Fulvia Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1969"
      },
      {
        "id": "2000-coupe",
        "name": "2000 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1974"
      },
      {
        "id": "stratos",
        "name": "Stratos",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1973–1975"
      },
      {
        "id": "beta-coupe",
        "name": "Beta Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1973–1984"
      },
      {
        "id": "beta-spider",
        "name": "Beta Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1973–1982"
      },
      {
        "id": "beta-montecarlo",
        "name": "Beta Montecarlo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1974–1979"
      },
      {
        "id": "gamma-coupe",
        "name": "Gamma Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–1980"
      },
      {
        "id": "delta",
        "name": "Delta",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1979–2014"
      },
      {
        "id": "trevi",
        "name": "Trevi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1985"
      },
      {
        "id": "a112",
        "name": "A112",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1982–1986"
      },
      {
        "id": "a112-abarth",
        "name": "A112 Abarth",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1986"
      },
      {
        "id": "prisma",
        "name": "Prisma",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1983–1990"
      },
      {
        "id": "thema",
        "name": "Thema",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1984–2014"
      },
      {
        "id": "dedra",
        "name": "Dedra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1990–1999"
      },
      {
        "id": "dedra-station-wagon",
        "name": "Dedra Station Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1998"
      },
      {
        "id": "zeta",
        "name": "Zeta",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–2001"
      },
      {
        "id": "kappa",
        "name": "Kappa",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2000"
      },
      {
        "id": "kappa-sw",
        "name": "Kappa SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2000"
      },
      {
        "id": "kappa-coupe",
        "name": "Kappa Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1997–2000"
      },
      {
        "id": "lybra",
        "name": "Lybra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2005"
      },
      {
        "id": "lybra-sw",
        "name": "Lybra SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2005"
      },
      {
        "id": "thesis",
        "name": "Thesis",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2009"
      },
      {
        "id": "phedra",
        "name": "Phedra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2010"
      },
      {
        "id": "musa",
        "name": "Musa",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2012"
      },
      {
        "id": "voyager",
        "name": "Voyager",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2015"
      },
      {
        "id": "delta-hpe",
        "name": "Delta HPE",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–1998"
      }
    ]
  },
  {
    "id": "leapmotor",
    "name": "Leapmotor",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "b10",
        "name": "B10",
        "fuel": "Elèctric",
        "power": "218",
        "length": "4.515",
        "width": "1.885",
        "height": "1.655",
        "trunk": "430",
        "price": "24.500€"
      },
      {
        "id": "b10",
        "name": "B10",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.515",
        "width": "1.885",
        "height": "1.655",
        "trunk": "330–1.600",
        "price": "24.500€"
      },
      {
        "id": "c10",
        "name": "C10",
        "fuel": "Elèctric",
        "power": "218",
        "length": "4.739",
        "width": "1.900",
        "height": "1.680",
        "trunk": "435–1.410",
        "price": "36.400€"
      },
      {
        "id": "c10",
        "name": "C10",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.739",
        "width": "1.900",
        "height": "1.680",
        "trunk": "435–1.410",
        "price": "36.400€"
      },
      {
        "id": "t03",
        "name": "T03",
        "fuel": "Elèctric",
        "power": "95",
        "length": "3.620",
        "width": "1.652",
        "height": "1.577",
        "trunk": "210–880",
        "price": "17.800€"
      }
    ]
  },
  {
    "id": "lepas",
    "name": "Lepas",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "l8-super-hybrid",
        "name": "L8 Super Hybrid",
        "fuel": "PHEV",
        "power": "279",
        "length": "4.688",
        "width": "1.871",
        "height": "1.686",
        "trunk": "507",
        "price": "41.700€"
      }
    ]
  },
  {
    "id": "lexus",
    "name": "Lexus",
    "logo": "🅛",
    "description": "Experience Amazing",
    "models": [
      {
        "id": "es",
        "name": "ES",
        "fuel": "Elèctric",
        "power": "224 / 343",
        "length": "5.140",
        "width": "1.920",
        "height": "1.560",
        "trunk": "462",
        "price": "61.500€"
      },
      {
        "id": "es",
        "name": "ES",
        "fuel": "Híbrid",
        "power": "201",
        "length": "5.140",
        "width": "1.920",
        "height": "1.555",
        "trunk": "493",
        "price": "61.500€"
      },
      {
        "id": "is",
        "name": "IS",
        "fuel": "Híbrid",
        "power": "223",
        "length": "4.680",
        "width": "1.810",
        "height": "1.430",
        "trunk": "450",
        "price": "40.500€"
      },
      {
        "id": "lbx",
        "name": "LBX",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.190",
        "width": "1.825",
        "height": "1.545",
        "trunk": "240",
        "price": "33.900€"
      },
      {
        "id": "lc",
        "name": "LC",
        "fuel": "Híbrid",
        "power": "359",
        "length": "4.770",
        "width": "1.920",
        "height": "1.345",
        "trunk": "197",
        "price": "124.800€"
      },
      {
        "id": "lc-cabrio",
        "name": "LC Cabrio",
        "fuel": "Gasolina",
        "power": "477",
        "length": "4.770",
        "width": "1.920",
        "height": "1.350",
        "trunk": "N.D.",
        "price": "124.800€"
      },
      {
        "id": "lm",
        "name": "LM",
        "fuel": "Híbrid",
        "power": "250",
        "length": "5.130",
        "width": "1.890",
        "height": "1.945",
        "trunk": "110–1.191",
        "price": "125.000€"
      },
      {
        "id": "ls",
        "name": "LS",
        "fuel": "Híbrid",
        "power": "359",
        "length": "5.235",
        "width": "1.900",
        "height": "1.450",
        "trunk": "N.D.",
        "price": "107.500€"
      },
      {
        "id": "nx",
        "name": "NX",
        "fuel": "Híbrid",
        "power": "244",
        "length": "4.660",
        "width": "1.865",
        "height": "1.660",
        "trunk": "545–1.436",
        "price": "48.500€"
      },
      {
        "id": "nx",
        "name": "NX",
        "fuel": "PHEV",
        "power": "309",
        "length": "4.660",
        "width": "1.865",
        "height": "1.660",
        "trunk": "545–1.436",
        "price": "48.500€"
      },
      {
        "id": "rx",
        "name": "RX",
        "fuel": "Híbrid",
        "power": "250 / 371",
        "length": "4.890",
        "width": "1.920",
        "height": "1.695",
        "trunk": "N.D.",
        "price": "77.300€"
      },
      {
        "id": "rx",
        "name": "RX",
        "fuel": "PHEV",
        "power": "309",
        "length": "4.890",
        "width": "1.920",
        "height": "1.695",
        "trunk": "N.D.",
        "price": "77.300€"
      },
      {
        "id": "rz",
        "name": "RZ",
        "fuel": "Elèctric",
        "power": "224 / 313 / 380 / 408",
        "length": "4.805",
        "width": "1.895",
        "height": "1.635",
        "trunk": "N.D.",
        "price": "73.000€"
      },
      {
        "id": "ux",
        "name": "UX",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.495",
        "width": "1.840",
        "height": "1.545",
        "trunk": "367–486",
        "price": "39.950€"
      },
      {
        "id": "ux",
        "name": "UX",
        "fuel": "Híbrid",
        "power": "184 / 199",
        "length": "4.495",
        "width": "1.840",
        "height": "1.520",
        "trunk": "283",
        "price": "39.950€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "sc",
        "name": "SC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1991–2010"
      },
      {
        "id": "gs",
        "name": "GS",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1993–2020"
      },
      {
        "id": "hs",
        "name": "HS",
        "fuel": "Híbrid gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      },
      {
        "id": "lfa",
        "name": "LFA",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2013"
      },
      {
        "id": "ct",
        "name": "CT",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2011–2022"
      },
      {
        "id": "gs-f",
        "name": "GS F",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2020"
      }
    ]
  },
  {
    "id": "livan",
    "name": "Livan",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "x3-pro",
        "name": "X3 Pro",
        "fuel": "Gasolina",
        "power": "103",
        "length": "4.005",
        "width": "1.760",
        "height": "1.575",
        "trunk": "400",
        "price": "16.995€"
      },
      {
        "id": "x6-pro",
        "name": "X6 Pro",
        "fuel": "Gasolina",
        "power": "174",
        "length": "4.535",
        "width": "1.845",
        "height": "1.725",
        "trunk": "359–1.200",
        "price": "23.995€"
      }
    ]
  },
  {
    "id": "lynkco",
    "name": "Lynk&Co",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "08",
        "name": "08",
        "fuel": "PHEV",
        "power": "345",
        "length": "4.820",
        "width": "1.915",
        "height": "1.685",
        "trunk": "540–1.254",
        "price": "52.995€"
      }
    ]
  },
  {
    "id": "mahindra",
    "name": "Mahindra",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "kuv100",
        "name": "KUV100",
        "fuel": "Gasolina",
        "power": "82",
        "length": "3.700",
        "width": "1.727",
        "height": "1.655",
        "trunk": "243–473",
        "price": "11.950€"
      },
      {
        "id": "pik-up-plus",
        "name": "Pik-Up Plus",
        "fuel": "Dièsel",
        "power": "140",
        "length": "5.175",
        "width": "1.915",
        "height": "1.820",
        "trunk": "N.D.",
        "price": "19.118€"
      },
      {
        "id": "quanto",
        "name": "Quanto",
        "fuel": "Gasolina",
        "power": "120",
        "length": "3.985",
        "width": "1.840",
        "height": "1.900",
        "trunk": "N.D.",
        "price": "15.972€"
      },
      {
        "id": "xuv500",
        "name": "XUV500",
        "fuel": "Gasolina",
        "power": "140",
        "length": "4.585",
        "width": "1.890",
        "height": "1.785",
        "trunk": "93–1.512",
        "price": "20.620€"
      }
    ]
  },
  {
    "id": "maserati",
    "name": "Maserati",
    "logo": "🔱",
    "description": "Excellence through Passion",
    "models": [
      {
        "id": "ghibli",
        "name": "Ghibli",
        "fuel": "Dièsel",
        "power": "275",
        "length": "4.971",
        "width": "2.128",
        "height": "1.461",
        "trunk": "500",
        "price": "82.700€"
      },
      {
        "id": "ghibli",
        "name": "Ghibli",
        "fuel": "Gasolina",
        "power": "350 / 430",
        "length": "4.971",
        "width": "2.128",
        "height": "1.461",
        "trunk": "500",
        "price": "82.700€"
      },
      {
        "id": "ghibli-hybrid",
        "name": "Ghibli Hybrid",
        "fuel": "Híbrid",
        "power": "330",
        "length": "4.791",
        "width": "2.128",
        "height": "1.461",
        "trunk": "500",
        "price": "82.700€"
      },
      {
        "id": "ghibli-trofeo",
        "name": "Ghibli Trofeo",
        "fuel": "Gasolina",
        "power": "580",
        "length": "4.971",
        "width": "2.128",
        "height": "1.461",
        "trunk": "500",
        "price": "82.700€"
      },
      {
        "id": "grecale",
        "name": "Grecale",
        "fuel": "Elèctric",
        "power": "550",
        "length": "4.865",
        "width": "1.948",
        "height": "1.651",
        "trunk": "535",
        "price": "81.050€"
      },
      {
        "id": "grecale",
        "name": "Grecale",
        "fuel": "Gasolina",
        "power": "530",
        "length": "4.859",
        "width": "2.163",
        "height": "1.659",
        "trunk": "570",
        "price": "81.050€"
      },
      {
        "id": "grecale",
        "name": "Grecale",
        "fuel": "Híbrid",
        "power": "300",
        "length": "4.846",
        "width": "2.163",
        "height": "1.670",
        "trunk": "535",
        "price": "81.050€"
      },
      {
        "id": "levante",
        "name": "Levante",
        "fuel": "Dièsel",
        "power": "275",
        "length": "5.005",
        "width": "2.158",
        "height": "1.693",
        "trunk": "580–1.625",
        "price": "96.115€"
      },
      {
        "id": "levante",
        "name": "Levante",
        "fuel": "Gasolina",
        "power": "350 / 430 / 530",
        "length": "5.020",
        "width": "2.158",
        "height": "1.698",
        "trunk": "580–1.625",
        "price": "96.115€"
      },
      {
        "id": "levante-trofeo",
        "name": "Levante Trofeo",
        "fuel": "Gasolina",
        "power": "580",
        "length": "5.020",
        "width": "2.158",
        "height": "1.698",
        "trunk": "580–1.625",
        "price": "96.115€"
      },
      {
        "id": "mc20",
        "name": "MC20",
        "fuel": "Gasolina",
        "power": "630",
        "length": "4.669",
        "width": "1.965",
        "height": "1.221",
        "trunk": "50–150",
        "price": "243.400€"
      },
      {
        "id": "mc20-cielo",
        "name": "MC20 Cielo",
        "fuel": "Gasolina",
        "power": "630",
        "length": "4.669",
        "width": "1.965",
        "height": "1.218",
        "trunk": "50–150",
        "price": "243.400€"
      },
      {
        "id": "quattroporte",
        "name": "Quattroporte",
        "fuel": "Gasolina",
        "power": "430",
        "length": "5.262",
        "width": "2.128",
        "height": "1.481",
        "trunk": "530",
        "price": "155.900€"
      },
      {
        "id": "quattroporte-trofeo",
        "name": "Quattroporte Trofeo",
        "fuel": "Gasolina",
        "power": "580",
        "length": "5.262",
        "width": "2.128",
        "height": "1.481",
        "trunk": "530",
        "price": "155.900€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "indy",
        "name": "Indy",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1969–1974"
      },
      {
        "id": "bora",
        "name": "Bora",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1971–1978"
      },
      {
        "id": "merak",
        "name": "Merak",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1974–1982"
      },
      {
        "id": "coupe",
        "name": "Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2004"
      },
      {
        "id": "spyder",
        "name": "Spyder",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2007"
      },
      {
        "id": "mc-12",
        "name": "MC 12",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2005"
      },
      {
        "id": "gransport",
        "name": "GranSport",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2007"
      },
      {
        "id": "quattroporte-sport-gt-s",
        "name": "Quattroporte Sport GT S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      }
    ]
  },
  {
    "id": "mazda",
    "name": "Mazda",
    "logo": "🔶",
    "description": "Zoom-Zoom",
    "models": [
      {
        "id": "2",
        "name": "2",
        "fuel": "Híbrid",
        "power": "90",
        "length": "4.080",
        "width": "1.695",
        "height": "1.495",
        "trunk": "255",
        "price": "20.311€"
      },
      {
        "id": "2-hybrid",
        "name": "2 Hybrid",
        "fuel": "Híbrid",
        "power": "116",
        "length": "3.940",
        "width": "1.745",
        "height": "1.500",
        "trunk": "286–935",
        "price": "20.311€"
      },
      {
        "id": "3",
        "name": "3",
        "fuel": "Híbrid",
        "power": "122 / 150 / 186",
        "length": "4.460",
        "width": "1.795",
        "height": "1.435",
        "trunk": "430–1.138",
        "price": "27.050€"
      },
      {
        "id": "3-sedan",
        "name": "3 Sedán",
        "fuel": "Híbrid",
        "power": "122 / 150 / 186",
        "length": "4.660",
        "width": "1.795",
        "height": "1.440",
        "trunk": "450–1.138",
        "price": "27.050€"
      },
      {
        "id": "6e",
        "name": "6e",
        "fuel": "Elèctric",
        "power": "245 / 258",
        "length": "4.921",
        "width": "1.890",
        "height": "1.491",
        "trunk": "466–1.074",
        "price": "43.725€"
      },
      {
        "id": "cx-3",
        "name": "CX-3",
        "fuel": "Gasolina",
        "power": "121",
        "length": "4.275",
        "width": "1.765",
        "height": "1.535",
        "trunk": "350–1.260",
        "price": "23.795€"
      },
      {
        "id": "cx-30",
        "name": "CX-30",
        "fuel": "Híbrid",
        "power": "122 / 150 / 186",
        "length": "4.395",
        "width": "2.040",
        "height": "1.540",
        "trunk": "430–1.406",
        "price": "30.590€"
      },
      {
        "id": "cx-5",
        "name": "CX-5",
        "fuel": "Híbrid",
        "power": "141",
        "length": "4.690",
        "width": "1.860",
        "height": "1.695",
        "trunk": "583–2.019",
        "price": "35.183€"
      },
      {
        "id": "cx-80",
        "name": "CX-80",
        "fuel": "Híbrid",
        "power": "254",
        "length": "4.995",
        "width": "1.890",
        "height": "1.705",
        "trunk": "258–1.971",
        "price": "60.444€"
      },
      {
        "id": "cx-80",
        "name": "CX-80",
        "fuel": "PHEV",
        "power": "327",
        "length": "4.995",
        "width": "1.890",
        "height": "1.705",
        "trunk": "258–1.971",
        "price": "60.444€"
      },
      {
        "id": "mx-30",
        "name": "MX-30",
        "fuel": "Elèctric",
        "power": "145",
        "length": "4.395",
        "width": "1.795",
        "height": "1.555",
        "trunk": "366–1.171",
        "price": "38.050€"
      },
      {
        "id": "mx-30",
        "name": "MX-30",
        "fuel": "Híbrid",
        "power": "170",
        "length": "4.395",
        "width": "1.848",
        "height": "1.560",
        "trunk": "350–1.155",
        "price": "38.050€"
      },
      {
        "id": "mx-5-retractable-fastback",
        "name": "MX-5 Retractable Fastback",
        "fuel": "Gasolina",
        "power": "184",
        "length": "3.915",
        "width": "1.735",
        "height": "1.235",
        "trunk": "127",
        "price": "28.720€"
      },
      {
        "id": "mx-5-soft-top",
        "name": "MX-5 Soft Top",
        "fuel": "Gasolina",
        "power": "132",
        "length": "3.915",
        "width": "1.735",
        "height": "1.225",
        "trunk": "130",
        "price": "28.720€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "rx-7",
        "name": "RX-7",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1970–2002"
      },
      {
        "id": "121",
        "name": "121",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1987–1998"
      },
      {
        "id": "323-station-wagon",
        "name": "323 Station Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1994"
      },
      {
        "id": "323-hatchback",
        "name": "323 Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1989–1998"
      },
      {
        "id": "323-sedan",
        "name": "323 Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1991"
      },
      {
        "id": "626-hatchback",
        "name": "626 Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1988–2002"
      },
      {
        "id": "626-sedan",
        "name": "626 Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1988–2002"
      },
      {
        "id": "626-station-wagon",
        "name": "626 Station Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1991"
      },
      {
        "id": "mx-3",
        "name": "MX-3",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1998"
      },
      {
        "id": "xedos-6",
        "name": "Xedos 6",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1999"
      },
      {
        "id": "mx-6",
        "name": "MX-6",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1997"
      },
      {
        "id": "xedos-9",
        "name": "Xedos 9",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–2002"
      },
      {
        "id": "b-series-bravo-dual-cab",
        "name": "B Series / Bravo Dual Cab",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2006"
      },
      {
        "id": "b-series-bravo-freestyle-cab",
        "name": "B Series / Bravo Freestyle Cab",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2006"
      },
      {
        "id": "tribute",
        "name": "Tribute",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2001–2011"
      },
      {
        "id": "6-atenza-hatchback",
        "name": "6 / Atenza Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2013"
      },
      {
        "id": "6-atenza-sedan",
        "name": "6 / Atenza Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "2002–2019"
      },
      {
        "id": "6-atenza-wagon",
        "name": "6 / Atenza Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2002–2018"
      },
      {
        "id": "rx-8",
        "name": "RX-8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2012"
      },
      {
        "id": "verisa",
        "name": "Verisa",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2015"
      },
      {
        "id": "5-premacy",
        "name": "5 / Premacy",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2005–2013"
      },
      {
        "id": "3-mps-mazdaspeed-3",
        "name": "3 MPS / Mazdaspeed 3",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2013"
      },
      {
        "id": "bt-50",
        "name": "BT-50",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2006–2020"
      },
      {
        "id": "2-demio-3-doors",
        "name": "2 / Demio - 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2014"
      },
      {
        "id": "cx-7",
        "name": "CX-7",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2012"
      },
      {
        "id": "cx-9",
        "name": "CX-9",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2007–2024"
      },
      {
        "id": "2-demio-sedan",
        "name": "2 / Demio - Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2014"
      },
      {
        "id": "biante",
        "name": "Biante",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2018"
      },
      {
        "id": "flair",
        "name": "Flair",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "flairwagon",
        "name": "Flairwagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2013"
      },
      {
        "id": "cx-8",
        "name": "CX-8",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2023"
      }
    ]
  },
  {
    "id": "mclaren",
    "name": "McLaren",
    "logo": "🏎️",
    "description": "The Art of Performance",
    "models": [
      {
        "id": "540c-570s",
        "name": "540C / 570S",
        "fuel": "Gasolina",
        "power": "540 / 570",
        "length": "4.530",
        "width": "2.095",
        "height": "1.202",
        "trunk": "N.D.",
        "price": "174.563€"
      },
      {
        "id": "600lt",
        "name": "600LT",
        "fuel": "Gasolina",
        "power": "600",
        "length": "5",
        "width": "2",
        "height": "1",
        "trunk": "150",
        "price": "210.000€"
      },
      {
        "id": "650s",
        "name": "650S",
        "fuel": "Gasolina",
        "power": "641 / 675",
        "length": "4.509",
        "width": "1.895",
        "height": "1.199",
        "trunk": "N.D.",
        "price": "238.000€"
      },
      {
        "id": "765lt",
        "name": "765LT",
        "fuel": "Gasolina",
        "power": "765",
        "length": "4.600",
        "width": "2.161",
        "height": "1.193",
        "trunk": "150–360",
        "price": "N.D.€"
      },
      {
        "id": "765lt-spider",
        "name": "765LT Spider",
        "fuel": "Gasolina",
        "power": "765",
        "length": "4.600",
        "width": "2.161",
        "height": "1.193",
        "trunk": "150–208",
        "price": "N.D.€"
      },
      {
        "id": "artura",
        "name": "Artura",
        "fuel": "Híbrid",
        "power": "680",
        "length": "4.539",
        "width": "1.913",
        "height": "1.193",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "elva",
        "name": "Elva",
        "fuel": "Gasolina",
        "power": "815",
        "length": "N.D.",
        "width": "N.D.",
        "height": "N.D.",
        "trunk": "N.D.",
        "price": "1.658.934€"
      },
      {
        "id": "gt",
        "name": "GT",
        "fuel": "Gasolina",
        "power": "620",
        "length": "4.683",
        "width": "2.095",
        "height": "1.213",
        "trunk": "150–570",
        "price": "N.D.€"
      },
      {
        "id": "p1",
        "name": "P1",
        "fuel": "Híbrid",
        "power": "737",
        "length": "4.588",
        "width": "1.946",
        "height": "1.188",
        "trunk": "120",
        "price": "1.048.727€"
      },
      {
        "id": "senna",
        "name": "Senna",
        "fuel": "Gasolina",
        "power": "800",
        "length": "4.744",
        "width": "2.153",
        "height": "1.195",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ]
  },
  {
    "id": "mercedes",
    "name": "Mercedes",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "amg-one",
        "name": "AMG One",
        "fuel": "Híbrid",
        "power": "1063",
        "length": "4.756",
        "width": "1.261",
        "height": "2.010",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "cla",
        "name": "CLA",
        "fuel": "Elèctric",
        "power": "272 / 354",
        "length": "4.723",
        "width": "2.021",
        "height": "1.468",
        "trunk": "405",
        "price": "45.175€"
      },
      {
        "id": "clase-a",
        "name": "Clase A",
        "fuel": "Dièsel",
        "power": "116 / 150 / 190",
        "length": "4.428",
        "width": "1.992",
        "height": "1.445",
        "trunk": "345–1.185",
        "price": "38.182€"
      },
      {
        "id": "clase-a",
        "name": "Clase A",
        "fuel": "Gasolina",
        "power": "421",
        "length": "4.453",
        "width": "1.992",
        "height": "1.414",
        "trunk": "370–1.210",
        "price": "38.182€"
      },
      {
        "id": "clase-a",
        "name": "Clase A",
        "fuel": "Híbrid",
        "power": "136 / 163 / 224 / 306",
        "length": "4.428",
        "width": "1.796",
        "height": "1.445",
        "trunk": "355–1.195",
        "price": "38.182€"
      },
      {
        "id": "clase-a",
        "name": "Clase A",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.428",
        "width": "1.992",
        "height": "1.452",
        "trunk": "310–1.125",
        "price": "38.182€"
      },
      {
        "id": "clase-a-berlina",
        "name": "Clase A berlina",
        "fuel": "Dièsel",
        "power": "116 / 150",
        "length": "4.558",
        "width": "1.992",
        "height": "1.446",
        "trunk": "395",
        "price": "38.182€"
      },
      {
        "id": "clase-a-berlina",
        "name": "Clase A berlina",
        "fuel": "Híbrid",
        "power": "136 / 163 / 306",
        "length": "4.558",
        "width": "1.992",
        "height": "1.446",
        "trunk": "395",
        "price": "38.182€"
      },
      {
        "id": "clase-a-berlina",
        "name": "Clase A berlina",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.558",
        "width": "1.992",
        "height": "1.458",
        "trunk": "345",
        "price": "38.182€"
      },
      {
        "id": "clase-b",
        "name": "Clase B",
        "fuel": "Dièsel",
        "power": "116 / 150 / 190",
        "length": "4.419",
        "width": "2.020",
        "height": "1.562",
        "trunk": "455–1.540",
        "price": "34.525€"
      },
      {
        "id": "clase-b",
        "name": "Clase B",
        "fuel": "Gasolina",
        "power": "136",
        "length": "4.419",
        "width": "2.020",
        "height": "1.562",
        "trunk": "455–1.540",
        "price": "34.525€"
      },
      {
        "id": "clase-b",
        "name": "Clase B",
        "fuel": "Híbrid",
        "power": "14",
        "length": "4.419",
        "width": "1.797",
        "height": "1.562",
        "trunk": "455–1.540",
        "price": "34.525€"
      },
      {
        "id": "clase-b",
        "name": "Clase B",
        "fuel": "PHEV",
        "power": "109 / 218",
        "length": "4.419",
        "width": "2.020",
        "height": "1.574",
        "trunk": "N.D.",
        "price": "34.525€"
      },
      {
        "id": "clase-c-all-terrain",
        "name": "Clase C All-Terrain",
        "fuel": "Híbrid",
        "power": "197",
        "length": "4.755",
        "width": "1.841",
        "height": "1.494",
        "trunk": "490–1.510",
        "price": "49.102€"
      },
      {
        "id": "clase-c-berlina",
        "name": "Clase C Berlina",
        "fuel": "Híbrid",
        "power": "163 / 170 / 197 / 200 / 204 / 258 / 265 / 408 / 680",
        "length": "4.751",
        "width": "2.033",
        "height": "1.440",
        "trunk": "455",
        "price": "49.102€"
      },
      {
        "id": "clase-c-berlina",
        "name": "Clase C Berlina",
        "fuel": "PHEV",
        "power": "313",
        "length": "4.751",
        "width": "2.033",
        "height": "1.442",
        "trunk": "315",
        "price": "49.102€"
      },
      {
        "id": "clase-c-estate",
        "name": "Clase C Estate",
        "fuel": "Híbrid",
        "power": "163 / 197 / 200 / 204 / 258 / 265 / 408 / 680",
        "length": "4.751",
        "width": "1.820",
        "height": "1.454",
        "trunk": "490–1.510",
        "price": "49.102€"
      },
      {
        "id": "clase-c-estate",
        "name": "Clase C Estate",
        "fuel": "PHEV",
        "power": "313",
        "length": "4.751",
        "width": "1.820",
        "height": "1.454",
        "trunk": "490–1.510",
        "price": "49.102€"
      },
      {
        "id": "clase-e",
        "name": "Clase E",
        "fuel": "Híbrid",
        "power": "197 / 204",
        "length": "4.949",
        "width": "1.880",
        "height": "1.468",
        "trunk": "540",
        "price": "63.425€"
      },
      {
        "id": "clase-e",
        "name": "Clase E",
        "fuel": "PHEV",
        "power": "313 / 585",
        "length": "4.949",
        "width": "1.880",
        "height": "1.469",
        "trunk": "370",
        "price": "63.425€"
      },
      {
        "id": "clase-e-estate",
        "name": "Clase E Estate",
        "fuel": "Híbrid",
        "power": "197 / 204",
        "length": "4.949",
        "width": "1.880",
        "height": "1.469",
        "trunk": "615–1.830",
        "price": "63.425€"
      },
      {
        "id": "clase-e-estate",
        "name": "Clase E Estate",
        "fuel": "PHEV",
        "power": "313",
        "length": "4.949",
        "width": "1.880",
        "height": "1.469",
        "trunk": "460–1.675",
        "price": "63.425€"
      },
      {
        "id": "clase-g",
        "name": "Clase G",
        "fuel": "Elèctric",
        "power": "587",
        "length": "4.624",
        "width": "1.913",
        "height": "1.986",
        "trunk": "N.D.",
        "price": "148.675€"
      },
      {
        "id": "clase-g",
        "name": "Clase G",
        "fuel": "Híbrid",
        "power": "367 / 449 / 585",
        "length": "4.873",
        "width": "1.984",
        "height": "1.976",
        "trunk": "N.D.",
        "price": "148.675€"
      },
      {
        "id": "clase-t",
        "name": "Clase T",
        "fuel": "Dièsel",
        "power": "95 / 116",
        "length": "4.498",
        "width": "1.859",
        "height": "1.811",
        "trunk": "520",
        "price": "28.062€"
      },
      {
        "id": "clase-t",
        "name": "Clase T",
        "fuel": "Gasolina",
        "power": "102 / 131",
        "length": "4.498",
        "width": "1.859",
        "height": "1.811",
        "trunk": "520",
        "price": "28.062€"
      },
      {
        "id": "cle-coupe",
        "name": "CLE Coupé",
        "fuel": "Híbrid",
        "power": "200 / 204 / 258 / 499",
        "length": "4.853",
        "width": "1.935",
        "height": "1.434",
        "trunk": "410",
        "price": "58.899€"
      },
      {
        "id": "cls-coupe",
        "name": "CLS Coupé",
        "fuel": "Dièsel",
        "power": "194 / 330",
        "length": "4.988",
        "width": "2.069",
        "height": "1.429",
        "trunk": "520",
        "price": "74.475€"
      },
      {
        "id": "cls-coupe",
        "name": "CLS Coupé",
        "fuel": "Híbrid",
        "power": "265 / 299 / 367 / 435",
        "length": "4.988",
        "width": "2.069",
        "height": "1.435",
        "trunk": "490",
        "price": "74.475€"
      },
      {
        "id": "coupe-4-puertas",
        "name": "Coupé 4 puertas",
        "fuel": "Híbrid",
        "power": "435",
        "length": "5.054",
        "width": "1.871",
        "height": "1.455",
        "trunk": "456",
        "price": "156.990€"
      },
      {
        "id": "eqa",
        "name": "EQA",
        "fuel": "Elèctric",
        "power": "190 / 228 / 292",
        "length": "4.463",
        "width": "2.020",
        "height": "1.624",
        "trunk": "340–1.320",
        "price": "49.900€"
      },
      {
        "id": "eqb",
        "name": "EQB",
        "fuel": "Elèctric",
        "power": "190 / 230 / 290",
        "length": "4.684",
        "width": "1.834",
        "height": "1.701",
        "trunk": "495–1.710",
        "price": "55.225€"
      },
      {
        "id": "eqc",
        "name": "EQC",
        "fuel": "Elèctric",
        "power": "408",
        "length": "4.761",
        "width": "2.096",
        "height": "1.622",
        "trunk": "500",
        "price": "81.750€"
      },
      {
        "id": "eqe",
        "name": "EQE",
        "fuel": "Elèctric",
        "power": "292 / 476",
        "length": "4.964",
        "width": "1.906",
        "height": "1.492",
        "trunk": "430",
        "price": "76.000€"
      },
      {
        "id": "eqe-suv",
        "name": "EQE SUV",
        "fuel": "Elèctric",
        "power": "292 / 408 / 476",
        "length": "4.879",
        "width": "2.141",
        "height": "1.672",
        "trunk": "520–1.675",
        "price": "91.575€"
      },
      {
        "id": "eqs",
        "name": "EQS",
        "fuel": "Elèctric",
        "power": "360 / 544 / 658",
        "length": "5.216",
        "width": "1.926",
        "height": "1.512",
        "trunk": "610–1.770",
        "price": "124.429€"
      },
      {
        "id": "eqs-suv",
        "name": "EQS SUV",
        "fuel": "Elèctric",
        "power": "360 / 544",
        "length": "5.125",
        "width": "1.959",
        "height": "1.718",
        "trunk": "645",
        "price": "145.001€"
      },
      {
        "id": "eqt",
        "name": "EQT",
        "fuel": "Elèctric",
        "power": "122",
        "length": "4.498",
        "width": "1.859",
        "height": "1.819",
        "trunk": "N.D.",
        "price": "48.650€"
      },
      {
        "id": "eqv",
        "name": "EQV",
        "fuel": "Elèctric",
        "power": "204",
        "length": "5.370",
        "width": "1.928",
        "height": "1.901",
        "trunk": "N.D.",
        "price": "89.014€"
      },
      {
        "id": "gla",
        "name": "GLA",
        "fuel": "Dièsel",
        "power": "150 / 190",
        "length": "4.410",
        "width": "2.020",
        "height": "1.611",
        "trunk": "425–1.420",
        "price": "38.375€"
      },
      {
        "id": "gla",
        "name": "GLA",
        "fuel": "Gasolina",
        "power": "136 / 163 / 224 / 421",
        "length": "4.436",
        "width": "2.020",
        "height": "1.585",
        "trunk": "435–1.430",
        "price": "38.375€"
      },
      {
        "id": "gla",
        "name": "GLA",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.410",
        "width": "2.020",
        "height": "1.609",
        "trunk": "435–1.430",
        "price": "38.375€"
      },
      {
        "id": "glb",
        "name": "GLB",
        "fuel": "Elèctric",
        "power": "272 / 354",
        "length": "4.732",
        "width": "2.029",
        "height": "1.687",
        "trunk": "540–1.715",
        "price": "40.750€"
      },
      {
        "id": "glc",
        "name": "GLC",
        "fuel": "Híbrid",
        "power": "197 / 204 / 258 / 269 / 367",
        "length": "4.716",
        "width": "1.890",
        "height": "1.648",
        "trunk": "620–1.680",
        "price": "60.024€"
      },
      {
        "id": "glc",
        "name": "GLC",
        "fuel": "PHEV",
        "power": "313 / 335",
        "length": "4.716",
        "width": "1.890",
        "height": "1.648",
        "trunk": "470–1.530",
        "price": "60.024€"
      },
      {
        "id": "glc-coupe",
        "name": "GLC Coupé",
        "fuel": "Híbrid",
        "power": "197 / 204 / 258 / 269",
        "length": "4.764",
        "width": "1.890",
        "height": "1.605",
        "trunk": "390–1.335",
        "price": "60.024€"
      },
      {
        "id": "glc-coupe",
        "name": "GLC Coupé",
        "fuel": "PHEV",
        "power": "313 / 333",
        "length": "4.764",
        "width": "1.890",
        "height": "1.605",
        "trunk": "390–1.335",
        "price": "60.024€"
      },
      {
        "id": "gle",
        "name": "GLE",
        "fuel": "Dièsel",
        "power": "245 / 272 / 330",
        "length": "4.924",
        "width": "1.947",
        "height": "1.772",
        "trunk": "630–2.055",
        "price": "69.800€"
      },
      {
        "id": "gle",
        "name": "GLE",
        "fuel": "Híbrid",
        "power": "367 / 435 / 612",
        "length": "4.924",
        "width": "1.947",
        "height": "1.772",
        "trunk": "N.D.",
        "price": "69.800€"
      },
      {
        "id": "gle",
        "name": "GLE",
        "fuel": "PHEV",
        "power": "320 / 333",
        "length": "4.924",
        "width": "1.947",
        "height": "1.772",
        "trunk": "N.D.",
        "price": "69.800€"
      },
      {
        "id": "gle-coupe",
        "name": "GLE Coupé",
        "fuel": "Dièsel",
        "power": "272 / 330",
        "length": "4.939",
        "width": "2.010",
        "height": "1.730",
        "trunk": "655–1.790",
        "price": "69.800€"
      },
      {
        "id": "gle-coupe",
        "name": "GLE Coupé",
        "fuel": "Híbrid",
        "power": "435 / 612",
        "length": "4.939",
        "width": "2.010",
        "height": "1.730",
        "trunk": "N.D.",
        "price": "69.800€"
      },
      {
        "id": "gle-coupe",
        "name": "GLE Coupé",
        "fuel": "PHEV",
        "power": "320 / 333",
        "length": "4.939",
        "width": "2.010",
        "height": "1.730",
        "trunk": "N.D.",
        "price": "69.800€"
      },
      {
        "id": "gls",
        "name": "GLS",
        "fuel": "Dièsel",
        "power": "286 / 330",
        "length": "5.207",
        "width": "2.157",
        "height": "1.823",
        "trunk": "355–2.400",
        "price": "98.100€"
      },
      {
        "id": "gls",
        "name": "GLS",
        "fuel": "Híbrid",
        "power": "367 / 489 / 612",
        "length": "5.207",
        "width": "2.157",
        "height": "1.823",
        "trunk": "355–2.400",
        "price": "98.100€"
      },
      {
        "id": "marco-polo",
        "name": "Marco Polo",
        "fuel": "Dièsel",
        "power": "163 / 190 / 237",
        "length": "5.140",
        "width": "1.928",
        "height": "1.995",
        "trunk": "N.D.",
        "price": "59.585€"
      },
      {
        "id": "maybach-clase-s",
        "name": "Maybach Clase S",
        "fuel": "Gasolina",
        "power": "612",
        "length": "5.469",
        "width": "1.921",
        "height": "1.510",
        "trunk": "495",
        "price": "260.789€"
      },
      {
        "id": "maybach-gls",
        "name": "Maybach GLS",
        "fuel": "Híbrid",
        "power": "558",
        "length": "5.205",
        "width": "2.157",
        "height": "1.838",
        "trunk": "N.D.",
        "price": "188.925€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "typ-1255-1460",
        "name": "Typ 12/55 - 14/60",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1926–1929"
      },
      {
        "id": "typ-838",
        "name": "Typ 8/38",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1926–1933"
      },
      {
        "id": "g1",
        "name": "\"G1",
        "fuel": "G4",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "G5",
        "years": "L 1500 A"
      },
      {
        "id": "typ-s",
        "name": "\"Typ S",
        "fuel": "SS",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "SSK",
        "years": "SSKL\""
      },
      {
        "id": "typ-nurburg",
        "name": "Typ Nurburg",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1928–1939"
      },
      {
        "id": "typ-mannheim",
        "name": "Typ Mannheim",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1929–1934"
      },
      {
        "id": "typ-stuttgart",
        "name": "Typ Stuttgart",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1929–1934"
      },
      {
        "id": "pullman",
        "name": "Pullman",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "17",
        "years": "1930–2020"
      },
      {
        "id": "typ-170170-v",
        "name": "Typ 170/170 V",
        "fuel": "Gasolina / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1931–1942"
      },
      {
        "id": "typ-770",
        "name": "Typ 770",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "11",
        "years": "1931–1943"
      },
      {
        "id": "typ-200",
        "name": "Typ 200",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1933–1936"
      },
      {
        "id": "typ-290",
        "name": "Typ 290",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1933–1937"
      },
      {
        "id": "typ-380",
        "name": "Typ 380",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1933–1934"
      },
      {
        "id": "typ-130",
        "name": "\"Typ 130",
        "fuel": "150 and 170 H\"",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "Gasolina",
        "years": "3"
      },
      {
        "id": "typ-500-k540-k",
        "name": "Typ 500 K/540 K",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "11",
        "years": "1934–1939"
      },
      {
        "id": "typ-230",
        "name": "\"Typ 230",
        "fuel": "260 D\"",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "Gasolina / Dièsel",
        "years": "7"
      },
      {
        "id": "typ-320",
        "name": "Typ 320",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1937–1942"
      },
      {
        "id": "s-class-cabriolet",
        "name": "S-Class Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1952–2020"
      },
      {
        "id": "cl-klasse-and-predecessors",
        "name": "CL-Klasse and predecessors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "15",
        "years": "1952–2014"
      },
      {
        "id": "sl-klasse",
        "name": "SL-Klasse",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "13",
        "years": "1954–2020"
      },
      {
        "id": "slk-klasse",
        "name": "SLK-Klasse",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1955–2016"
      },
      {
        "id": "laundalet",
        "name": "Laundalet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1960–1981"
      },
      {
        "id": "e-klasse-t-modell",
        "name": "E-Klasse T-Modell",
        "fuel": "Gasolina / Dièsel / Híbrid dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "11",
        "years": "1965–2020"
      },
      {
        "id": "e-klasse-coupe-and-predecessors",
        "name": "E-Klasse Coupe and predecessors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "11",
        "years": "1969–2020"
      },
      {
        "id": "g-klasse-cabriolet",
        "name": "G-Klasse Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1979–2013"
      },
      {
        "id": "g-klasse-kurz",
        "name": "G-Klasse Kurz",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1979–2012"
      },
      {
        "id": "c-klasse-amg",
        "name": "C-Klasse AMG",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "9",
        "years": "1984–2015"
      },
      {
        "id": "clk-gtr",
        "name": "CLK GTR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–1999"
      },
      {
        "id": "clk-amg",
        "name": "CLK AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1999–2009"
      },
      {
        "id": "g-klasse-amg",
        "name": "G-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1999–2018"
      },
      {
        "id": "m-klasse",
        "name": "M-Klasse",
        "fuel": "Gasolina / Dièsel / Híbrid gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1997–2015"
      },
      {
        "id": "m-klasse-amg",
        "name": "M-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1999–2015"
      },
      {
        "id": "sl-amg",
        "name": "SL AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "13",
        "years": "1999–2019"
      },
      {
        "id": "s-klasse-amg",
        "name": "S-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "10",
        "years": "1999–2017"
      },
      {
        "id": "c-klasse-sportcoupeclc",
        "name": "C-Klasse SportCoupe/CLC",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2011"
      },
      {
        "id": "cl-amg",
        "name": "CL AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "9",
        "years": "2000–2014"
      },
      {
        "id": "clk-amg-cabrio",
        "name": "CLK AMG Cabrio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2009"
      },
      {
        "id": "slk-amg",
        "name": "SLK AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2000–2016"
      },
      {
        "id": "v-class-and-predecessors",
        "name": "V-Class and predecessors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1996–2023"
      },
      {
        "id": "vaneo",
        "name": "VANEO",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2006"
      },
      {
        "id": "viano",
        "name": "VIANO",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2014"
      },
      {
        "id": "slr-mclaren",
        "name": "SLR McLaren",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2003–2009"
      },
      {
        "id": "cls-amg",
        "name": "CLS AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2004–2018"
      },
      {
        "id": "e-klasse-amg",
        "name": "E-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1996–2016"
      },
      {
        "id": "e-klasse-t-modell-amg",
        "name": "E-Klasse T-Modell AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2004–2017"
      },
      {
        "id": "r-klasse",
        "name": "R-Klasse",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2013"
      },
      {
        "id": "r-klasse-lang",
        "name": "R-Klasse Lang",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2013"
      },
      {
        "id": "r-klasse-amg",
        "name": "R-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2008"
      },
      {
        "id": "gl-klasse",
        "name": "GL-Klasse",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2006–2016"
      },
      {
        "id": "glk-klasse",
        "name": "GLK-Klasse",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2016"
      },
      {
        "id": "sls-amg",
        "name": "SLS AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2010–2015"
      },
      {
        "id": "c-klasse-coupe",
        "name": "C-Klasse Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2018"
      },
      {
        "id": "c-klasse-coupe-amg",
        "name": "C-Klasse Coupe AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2016"
      },
      {
        "id": "cls-shooting-brake",
        "name": "CLS Shooting Brake",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2012–2017"
      },
      {
        "id": "gl-klasse-amg",
        "name": "GL-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2016"
      },
      {
        "id": "cla-45",
        "name": "CLA 45",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      },
      {
        "id": "a-klasse-amg",
        "name": "A-Klasse AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2015"
      },
      {
        "id": "cls-shooting-brake-amg",
        "name": "CLS Shooting Brake AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "s-class-coupe-amg",
        "name": "S-Class Coupe AMG",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2017"
      },
      {
        "id": "s-klasse-coupe",
        "name": "S-Klasse Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2020"
      },
      {
        "id": "c-class-cabriolet",
        "name": "C-Class Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2022"
      },
      {
        "id": "slc-class",
        "name": "SLC-Class",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2020"
      },
      {
        "id": "a-class-sedan",
        "name": "A-Class Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2018–2023"
      },
      {
        "id": "x-class",
        "name": "X-Class",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      }
    ]
  },
  {
    "id": "mg",
    "name": "MG",
    "logo": "🔺",
    "description": "British Heritage",
    "models": [
      {
        "id": "4",
        "name": "4",
        "fuel": "Elèctric",
        "power": "170 / 204 / 245 / 435",
        "length": "4.287",
        "width": "1.836",
        "height": "1.516",
        "trunk": "363–1.165",
        "price": "26.480€"
      },
      {
        "id": "5-electric",
        "name": "5 Electric",
        "fuel": "Elèctric",
        "power": "184",
        "length": "4.544",
        "width": "1.811",
        "height": "1.513",
        "trunk": "578–1.456",
        "price": "N.D.€"
      },
      {
        "id": "ehs-plug-in-hybrid",
        "name": "EHS Plug-in Hybrid",
        "fuel": "PHEV",
        "power": "258",
        "length": "4.574",
        "width": "1.876",
        "height": "1.685",
        "trunk": "463–1.287",
        "price": "29.999€"
      },
      {
        "id": "hs",
        "name": "HS",
        "fuel": "Gasolina",
        "power": "162",
        "length": "4.610",
        "width": "1.876",
        "height": "1.685",
        "trunk": "463–1.454",
        "price": "27.440€"
      },
      {
        "id": "marvel-r-electric",
        "name": "Marvel R Electric",
        "fuel": "Elèctric",
        "power": "288",
        "length": "4.674",
        "width": "1.919",
        "height": "1.618",
        "trunk": "357–1.396",
        "price": "N.D.€"
      },
      {
        "id": "mgs5",
        "name": "MGS5",
        "fuel": "Elèctric",
        "power": "170 / 231",
        "length": "4.476",
        "width": "1.849",
        "height": "1.621",
        "trunk": "453–1.441",
        "price": "32.990€"
      },
      {
        "id": "mgs6",
        "name": "MGS6",
        "fuel": "Elèctric",
        "power": "245 / 361",
        "length": "4.708",
        "width": "1.912",
        "height": "1.672",
        "trunk": "674–1.910",
        "price": "45.990€"
      },
      {
        "id": "zs",
        "name": "ZS",
        "fuel": "Gasolina",
        "power": "106 / 111",
        "length": "4.323",
        "width": "1.809",
        "height": "1.653",
        "trunk": "448–1.166",
        "price": "17.190€"
      },
      {
        "id": "zs-ev",
        "name": "ZS EV",
        "fuel": "Elèctric",
        "power": "154 / 177",
        "length": "4.323",
        "width": "1.809",
        "height": "1.649",
        "trunk": "448–1.166",
        "price": "17.190€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "ftf",
        "name": "F/TF",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2005"
      },
      {
        "id": "zr-3-doors",
        "name": "ZR 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2005"
      },
      {
        "id": "zr-5-doors",
        "name": "ZR 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2005"
      },
      {
        "id": "zs-sedan",
        "name": "ZS Sedan",
        "fuel": "Dièsel / Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2005"
      },
      {
        "id": "zs-hatchback",
        "name": "ZS Hatchback",
        "fuel": "Dièsel / Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2005"
      },
      {
        "id": "zt",
        "name": "ZT",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2005"
      },
      {
        "id": "zt-t",
        "name": "ZT-T",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2005"
      },
      {
        "id": "xpower",
        "name": "XPower",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2005"
      },
      {
        "id": "mg-6",
        "name": "MG 6",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2016"
      },
      {
        "id": "gs",
        "name": "GS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2019"
      }
    ]
  },
  {
    "id": "microlino",
    "name": "Microlino",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "microlino",
        "name": "Microlino",
        "fuel": "Elèctric",
        "power": "17",
        "length": "2.519",
        "width": "1.473",
        "height": "1.501",
        "trunk": "230",
        "price": "22.900€"
      }
    ]
  },
  {
    "id": "mini",
    "name": "Mini",
    "logo": "🔘",
    "description": "Not Normal",
    "models": [
      {
        "id": "3-puertas",
        "name": "3 puertas",
        "fuel": "Elèctric",
        "power": "184",
        "length": "3.850",
        "width": "1.727",
        "height": "1.432",
        "trunk": "211–731",
        "price": "22.300€"
      },
      {
        "id": "3-puertas",
        "name": "3 puertas",
        "fuel": "Gasolina",
        "power": "102 / 136 / 178",
        "length": "3.863",
        "width": "1.727",
        "height": "1.414",
        "trunk": "211–731",
        "price": "22.300€"
      },
      {
        "id": "3-puertas-john-cooper-works",
        "name": "3 puertas John Cooper Works",
        "fuel": "Gasolina",
        "power": "231",
        "length": "3.872",
        "width": "1.727",
        "height": "1.414",
        "trunk": "211–731",
        "price": "22.300€"
      },
      {
        "id": "aceman",
        "name": "Aceman",
        "fuel": "Elèctric",
        "power": "184 / 218 / 258",
        "length": "4.079",
        "width": "1.754",
        "height": "1.514",
        "trunk": "300–1.005",
        "price": "32.555€"
      },
      {
        "id": "cabrio",
        "name": "Cabrio",
        "fuel": "Gasolina",
        "power": "102 / 136 / 178",
        "length": "3.863",
        "width": "1.727",
        "height": "1.415",
        "trunk": "160–215",
        "price": "26.300€"
      },
      {
        "id": "cabrio-john-cooper-works",
        "name": "Cabrio John Cooper Works",
        "fuel": "Gasolina",
        "power": "231",
        "length": "3.872",
        "width": "1.727",
        "height": "1.415",
        "trunk": "160–215",
        "price": "26.300€"
      },
      {
        "id": "clubman",
        "name": "Clubman",
        "fuel": "Dièsel",
        "power": "116 / 150 / 190",
        "length": "4.260",
        "width": "1.800",
        "height": "1.441",
        "trunk": "360–1.250",
        "price": "26.750€"
      },
      {
        "id": "clubman",
        "name": "Clubman",
        "fuel": "Gasolina",
        "power": "102 / 136 / 178 / 192",
        "length": "4.266",
        "width": "1.800",
        "height": "1.441",
        "trunk": "360–1.250",
        "price": "26.750€"
      },
      {
        "id": "clubman-john-cooper-works",
        "name": "Clubman John Cooper Works",
        "fuel": "Gasolina",
        "power": "306",
        "length": "4.266",
        "width": "1.800",
        "height": "1.441",
        "trunk": "360–1.250",
        "price": "26.750€"
      },
      {
        "id": "cooper",
        "name": "Cooper",
        "fuel": "Gasolina",
        "power": "156 / 204",
        "length": "4.036",
        "width": "1.744",
        "height": "1.464",
        "trunk": "275–925",
        "price": "23.100€"
      },
      {
        "id": "countryman",
        "name": "Countryman",
        "fuel": "Elèctric",
        "power": "204 / 313",
        "length": "4.445",
        "width": "1.843",
        "height": "1.635",
        "trunk": "460–1.450",
        "price": "39.850€"
      },
      {
        "id": "countryman",
        "name": "Countryman",
        "fuel": "Híbrid",
        "power": "163 / 170 / 218",
        "length": "4.444",
        "width": "1.843",
        "height": "1.661",
        "trunk": "450–1.450",
        "price": "39.850€"
      },
      {
        "id": "countryman-john-cooper-works",
        "name": "Countryman John Cooper Works",
        "fuel": "Gasolina",
        "power": "300",
        "length": "4.447",
        "width": "1.843",
        "height": "1.645",
        "trunk": "505–1.530",
        "price": "39.850€"
      },
      {
        "id": "john-cooper-works",
        "name": "John Cooper Works",
        "fuel": "Gasolina",
        "power": "231",
        "length": "3.876",
        "width": "1.744",
        "height": "1.452",
        "trunk": "210–725",
        "price": "22.300€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "clubvan",
        "name": "Clubvan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2014"
      },
      {
        "id": "coupe",
        "name": "Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2015"
      },
      {
        "id": "roadster",
        "name": "Roadster",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2015"
      },
      {
        "id": "paceman",
        "name": "Paceman",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      }
    ]
  },
  {
    "id": "mitsubishi",
    "name": "Mitsubishi",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "asx",
        "name": "ASX",
        "fuel": "Gasolina",
        "power": "90",
        "length": "4.227",
        "width": "1.797",
        "height": "1.567",
        "trunk": "422–1.275",
        "price": "21.390€"
      },
      {
        "id": "asx",
        "name": "ASX",
        "fuel": "Híbrid",
        "power": "140 / 145 / 160",
        "length": "4.227",
        "width": "1.797",
        "height": "1.567",
        "trunk": "422–1.275",
        "price": "21.390€"
      },
      {
        "id": "colt",
        "name": "Colt",
        "fuel": "Gasolina",
        "power": "65 / 90",
        "length": "4.053",
        "width": "1.798",
        "height": "1.439",
        "trunk": "391–1.069",
        "price": "17.790€"
      },
      {
        "id": "colt",
        "name": "Colt",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.053",
        "width": "1.798",
        "height": "1.439",
        "trunk": "391–1.069",
        "price": "17.790€"
      },
      {
        "id": "grandis",
        "name": "Grandis",
        "fuel": "Híbrid",
        "power": "140 / 160",
        "length": "4.413",
        "width": "1.797",
        "height": "1.575",
        "trunk": "N.D.",
        "price": "27.300€"
      },
      {
        "id": "l200",
        "name": "L200",
        "fuel": "Dièsel",
        "power": "150",
        "length": "5.215",
        "width": "1.815",
        "height": "1.780",
        "trunk": "N.D.",
        "price": "30.300€"
      },
      {
        "id": "outlander",
        "name": "Outlander",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.695",
        "width": "1.810",
        "height": "1.710",
        "trunk": "550–1.718",
        "price": "30.400€"
      },
      {
        "id": "outlander-phev",
        "name": "Outlander PHEV",
        "fuel": "PHEV",
        "power": "224",
        "length": "4.695",
        "width": "1.800",
        "height": "1.710",
        "trunk": "498–921",
        "price": "30.400€"
      },
      {
        "id": "space-star",
        "name": "Space Star",
        "fuel": "Gasolina",
        "power": "71",
        "length": "3.845",
        "width": "1.665",
        "height": "1.505",
        "trunk": "209",
        "price": "13.150€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "pajero-3-doors",
        "name": "Pajero 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1982–2009"
      },
      {
        "id": "pajero-5-doors",
        "name": "Pajero 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1983–2009"
      },
      {
        "id": "starion",
        "name": "Starion",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1982–1991"
      },
      {
        "id": "l300",
        "name": "L300",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1994"
      },
      {
        "id": "colt-3-doors",
        "name": "Colt 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1988–2012"
      },
      {
        "id": "galant",
        "name": "Galant",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1988–2012"
      },
      {
        "id": "lancer",
        "name": "Lancer",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1988–2017"
      },
      {
        "id": "lancer-hatchback",
        "name": "Lancer Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1988–2017"
      },
      {
        "id": "eclipse",
        "name": "Eclipse",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1989–2012"
      },
      {
        "id": "lancer-combi",
        "name": "Lancer Combi",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1989–2006"
      },
      {
        "id": "3000-gt",
        "name": "3000 GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1990–2001"
      },
      {
        "id": "sigma",
        "name": "Sigma",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1996"
      },
      {
        "id": "space-runner",
        "name": "Space Runner",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1999"
      },
      {
        "id": "lancer-evolution",
        "name": "Lancer Evolution",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "10",
        "years": "1992–2016"
      },
      {
        "id": "l-200",
        "name": "L 200",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "8",
        "years": "1995–2019"
      },
      {
        "id": "carisma-sedan",
        "name": "Carisma Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2004"
      },
      {
        "id": "pajero-pinin-shogun-pinin-montero-io",
        "name": "Pajero Pinin / Shogun Pinin / Montero iO",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2007"
      },
      {
        "id": "galant-station-wagon",
        "name": "Galant Station Wagon",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2001"
      },
      {
        "id": "eclipse-spyder",
        "name": "Eclipse Spyder",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2012"
      },
      {
        "id": "endeavor",
        "name": "Endeavor",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2011"
      },
      {
        "id": "raider-crew-cab",
        "name": "Raider Crew Cab",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2009"
      },
      {
        "id": "raider-double-cab",
        "name": "Raider Double Cab",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2009"
      },
      {
        "id": "colt-czc",
        "name": "Colt CZC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2012"
      },
      {
        "id": "i-miev",
        "name": "i-MiEV",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2021"
      },
      {
        "id": "mirage",
        "name": "Mirage",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2012–2024"
      },
      {
        "id": "mirage-g4",
        "name": "Mirage G4",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2019"
      },
      {
        "id": "attrage",
        "name": "Attrage",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2024"
      }
    ]
  },
  {
    "id": "nio",
    "name": "NIO",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "el7",
        "name": "EL7",
        "fuel": "Elèctric",
        "power": "653",
        "length": "4.912",
        "width": "1.987",
        "height": "1.720",
        "trunk": "570–1.545",
        "price": "N.D.€"
      },
      {
        "id": "et5",
        "name": "ET5",
        "fuel": "Elèctric",
        "power": "490",
        "length": "4.790",
        "width": "1.960",
        "height": "1.499",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "et7",
        "name": "ET7",
        "fuel": "Elèctric",
        "power": "653",
        "length": "5.101",
        "width": "1.987",
        "height": "1.509",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ]
  },
  {
    "id": "nissan",
    "name": "Nissan",
    "logo": "⭕",
    "description": "Innovation That Excites",
    "models": [
      {
        "id": "ariya",
        "name": "Ariya",
        "fuel": "Elèctric",
        "power": "218 / 242 / 279 / 306",
        "length": "4.595",
        "width": "1.850",
        "height": "1.660",
        "trunk": "466",
        "price": "64.000€"
      },
      {
        "id": "ariya-nismo",
        "name": "Ariya Nismo",
        "fuel": "Elèctric",
        "power": "435",
        "length": "4.655",
        "width": "1.850",
        "height": "1.660",
        "trunk": "415–1.280",
        "price": "64.000€"
      },
      {
        "id": "gt-r",
        "name": "GT-R",
        "fuel": "Gasolina",
        "power": "570",
        "length": "4.710",
        "width": "1.895",
        "height": "1.370",
        "trunk": "315",
        "price": "117.200€"
      },
      {
        "id": "juke",
        "name": "Juke",
        "fuel": "Gasolina",
        "power": "114",
        "length": "4.210",
        "width": "1.800",
        "height": "1.595",
        "trunk": "422–1.305",
        "price": "21.700€"
      },
      {
        "id": "juke",
        "name": "Juke",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.210",
        "width": "1.800",
        "height": "1.595",
        "trunk": "354",
        "price": "21.700€"
      },
      {
        "id": "leaf",
        "name": "Leaf",
        "fuel": "Elèctric",
        "power": "150 / 217",
        "length": "4.490",
        "width": "1.788",
        "height": "1.545",
        "trunk": "435",
        "price": "35.620€"
      },
      {
        "id": "micra",
        "name": "Micra",
        "fuel": "Gasolina",
        "power": "92",
        "length": "3.999",
        "width": "1.743",
        "height": "1.455",
        "trunk": "300–1.004",
        "price": "18.707€"
      },
      {
        "id": "navara",
        "name": "Navara",
        "fuel": "Dièsel",
        "power": "160 / 190",
        "length": "5.330",
        "width": "1.850",
        "height": "1.828",
        "trunk": "N.D.",
        "price": "34.516€"
      },
      {
        "id": "nv300",
        "name": "NV300",
        "fuel": "Dièsel",
        "power": "110",
        "length": "N.D.",
        "width": "N.D.",
        "height": "N.D.",
        "trunk": "N.D.",
        "price": "29.742€"
      },
      {
        "id": "qashqai",
        "name": "Qashqai",
        "fuel": "Híbrid",
        "power": "140 / 158 / 190",
        "length": "4.425",
        "width": "1.848",
        "height": "1.625",
        "trunk": "N.D.",
        "price": "30.650€"
      },
      {
        "id": "x-trail",
        "name": "X-Trail",
        "fuel": "Gasolina",
        "power": "160",
        "length": "4.690",
        "width": "1.820",
        "height": "1.710",
        "trunk": "565–1.996",
        "price": "36.496€"
      },
      {
        "id": "x-trail",
        "name": "X-Trail",
        "fuel": "Híbrid",
        "power": "163 / 204 / 213",
        "length": "4.680",
        "width": "1.840",
        "height": "1.695",
        "trunk": "585–1.424",
        "price": "36.496€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "micra-3-doors",
        "name": "Micra 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1982–2007"
      },
      {
        "id": "300-zx",
        "name": "300 ZX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1984–1996"
      },
      {
        "id": "bluebird-hatchback",
        "name": "Bluebird Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1990"
      },
      {
        "id": "bluebird-sedan",
        "name": "Bluebird Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1990"
      },
      {
        "id": "bluebird-traveller",
        "name": "Bluebird Traveller",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1990"
      },
      {
        "id": "terrano-3-doors",
        "name": "Terrano 3 Doors",
        "fuel": "Dièsel / Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1988–2006"
      },
      {
        "id": "patrol-swb",
        "name": "Patrol SWB",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1988–2010"
      },
      {
        "id": "200-sx",
        "name": "200 SX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1989–2000"
      },
      {
        "id": "maxima",
        "name": "Maxima",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1989–2023"
      },
      {
        "id": "prairie",
        "name": "Prairie",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1996"
      },
      {
        "id": "sunny-3-doors",
        "name": "Sunny 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "sunny-hatchback",
        "name": "Sunny Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "sunny-sedan",
        "name": "Sunny Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1995"
      },
      {
        "id": "sunny-traveller",
        "name": "Sunny Traveller",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1996"
      },
      {
        "id": "primera-break",
        "name": "Primera Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1990–2007"
      },
      {
        "id": "primera-hatchback",
        "name": "Primera Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1990–2007"
      },
      {
        "id": "primera-sedan",
        "name": "Primera Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1990–2008"
      },
      {
        "id": "100-nx",
        "name": "100 NX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1996"
      },
      {
        "id": "serena",
        "name": "Serena",
        "fuel": "Dièsel / Gasolina / Mild hybrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1991–2022"
      },
      {
        "id": "liberty",
        "name": "Liberty",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2004"
      },
      {
        "id": "almera-pulsar-3-doors",
        "name": "Almera / Pulsar 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1995–2007"
      },
      {
        "id": "almera-pulsar-5-doors",
        "name": "Almera / Pulsar 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1995–2018"
      },
      {
        "id": "almera-pulsar-sedan",
        "name": "Almera / Pulsar Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1995–2019"
      },
      {
        "id": "almera-tino",
        "name": "Almera Tino",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2006"
      },
      {
        "id": "xterra",
        "name": "XTerra",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2002–2015"
      },
      {
        "id": "350z",
        "name": "350Z",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2008"
      },
      {
        "id": "350z-roadster",
        "name": "350Z Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2009"
      },
      {
        "id": "note",
        "name": "Note",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2005–2019"
      },
      {
        "id": "grand-livina",
        "name": "Grand Livina",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2013"
      },
      {
        "id": "platina",
        "name": "Platina",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2010"
      },
      {
        "id": "tiida-versa",
        "name": "Tiida / Versa",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2018"
      },
      {
        "id": "370z",
        "name": "370Z",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2020"
      },
      {
        "id": "370z-roadster",
        "name": "370Z Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2020"
      },
      {
        "id": "370z-nismo",
        "name": "370Z Nismo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2009–2021"
      },
      {
        "id": "cube",
        "name": "Cube",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2019"
      },
      {
        "id": "np300",
        "name": "NP300",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2008–2015"
      },
      {
        "id": "nv",
        "name": "NV",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2019"
      },
      {
        "id": "pixo",
        "name": "Pixo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      },
      {
        "id": "murano-crosscabriolet",
        "name": "Murano CrossCabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2014"
      },
      {
        "id": "micra-cc",
        "name": "Micra C+C",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2008"
      },
      {
        "id": "juke-nismo",
        "name": "Juke Nismo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2017"
      },
      {
        "id": "teana",
        "name": "Teana",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2013"
      },
      {
        "id": "quest",
        "name": "Quest",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2004–2017"
      },
      {
        "id": "titan-crew-cab",
        "name": "Titan Crew Cab",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2004–2024"
      },
      {
        "id": "titan-king-cab",
        "name": "Titan King Cab",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2015"
      },
      {
        "id": "terrano-5-doors",
        "name": "Terrano 5 Doors",
        "fuel": "Dièsel / Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1990–2019"
      },
      {
        "id": "sunny",
        "name": "Sunny",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2019"
      },
      {
        "id": "skyline",
        "name": "Skyline",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2001–2010"
      }
    ]
  },
  {
    "id": "omoda",
    "name": "Omoda",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "5",
        "name": "5",
        "fuel": "Gasolina",
        "power": "145",
        "length": "4.373",
        "width": "1.824",
        "height": "1.588",
        "trunk": "N.D.",
        "price": "26.264€"
      },
      {
        "id": "5-ev",
        "name": "5 EV",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.424",
        "width": "1.830",
        "height": "1.588",
        "trunk": "380–1.075",
        "price": "26.264€"
      },
      {
        "id": "9",
        "name": "9",
        "fuel": "PHEV",
        "power": "537",
        "length": "4.775",
        "width": "1.920",
        "height": "1.671",
        "trunk": "471–1.004",
        "price": "39.990€"
      }
    ]
  },
  {
    "id": "opel",
    "name": "Opel",
    "logo": "⚡",
    "description": "Wir leben Autos",
    "models": [
      {
        "id": "astra",
        "name": "Astra",
        "fuel": "Dièsel",
        "power": "130",
        "length": "4.374",
        "width": "1.859",
        "height": "1.460",
        "trunk": "422–1.339",
        "price": "26.500€"
      },
      {
        "id": "astra",
        "name": "Astra",
        "fuel": "Elèctric",
        "power": "156",
        "length": "4.374",
        "width": "1.859",
        "height": "1.460",
        "trunk": "352–1.268",
        "price": "26.500€"
      },
      {
        "id": "astra",
        "name": "Astra",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.374",
        "width": "1.859",
        "height": "1.460",
        "trunk": "422–1.339",
        "price": "26.500€"
      },
      {
        "id": "astra",
        "name": "Astra",
        "fuel": "PHEV",
        "power": "195",
        "length": "4.374",
        "width": "1.859",
        "height": "1.460",
        "trunk": "310–1.236",
        "price": "26.500€"
      },
      {
        "id": "astra-sports-tourer",
        "name": "Astra Sports Tourer",
        "fuel": "Dièsel",
        "power": "130",
        "length": "4.642",
        "width": "1.859",
        "height": "1.443",
        "trunk": "597–1.634",
        "price": "26.500€"
      },
      {
        "id": "astra-sports-tourer",
        "name": "Astra Sports Tourer",
        "fuel": "Elèctric",
        "power": "156",
        "length": "4.642",
        "width": "1.859",
        "height": "1.443",
        "trunk": "516–1.553",
        "price": "26.500€"
      },
      {
        "id": "astra-sports-tourer",
        "name": "Astra Sports Tourer",
        "fuel": "Híbrid",
        "power": "145",
        "length": "4.642",
        "width": "1.859",
        "height": "1.443",
        "trunk": "597–1.634",
        "price": "26.500€"
      },
      {
        "id": "astra-sports-tourer",
        "name": "Astra Sports Tourer",
        "fuel": "PHEV",
        "power": "195",
        "length": "4.642",
        "width": "1.859",
        "height": "1.443",
        "trunk": "466–1.483",
        "price": "26.500€"
      },
      {
        "id": "cabrio",
        "name": "Cabrio",
        "fuel": "Gasolina",
        "power": "136",
        "length": "4.696",
        "width": "1.839",
        "height": "1.443",
        "trunk": "280–380",
        "price": "34.300€"
      },
      {
        "id": "combo-e-life",
        "name": "Combo e-Life",
        "fuel": "Elèctric",
        "power": "136",
        "length": "4.403",
        "width": "1.848",
        "height": "1.841",
        "trunk": "597–2.126",
        "price": "36.900€"
      },
      {
        "id": "corsa",
        "name": "Corsa",
        "fuel": "Gasolina",
        "power": "75 / 100",
        "length": "4.060",
        "width": "1.765",
        "height": "1.435",
        "trunk": "309–1.081",
        "price": "18.900€"
      },
      {
        "id": "corsa-gse",
        "name": "Corsa GSE",
        "fuel": "Elèctric",
        "power": "281",
        "length": "4.060",
        "width": "1.765",
        "height": "N.D.",
        "trunk": "N.D.",
        "price": "18.900€"
      },
      {
        "id": "corsa-e",
        "name": "Corsa-e",
        "fuel": "Elèctric",
        "power": "136 / 156",
        "length": "4.060",
        "width": "1.765",
        "height": "1.435",
        "trunk": "267–1.042",
        "price": "18.900€"
      },
      {
        "id": "crossland",
        "name": "Crossland",
        "fuel": "Dièsel",
        "power": "110 / 120",
        "length": "4.217",
        "width": "1.765",
        "height": "1.605",
        "trunk": "410–1.255",
        "price": "19.400€"
      },
      {
        "id": "crossland",
        "name": "Crossland",
        "fuel": "Gasolina",
        "power": "110 / 131",
        "length": "4.217",
        "width": "1.765",
        "height": "1.605",
        "trunk": "520–1.255",
        "price": "19.400€"
      },
      {
        "id": "frontera",
        "name": "Frontera",
        "fuel": "Elèctric",
        "power": "113",
        "length": "4.385",
        "width": "1.795",
        "height": "1.635",
        "trunk": "460–1.600",
        "price": "24.300€"
      },
      {
        "id": "frontera",
        "name": "Frontera",
        "fuel": "Híbrid",
        "power": "100 / 136",
        "length": "4.385",
        "width": "1.795",
        "height": "1.635",
        "trunk": "460–1.600",
        "price": "24.300€"
      },
      {
        "id": "grandland",
        "name": "Grandland",
        "fuel": "Elèctric",
        "power": "213",
        "length": "4.650",
        "width": "1.905",
        "height": "1.666",
        "trunk": "550–1.645",
        "price": "32.400€"
      },
      {
        "id": "grandland",
        "name": "Grandland",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.650",
        "width": "1.905",
        "height": "1.666",
        "trunk": "550–1.645",
        "price": "32.400€"
      },
      {
        "id": "grandland",
        "name": "Grandland",
        "fuel": "PHEV",
        "power": "195 / 300",
        "length": "4.488",
        "width": "1.856",
        "height": "1.609",
        "trunk": "390–1.528",
        "price": "32.400€"
      },
      {
        "id": "insignia",
        "name": "Insignia",
        "fuel": "Dièsel",
        "power": "122 / 174",
        "length": "4.897",
        "width": "1.863",
        "height": "1.455",
        "trunk": "N.D.",
        "price": "28.900€"
      },
      {
        "id": "insignia-country-tourer",
        "name": "Insignia Country Tourer",
        "fuel": "Dièsel",
        "power": "170 / 210",
        "length": "5.004",
        "width": "1.941",
        "height": "1.525",
        "trunk": "560–1.665",
        "price": "28.900€"
      },
      {
        "id": "insignia-country-tourer",
        "name": "Insignia Country Tourer",
        "fuel": "Gasolina",
        "power": "260",
        "length": "5.004",
        "width": "1.941",
        "height": "1.525",
        "trunk": "560–1.665",
        "price": "28.900€"
      },
      {
        "id": "insignia-grand-sport",
        "name": "Insignia Grand Sport",
        "fuel": "Dièsel",
        "power": "110 / 136 / 170 / 210",
        "length": "4.897",
        "width": "1.863",
        "height": "1.455",
        "trunk": "490–1.450",
        "price": "28.900€"
      },
      {
        "id": "insignia-grand-sport",
        "name": "Insignia Grand Sport",
        "fuel": "Gasolina",
        "power": "140 / 165 / 260",
        "length": "4.897",
        "width": "1.863",
        "height": "1.455",
        "trunk": "490–1.450",
        "price": "28.900€"
      },
      {
        "id": "insignia-sports-tourer",
        "name": "Insignia Sports Tourer",
        "fuel": "Dièsel",
        "power": "170 / 210",
        "length": "4.998",
        "width": "1.941",
        "height": "1.490",
        "trunk": "560–1.665",
        "price": "28.900€"
      },
      {
        "id": "insignia-sports-tourer",
        "name": "Insignia Sports Tourer",
        "fuel": "Gasolina",
        "power": "140 / 165 / 260",
        "length": "4.897",
        "width": "1.863",
        "height": "1.500",
        "trunk": "560–1.665",
        "price": "28.900€"
      },
      {
        "id": "karl",
        "name": "Karl",
        "fuel": "Gasolina",
        "power": "75",
        "length": "3.675",
        "width": "1.698",
        "height": "1.475",
        "trunk": "215–1.013",
        "price": "11.410€"
      },
      {
        "id": "mokka",
        "name": "Mokka",
        "fuel": "Elèctric",
        "power": "156",
        "length": "4.150",
        "width": "1.787",
        "height": "1.535",
        "trunk": "310–1.060",
        "price": "26.350€"
      },
      {
        "id": "mokka",
        "name": "Mokka",
        "fuel": "Gasolina",
        "power": "136",
        "length": "4.150",
        "width": "1.787",
        "height": "1.535",
        "trunk": "350–1.105",
        "price": "26.350€"
      },
      {
        "id": "mokka",
        "name": "Mokka",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.150",
        "width": "1.787",
        "height": "1.535",
        "trunk": "350–1.105",
        "price": "26.350€"
      },
      {
        "id": "vivaro",
        "name": "Vivaro",
        "fuel": "Dièsel",
        "power": "95 / 125 / 145",
        "length": "4.999",
        "width": "1.956",
        "height": "1.971",
        "trunk": "1.000–5.200",
        "price": "26.053€"
      },
      {
        "id": "zafira",
        "name": "Zafira",
        "fuel": "Dièsel",
        "power": "120 / 134 / 136 / 170",
        "length": "4.666",
        "width": "1.884",
        "height": "1.660",
        "trunk": "710–1.860",
        "price": "22.350€"
      },
      {
        "id": "zafira",
        "name": "Zafira",
        "fuel": "Gasolina",
        "power": "120 / 136 / 140",
        "length": "4.666",
        "width": "1.884",
        "height": "1.660",
        "trunk": "710–1.860",
        "price": "22.350€"
      },
      {
        "id": "zafira",
        "name": "Zafira",
        "fuel": "GLP",
        "power": "140",
        "length": "4.666",
        "width": "1.884",
        "height": "1.660",
        "trunk": "152–1.860",
        "price": "22.350€"
      },
      {
        "id": "zafira-life",
        "name": "Zafira Life",
        "fuel": "Dièsel",
        "power": "150 / 180",
        "length": "5.306",
        "width": "1.890",
        "height": "3.275",
        "trunk": "1.400–3.300",
        "price": "22.350€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "manta",
        "name": "Manta",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1989"
      },
      {
        "id": "rekord-sedan",
        "name": "Rekord Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1977–1986"
      },
      {
        "id": "rekord-caravan",
        "name": "Rekord Caravan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1977–1986"
      },
      {
        "id": "monza",
        "name": "Monza",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1983–1987"
      },
      {
        "id": "kadett-3-doors",
        "name": "Kadett 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1991"
      },
      {
        "id": "kadett-5-doors",
        "name": "Kadett 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1991"
      },
      {
        "id": "kadett-caravan",
        "name": "Kadett Caravan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1984–1991"
      },
      {
        "id": "kadett-sedan",
        "name": "Kadett Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1991"
      },
      {
        "id": "kadett-cabriolet",
        "name": "Kadett Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1987–1993"
      },
      {
        "id": "omega-sedan",
        "name": "Omega Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1986–2003"
      },
      {
        "id": "omega-caravan",
        "name": "Omega Caravan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1986–2003"
      },
      {
        "id": "vectra-hatchback",
        "name": "Vectra Hatchback",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1988–2008"
      },
      {
        "id": "vectra-sedan",
        "name": "Vectra Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1988–2008"
      },
      {
        "id": "calibra",
        "name": "Calibra",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1997"
      },
      {
        "id": "monterey",
        "name": "Monterey",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–1998"
      },
      {
        "id": "astra-3-doors",
        "name": "Astra 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1991–2009"
      },
      {
        "id": "astra-sedan",
        "name": "Astra Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1992–2015"
      },
      {
        "id": "astra-cabriolet",
        "name": "Astra Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1993–2006"
      },
      {
        "id": "corsa-3-doors",
        "name": "Corsa 3 Doors",
        "fuel": "Gasolina / Dièsel / Gas liquat / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1993–2019"
      },
      {
        "id": "tigra",
        "name": "Tigra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2009"
      },
      {
        "id": "astra-caravan",
        "name": "Astra Caravan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1994–2011"
      },
      {
        "id": "vectra-caravan",
        "name": "Vectra Caravan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1996–2008"
      },
      {
        "id": "vectra-opc",
        "name": "Vectra OPC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2008"
      },
      {
        "id": "sintra",
        "name": "Sintra",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1997–1999"
      },
      {
        "id": "speedster",
        "name": "Speedster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2005"
      },
      {
        "id": "combo",
        "name": "Combo",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2001–2023"
      },
      {
        "id": "astra-coupe",
        "name": "Astra Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2006"
      },
      {
        "id": "astra-opc",
        "name": "Astra OPC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2018"
      },
      {
        "id": "meriva",
        "name": "Meriva",
        "fuel": "Gasolina / Dièsel / Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2003–2017"
      },
      {
        "id": "signum",
        "name": "Signum",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2008"
      },
      {
        "id": "insignia-opc",
        "name": "Insignia OPC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      },
      {
        "id": "insignia-sports-tourer-opc",
        "name": "Insignia Sports Tourer OPC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2017"
      },
      {
        "id": "astra-twin-top-cabriolet",
        "name": "Astra Twin Top / Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2011"
      },
      {
        "id": "antara",
        "name": "Antara",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2017"
      },
      {
        "id": "corsa-opc",
        "name": "Corsa OPC",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2019"
      },
      {
        "id": "adam",
        "name": "Adam",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2019"
      },
      {
        "id": "adam-rocks",
        "name": "Adam Rocks",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2019"
      },
      {
        "id": "cascada",
        "name": "Cascada",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2019"
      },
      {
        "id": "insignia-gsi",
        "name": "Insignia GSi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "insignia-sports-tourer-gsi",
        "name": "Insignia Sports Tourer GSi",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "ampera",
        "name": "Ampera",
        "fuel": "Híbrid / Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2019"
      }
    ]
  },
  {
    "id": "peugeot",
    "name": "Peugeot",
    "logo": "🦁",
    "description": "Motion & Emotion",
    "models": [
      {
        "id": "2008",
        "name": "2008",
        "fuel": "Dièsel",
        "power": "131",
        "length": "4.300",
        "width": "1.770",
        "height": "1.550",
        "trunk": "434–1.467",
        "price": "26.890€"
      },
      {
        "id": "2008",
        "name": "2008",
        "fuel": "Gasolina",
        "power": "100 / 131",
        "length": "4.300",
        "width": "1.770",
        "height": "1.550",
        "trunk": "434–1.467",
        "price": "26.890€"
      },
      {
        "id": "208",
        "name": "208",
        "fuel": "Gasolina",
        "power": "75 / 100",
        "length": "4.055",
        "width": "1.745",
        "height": "1.465",
        "trunk": "209",
        "price": "20.100€"
      },
      {
        "id": "208",
        "name": "208",
        "fuel": "Híbrid",
        "power": "100 / 136",
        "length": "4.055",
        "width": "1.745",
        "height": "1.465",
        "trunk": "309",
        "price": "20.100€"
      },
      {
        "id": "3008",
        "name": "3008",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.540",
        "width": "1.890",
        "height": "1.640",
        "trunk": "588",
        "price": "38.660€"
      },
      {
        "id": "3008",
        "name": "3008",
        "fuel": "PHEV",
        "power": "195",
        "length": "4.540",
        "width": "1.890",
        "height": "1.640",
        "trunk": "520",
        "price": "38.660€"
      },
      {
        "id": "408",
        "name": "408",
        "fuel": "Elèctric",
        "power": "213",
        "length": "4.690",
        "width": "1.850",
        "height": "1.485",
        "trunk": "471–1.545",
        "price": "36.250€"
      },
      {
        "id": "408",
        "name": "408",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.690",
        "width": "1.850",
        "height": "1.485",
        "trunk": "536–1.611",
        "price": "36.250€"
      },
      {
        "id": "408",
        "name": "408",
        "fuel": "PHEV",
        "power": "225",
        "length": "4.690",
        "width": "1.850",
        "height": "1.485",
        "trunk": "471–1.545",
        "price": "36.250€"
      },
      {
        "id": "5008",
        "name": "5008",
        "fuel": "Dièsel",
        "power": "130 / 180",
        "length": "4.641",
        "width": "1.844",
        "height": "1.651",
        "trunk": "N.D.",
        "price": "30.300€"
      },
      {
        "id": "5008",
        "name": "5008",
        "fuel": "Gasolina",
        "power": "130 / 180",
        "length": "4.641",
        "width": "1.844",
        "height": "1.651",
        "trunk": "N.D.",
        "price": "30.300€"
      },
      {
        "id": "508-5-puertas",
        "name": "508 5 puertas",
        "fuel": "Dièsel",
        "power": "130",
        "length": "4.750",
        "width": "1.859",
        "height": "1.403",
        "trunk": "487–1.537",
        "price": "39.210€"
      },
      {
        "id": "508-5-puertas",
        "name": "508 5 puertas",
        "fuel": "Gasolina",
        "power": "130",
        "length": "4.750",
        "width": "1.859",
        "height": "1.403",
        "trunk": "487–1.537",
        "price": "39.210€"
      },
      {
        "id": "508-5-puertas",
        "name": "508 5 puertas",
        "fuel": "PHEV",
        "power": "180 / 225 / 360",
        "length": "4.750",
        "width": "1.861",
        "height": "1.403",
        "trunk": "487–1.537",
        "price": "39.210€"
      },
      {
        "id": "508-sw",
        "name": "508 SW",
        "fuel": "Dièsel",
        "power": "130",
        "length": "4.778",
        "width": "1.859",
        "height": "1.420",
        "trunk": "530–1.730",
        "price": "39.210€"
      },
      {
        "id": "508-sw",
        "name": "508 SW",
        "fuel": "Gasolina",
        "power": "130",
        "length": "4.778",
        "width": "1.859",
        "height": "1.420",
        "trunk": "530–1.780",
        "price": "39.210€"
      },
      {
        "id": "508-sw",
        "name": "508 SW",
        "fuel": "PHEV",
        "power": "180 / 225 / 360",
        "length": "4.778",
        "width": "1.859",
        "height": "1.420",
        "trunk": "530–1.780",
        "price": "39.210€"
      },
      {
        "id": "e-2008",
        "name": "E-2008",
        "fuel": "Elèctric",
        "power": "136 / 156",
        "length": "4.300",
        "width": "1.770",
        "height": "1.550",
        "trunk": "434–1.467",
        "price": "26.890€"
      },
      {
        "id": "e-208",
        "name": "E-208",
        "fuel": "Elèctric",
        "power": "136 / 156",
        "length": "4.055",
        "width": "1.745",
        "height": "1.430",
        "trunk": "342–1.118",
        "price": "20.100€"
      },
      {
        "id": "e-3008",
        "name": "E-3008",
        "fuel": "Elèctric",
        "power": "210 / 325",
        "length": "4.542",
        "width": "1.895",
        "height": "1.641",
        "trunk": "520–1.480",
        "price": "38.660€"
      },
      {
        "id": "e-5008",
        "name": "E-5008",
        "fuel": "Elèctric",
        "power": "210 / 325",
        "length": "4.791",
        "width": "1.895",
        "height": "1.694",
        "trunk": "748",
        "price": "30.300€"
      },
      {
        "id": "rifter",
        "name": "Rifter",
        "fuel": "Elèctric",
        "power": "136",
        "length": "4.403",
        "width": "1.848",
        "height": "1.880",
        "trunk": "N.D.",
        "price": "37.000€"
      },
      {
        "id": "traveller",
        "name": "Traveller",
        "fuel": "Dièsel",
        "power": "115 / 150 / 177",
        "length": "4.606",
        "width": "1.920",
        "height": "1.940",
        "trunk": "224–3.397",
        "price": "27.021€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "504",
        "name": "504",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1968–1982"
      },
      {
        "id": "104",
        "name": "104",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1972–1988"
      },
      {
        "id": "604",
        "name": "604",
        "fuel": "Dièsel / Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1986"
      },
      {
        "id": "505",
        "name": "505",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1979–1992"
      },
      {
        "id": "205",
        "name": "205",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1983–1998"
      },
      {
        "id": "405",
        "name": "405",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1987–1996"
      },
      {
        "id": "605",
        "name": "605",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1989–1999"
      },
      {
        "id": "106",
        "name": "106",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1991–2003"
      },
      {
        "id": "306",
        "name": "306",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "9",
        "years": "1993–2003"
      },
      {
        "id": "806",
        "name": "806",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1994–2002"
      },
      {
        "id": "406",
        "name": "406",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2004"
      },
      {
        "id": "406-break",
        "name": "406 Break",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2004"
      },
      {
        "id": "406-coupe",
        "name": "406 Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2004"
      },
      {
        "id": "206-3-doors",
        "name": "206 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1998–2010"
      },
      {
        "id": "206-5-doors",
        "name": "206 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1998–2010"
      },
      {
        "id": "206-cc",
        "name": "206 CC",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2007"
      },
      {
        "id": "206-sw",
        "name": "206 SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2007"
      },
      {
        "id": "partner-combi",
        "name": "Partner Combi",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2008"
      },
      {
        "id": "307-3-doors",
        "name": "307 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2008"
      },
      {
        "id": "307-5-doors",
        "name": "307 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2008"
      },
      {
        "id": "307-sw",
        "name": "307 SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2002–2008"
      },
      {
        "id": "307-cc",
        "name": "307 CC",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2008"
      },
      {
        "id": "807",
        "name": "807",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2008"
      },
      {
        "id": "407",
        "name": "407",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2010"
      },
      {
        "id": "407-sw",
        "name": "407 SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2010"
      },
      {
        "id": "407-coupe",
        "name": "407 Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2008"
      },
      {
        "id": "1007",
        "name": "1007",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2009"
      },
      {
        "id": "tepee",
        "name": "Tepee",
        "fuel": "Dièsel / Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2007–2017"
      },
      {
        "id": "107-3-doors",
        "name": "107 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2014"
      },
      {
        "id": "107-5-doors",
        "name": "107 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2014"
      },
      {
        "id": "207-3-doors",
        "name": "207 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2006–2012"
      },
      {
        "id": "207-5-doors",
        "name": "207 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2012"
      },
      {
        "id": "207-sw",
        "name": "207 SW",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2012"
      },
      {
        "id": "207-cc",
        "name": "207 CC",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2014"
      },
      {
        "id": "308-3-doors",
        "name": "308 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2013"
      },
      {
        "id": "308-cc",
        "name": "308 CC",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2015"
      },
      {
        "id": "rcz",
        "name": "RCZ",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2015"
      },
      {
        "id": "rcz-r",
        "name": "RCZ R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2015"
      },
      {
        "id": "206-sedan",
        "name": "206 Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2012"
      },
      {
        "id": "206-3-doors",
        "name": "206+ 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      },
      {
        "id": "206-5-doors",
        "name": "206+ 5 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2012"
      },
      {
        "id": "4007",
        "name": "4007",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2012"
      },
      {
        "id": "4008",
        "name": "4008",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "ion",
        "name": "iOn",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2012"
      },
      {
        "id": "hoggar",
        "name": "Hoggar",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2014"
      },
      {
        "id": "408-sedan",
        "name": "408 Sedan",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2014"
      },
      {
        "id": "508-rxh",
        "name": "508 RXH",
        "fuel": "Híbrid / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2018"
      },
      {
        "id": "108",
        "name": "108",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2022"
      },
      {
        "id": "208-3-doors",
        "name": "208 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2018"
      },
      {
        "id": "208-gti",
        "name": "208 GTI",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2018"
      },
      {
        "id": "208-xy",
        "name": "208 XY",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2015"
      },
      {
        "id": "pick-up",
        "name": "Pick Up",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      }
    ]
  },
  {
    "id": "polestar",
    "name": "Polestar",
    "logo": "⭐",
    "description": "Pure Electric Performance",
    "models": [
      {
        "id": "2",
        "name": "2",
        "fuel": "Elèctric",
        "power": "272 / 299 / 421 / 476",
        "length": "4.606",
        "width": "1.859",
        "height": "1.479",
        "trunk": "405–1.095",
        "price": "52.900€"
      },
      {
        "id": "3",
        "name": "3",
        "fuel": "Elèctric",
        "power": "490",
        "length": "4.900",
        "width": "2.120",
        "height": "1.614",
        "trunk": "484–1.411",
        "price": "92.900€"
      },
      {
        "id": "5",
        "name": "5",
        "fuel": "Elèctric",
        "power": "748 / 884",
        "length": "5.087",
        "width": "2.015",
        "height": "1.419",
        "trunk": "365–1.128",
        "price": "121.900€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "1",
        "name": "1",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2022"
      }
    ]
  },
  {
    "id": "porsche",
    "name": "Porsche",
    "logo": "🏁",
    "description": "There is no substitute",
    "models": [
      {
        "id": "718-boxster",
        "name": "718 Boxster",
        "fuel": "Gasolina",
        "power": "300 / 350 / 365",
        "length": "4.379",
        "width": "1.801",
        "height": "1.281",
        "trunk": "130–150",
        "price": "61.547€"
      },
      {
        "id": "718-cayman-gt4-rs",
        "name": "718 Cayman GT4 RS",
        "fuel": "Gasolina",
        "power": "500",
        "length": "4.456",
        "width": "1.822",
        "height": "1.267",
        "trunk": "125–260",
        "price": "94.580€"
      },
      {
        "id": "718-spyder",
        "name": "718 Spyder",
        "fuel": "Gasolina",
        "power": "500",
        "length": "4.418",
        "width": "1.822",
        "height": "1.252",
        "trunk": "150",
        "price": "180.709€"
      },
      {
        "id": "911",
        "name": "911",
        "fuel": "Gasolina",
        "power": "385 / 450 / 480 / 525 / 580 / 650",
        "length": "4.533",
        "width": "1.852",
        "height": "1.303",
        "trunk": "132–264",
        "price": "141.868€"
      },
      {
        "id": "911-dakar",
        "name": "911 Dakar",
        "fuel": "Gasolina",
        "power": "480",
        "length": "4.530",
        "width": "1.864",
        "height": "1.338",
        "trunk": "132",
        "price": "141.868€"
      },
      {
        "id": "911-gt3",
        "name": "911 GT3",
        "fuel": "Gasolina",
        "power": "510 / 525",
        "length": "4.573",
        "width": "1.852",
        "height": "1.279",
        "trunk": "132",
        "price": "141.868€"
      },
      {
        "id": "911-targa",
        "name": "911 Targa",
        "fuel": "Gasolina",
        "power": "385 / 450 / 480",
        "length": "4.533",
        "width": "1.852",
        "height": "1.301",
        "trunk": "132–163",
        "price": "141.868€"
      },
      {
        "id": "911-targa",
        "name": "911 Targa",
        "fuel": "Híbrid",
        "power": "541",
        "length": "4.553",
        "width": "1.852",
        "height": "N.D.",
        "trunk": "163",
        "price": "141.868€"
      },
      {
        "id": "935",
        "name": "935",
        "fuel": "Combustió",
        "power": "700",
        "length": "4.865",
        "width": "2.034",
        "height": "1.359",
        "trunk": "N.D.",
        "price": "835.318€"
      },
      {
        "id": "cayenne",
        "name": "Cayenne",
        "fuel": "Gasolina",
        "power": "353 / 474",
        "length": "4.930",
        "width": "1.983",
        "height": "1.697",
        "trunk": "772–1.708",
        "price": "108.619€"
      },
      {
        "id": "cayenne",
        "name": "Cayenne",
        "fuel": "PHEV",
        "power": "470 / 519 / 739",
        "length": "4.930",
        "width": "1.983",
        "height": "1.685",
        "trunk": "621–1.567",
        "price": "108.619€"
      },
      {
        "id": "gts",
        "name": "GTS",
        "fuel": "Gasolina",
        "power": "400",
        "length": "4.405",
        "width": "1.801",
        "height": "1.276",
        "trunk": "162",
        "price": "94.580€"
      },
      {
        "id": "macan",
        "name": "Macan",
        "fuel": "Elèctric",
        "power": "360 / 408 / 516 / 639",
        "length": "4.784",
        "width": "1.938",
        "height": "1.622",
        "trunk": "540–1.348",
        "price": "82.310€"
      },
      {
        "id": "panamera",
        "name": "Panamera",
        "fuel": "Gasolina",
        "power": "353 / 500",
        "length": "5.052",
        "width": "1.937",
        "height": "1.415",
        "trunk": "478–1.312",
        "price": "125.102€"
      },
      {
        "id": "panamera",
        "name": "Panamera",
        "fuel": "PHEV",
        "power": "470 / 544 / 680",
        "length": "5.052",
        "width": "1.937",
        "height": "1.423",
        "trunk": "430–1.264",
        "price": "125.102€"
      },
      {
        "id": "panamera-executive",
        "name": "Panamera Executive",
        "fuel": "PHEV",
        "power": "470",
        "length": "5.202",
        "width": "1.937",
        "height": "1.425",
        "trunk": "430–1.385",
        "price": "125.102€"
      },
      {
        "id": "taycan",
        "name": "Taycan",
        "fuel": "Elèctric",
        "power": "408 / 544 / 700 / 884 / 952 / 1034",
        "length": "4.962",
        "width": "1.966",
        "height": "1.378",
        "trunk": "366",
        "price": "95.995€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "911-carrera",
        "name": "911 Carrera",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "12",
        "years": "1964–2019"
      },
      {
        "id": "911-carrera-rs",
        "name": "911 Carrera RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1972–1996"
      },
      {
        "id": "928",
        "name": "928",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1978–1982"
      },
      {
        "id": "928-s",
        "name": "928 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1980–1991"
      },
      {
        "id": "944",
        "name": "944",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1990"
      },
      {
        "id": "944-turbo",
        "name": "944 Turbo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1990"
      },
      {
        "id": "944-s",
        "name": "944 S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1986–1991"
      },
      {
        "id": "959",
        "name": "959",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1987–1988"
      },
      {
        "id": "928-gt",
        "name": "928 GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1991"
      },
      {
        "id": "968",
        "name": "968",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1991–1995"
      },
      {
        "id": "968-cabriolet",
        "name": "968 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1995"
      },
      {
        "id": "928-gts",
        "name": "928 GTS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1995"
      },
      {
        "id": "968-turbo-s",
        "name": "968 Turbo S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1993–1994"
      },
      {
        "id": "911-carrera-4",
        "name": "911 Carrera 4",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1988–2015"
      },
      {
        "id": "911-gt2",
        "name": "911 GT2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1995–2009"
      },
      {
        "id": "911-carrera-s",
        "name": "911 Carrera S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1995–2024"
      },
      {
        "id": "boxster",
        "name": "Boxster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1996–2016"
      },
      {
        "id": "boxster-s",
        "name": "Boxster S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1999–2016"
      },
      {
        "id": "carrera-gt",
        "name": "Carrera GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2006"
      },
      {
        "id": "911-gt3-rs",
        "name": "911 GT3 RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "2004–2019"
      },
      {
        "id": "cayenne-turbo",
        "name": "Cayenne Turbo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2002–2023"
      },
      {
        "id": "cayman-s",
        "name": "Cayman S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2005–2016"
      },
      {
        "id": "cayman",
        "name": "Cayman",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2006–2016"
      },
      {
        "id": "cayenne-turbo-s",
        "name": "Cayenne Turbo S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2006–2017"
      },
      {
        "id": "boxster-spyder",
        "name": "Boxster Spyder",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2019"
      },
      {
        "id": "panamera-s",
        "name": "Panamera S",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2016"
      },
      {
        "id": "cayenne-diesel",
        "name": "Cayenne Diesel",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2008–2017"
      },
      {
        "id": "cayenne-s-hybrid",
        "name": "Cayenne S Hybrid",
        "fuel": "Híbrid gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2014"
      },
      {
        "id": "911-sport-classic",
        "name": "911 Sport Classic",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2012"
      },
      {
        "id": "panamera-diesel",
        "name": "Panamera Diesel",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2016"
      },
      {
        "id": "cayenne-s-transsyberia",
        "name": "Cayenne S TransSyberia",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2011"
      },
      {
        "id": "cayman-r",
        "name": "Cayman R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2011"
      },
      {
        "id": "panamera-s-hybrid",
        "name": "Panamera S Hybrid",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2013"
      },
      {
        "id": "panamera-s-e-hybrid",
        "name": "Panamera S E-Hybrid",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      },
      {
        "id": "918",
        "name": "918",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2015"
      },
      {
        "id": "macan-s-diesel",
        "name": "Macan S Diesel",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "macan-turbo",
        "name": "Macan Turbo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2021"
      },
      {
        "id": "911-carrera-4-cabriolet",
        "name": "911 Carrera 4 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1998–2016"
      },
      {
        "id": "911-carrera-s-cabriolet",
        "name": "911 Carrera S Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2005–2018"
      },
      {
        "id": "911-carrera-gts-cabriolet",
        "name": "911 Carrera GTS Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2010–2016"
      },
      {
        "id": "cayenne-s-diesel",
        "name": "Cayenne S Diesel",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2017"
      },
      {
        "id": "panamera-4s-diesel-sport-turismo",
        "name": "Panamera 4S Diesel Sport Turismo",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "panamera-4s-sport-turismo",
        "name": "Panamera 4S Sport Turismo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "panamera-4-e-hybrid-sport-turismo",
        "name": "Panamera 4 E-Hybrid Sport Turismo",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "panamera-turbo-sport-turismo",
        "name": "Panamera Turbo Sport Turismo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2020"
      },
      {
        "id": "panamera-turbo-s-e-hybrid-sport-turismo",
        "name": "Panamera Turbo S E-Hybrid Sport Turismo",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2023"
      },
      {
        "id": "cayenne-s-e-hybrid",
        "name": "Cayenne S E-Hybrid",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2019"
      },
      {
        "id": "911-gt2-rs",
        "name": "911 GT2 RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2010–2019"
      },
      {
        "id": "911-r",
        "name": "911 R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2019"
      },
      {
        "id": "911-carrera-4-gts-cabriolet",
        "name": "911 Carrera 4 GTS Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2018"
      },
      {
        "id": "cayenne-turbo-coupe",
        "name": "Cayenne Turbo Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2023"
      },
      {
        "id": "cayenne-turbo-s-e-hybrid",
        "name": "Cayenne Turbo S E-Hybrid",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2023"
      },
      {
        "id": "speedster",
        "name": "Speedster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2019–2019"
      }
    ]
  },
  {
    "id": "ram",
    "name": "RAM",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "1500",
        "name": "1500",
        "fuel": "Dièsel",
        "power": "260",
        "length": "5.916",
        "width": "2.084",
        "height": "1.968",
        "trunk": "N.D.",
        "price": "60.300€"
      },
      {
        "id": "1500",
        "name": "1500",
        "fuel": "Gasolina",
        "power": "395 / 702",
        "length": "5.916",
        "width": "2.235",
        "height": "2.055",
        "trunk": "N.D.",
        "price": "60.300€"
      }
    ]
  },
  {
    "id": "renault",
    "name": "Renault",
    "logo": "💎",
    "description": "Passion for Life",
    "models": [
      {
        "id": "4",
        "name": "4",
        "fuel": "Elèctric",
        "power": "120 / 150",
        "length": "4.144",
        "width": "1.808",
        "height": "1.552",
        "trunk": "339–1.405",
        "price": "29.950€"
      },
      {
        "id": "5",
        "name": "5",
        "fuel": "Elèctric",
        "power": "150",
        "length": "3.920",
        "width": "1.770",
        "height": "1.500",
        "trunk": "326",
        "price": "31.584€"
      },
      {
        "id": "arkana",
        "name": "Arkana",
        "fuel": "Híbrid",
        "power": "140 / 143",
        "length": "4.568",
        "width": "1.820",
        "height": "1.571",
        "trunk": "480–1.263",
        "price": "20.250€"
      },
      {
        "id": "austral",
        "name": "Austral",
        "fuel": "Híbrid",
        "power": "140 / 160 / 200",
        "length": "4.510",
        "width": "1.843",
        "height": "1.618",
        "trunk": "500–1.525",
        "price": "30.555€"
      },
      {
        "id": "captur",
        "name": "Captur",
        "fuel": "Gasolina",
        "power": "90",
        "length": "4.239",
        "width": "1.797",
        "height": "1.575",
        "trunk": "484–1.596",
        "price": "21.690€"
      },
      {
        "id": "captur",
        "name": "Captur",
        "fuel": "GLP",
        "power": "90",
        "length": "4.239",
        "width": "1.797",
        "height": "1.575",
        "trunk": "484–1.596",
        "price": "21.690€"
      },
      {
        "id": "captur",
        "name": "Captur",
        "fuel": "Híbrid",
        "power": "140",
        "length": "4.239",
        "width": "1.797",
        "height": "1.575",
        "trunk": "484–1.596",
        "price": "21.690€"
      },
      {
        "id": "captur",
        "name": "Captur",
        "fuel": "PHEV",
        "power": "145",
        "length": "4.239",
        "width": "1.797",
        "height": "1.575",
        "trunk": "348–1.458",
        "price": "21.690€"
      },
      {
        "id": "clio",
        "name": "Clio",
        "fuel": "Híbrid",
        "power": "160",
        "length": "4.116",
        "width": "1.768",
        "height": "1.451",
        "trunk": "391",
        "price": "16.141€"
      },
      {
        "id": "espace",
        "name": "Espace",
        "fuel": "Híbrid",
        "power": "200",
        "length": "4.746",
        "width": "1.843",
        "height": "1.645",
        "trunk": "520–2.153",
        "price": "40.189€"
      },
      {
        "id": "kadjar",
        "name": "Kadjar",
        "fuel": "Dièsel",
        "power": "115",
        "length": "4.489",
        "width": "1.836",
        "height": "1.607",
        "trunk": "472–1.478",
        "price": "24.557€"
      },
      {
        "id": "kadjar",
        "name": "Kadjar",
        "fuel": "Gasolina",
        "power": "140 / 160",
        "length": "4.489",
        "width": "1.836",
        "height": "1.613",
        "trunk": "465–574",
        "price": "24.557€"
      },
      {
        "id": "kangoo",
        "name": "Kangoo",
        "fuel": "Dièsel",
        "power": "95",
        "length": "4.486",
        "width": "2.159",
        "height": "1.808",
        "trunk": "775–3.500",
        "price": "21.699€"
      },
      {
        "id": "kangoo-e-tech",
        "name": "Kangoo E-TECH",
        "fuel": "Elèctric",
        "power": "122",
        "length": "4.486",
        "width": "1.860",
        "height": "1.793",
        "trunk": "950–2.500",
        "price": "21.699€"
      },
      {
        "id": "koleos",
        "name": "Koleos",
        "fuel": "Dièsel",
        "power": "150 / 190",
        "length": "4.673",
        "width": "1.843",
        "height": "1.667",
        "trunk": "565",
        "price": "31.160€"
      },
      {
        "id": "megane",
        "name": "Mégane",
        "fuel": "Dièsel",
        "power": "115",
        "length": "4.359",
        "width": "1.814",
        "height": "1.447",
        "trunk": "384–1.247",
        "price": "23.643€"
      },
      {
        "id": "megane",
        "name": "Mégane",
        "fuel": "Gasolina",
        "power": "140",
        "length": "4.359",
        "width": "1.814",
        "height": "1.447",
        "trunk": "384–1.247",
        "price": "23.643€"
      },
      {
        "id": "rafale",
        "name": "Rafale",
        "fuel": "Híbrid",
        "power": "200",
        "length": "4.710",
        "width": "1.866",
        "height": "1.613",
        "trunk": "528–1.600",
        "price": "43.100€"
      },
      {
        "id": "rafale",
        "name": "Rafale",
        "fuel": "PHEV",
        "power": "300",
        "length": "4.710",
        "width": "1.866",
        "height": "1.613",
        "trunk": "528–1.600",
        "price": "43.100€"
      },
      {
        "id": "scenic",
        "name": "Scenic",
        "fuel": "Elèctric",
        "power": "170 / 220",
        "length": "4.470",
        "width": "1.864",
        "height": "1.571",
        "trunk": "545–1.449",
        "price": "22.650€"
      },
      {
        "id": "symbioz",
        "name": "Symbioz",
        "fuel": "Híbrid",
        "power": "160",
        "length": "4.413",
        "width": "1.797",
        "height": "1.575",
        "trunk": "434–1.582",
        "price": "27.523€"
      },
      {
        "id": "trafic",
        "name": "Trafic",
        "fuel": "Dièsel",
        "power": "90 / 120 / 140",
        "length": "4.999",
        "width": "2.283",
        "height": "1.971",
        "trunk": "N.D.",
        "price": "26.442€"
      },
      {
        "id": "twingo",
        "name": "Twingo",
        "fuel": "Elèctric",
        "power": "80",
        "length": "3.789",
        "width": "1.720",
        "height": "1.491",
        "trunk": "305",
        "price": "19.500€"
      },
      {
        "id": "twizy",
        "name": "Twizy",
        "fuel": "Elèctric",
        "power": "5 / 17",
        "length": "2.338",
        "width": "1.381",
        "height": "1.454",
        "trunk": "55",
        "price": "7.930€"
      },
      {
        "id": "zoe",
        "name": "Zoe",
        "fuel": "Elèctric",
        "power": "108 / 135",
        "length": "4.084",
        "width": "1.945",
        "height": "1.562",
        "trunk": "338–1.225",
        "price": "26.200€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "4-cv",
        "name": "4 CV",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1947–1961"
      },
      {
        "id": "16",
        "name": "16",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1980"
      },
      {
        "id": "12",
        "name": "12",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1969–1980"
      },
      {
        "id": "8",
        "name": "8",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1962–1971"
      },
      {
        "id": "14",
        "name": "14",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–1983"
      },
      {
        "id": "20",
        "name": "20",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1984"
      },
      {
        "id": "30",
        "name": "30",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1979–1984"
      },
      {
        "id": "18",
        "name": "18",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1978–1984"
      },
      {
        "id": "11",
        "name": "11",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1983–1986"
      },
      {
        "id": "25",
        "name": "25",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1984–1992"
      },
      {
        "id": "9",
        "name": "9",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1981–1988"
      },
      {
        "id": "21",
        "name": "21",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1986–1994"
      },
      {
        "id": "19",
        "name": "19",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1988–1996"
      },
      {
        "id": "alpine",
        "name": "Alpine",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1977–1994"
      },
      {
        "id": "safrane",
        "name": "Safrane",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–2000"
      },
      {
        "id": "laguna",
        "name": "Laguna",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1994–2016"
      },
      {
        "id": "laguna-estate",
        "name": "Laguna Estate",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1995–2016"
      },
      {
        "id": "laguna-coupe",
        "name": "Laguna Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2015"
      },
      {
        "id": "avantime",
        "name": "Avantime",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2003"
      },
      {
        "id": "vel-satis",
        "name": "Vel Satis",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2009"
      },
      {
        "id": "clio-3-doors",
        "name": "Clio 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "10",
        "years": "1990–2013"
      },
      {
        "id": "clio-estate",
        "name": "Clio Estate",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2009–2019"
      },
      {
        "id": "clio-rs",
        "name": "Clio RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      },
      {
        "id": "clio-symbol-thalia",
        "name": "Clio Symbol / Thalia",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2000–2013"
      },
      {
        "id": "megane-coupe",
        "name": "Megane Coupe",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "12",
        "years": "1996–2017"
      },
      {
        "id": "megane-cabriolet",
        "name": "Megane Cabriolet",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1997–2016"
      },
      {
        "id": "megane-estate",
        "name": "Megane Estate",
        "fuel": "Gasolina / Dièsel / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "8",
        "years": "1999–2024"
      },
      {
        "id": "modus",
        "name": "Modus",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2012"
      },
      {
        "id": "grand-modus",
        "name": "Grand Modus",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2012"
      },
      {
        "id": "scenic-xmod",
        "name": "Scenic XMOD",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      },
      {
        "id": "grand-scenic",
        "name": "Grand Scenic",
        "fuel": "Gasolina / Dièsel / Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2003–2022"
      },
      {
        "id": "fluence",
        "name": "Fluence",
        "fuel": "Gasolina / Dièsel / Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2009–2016"
      },
      {
        "id": "latitude",
        "name": "Latitude",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2015"
      },
      {
        "id": "talisman",
        "name": "Talisman",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2022"
      },
      {
        "id": "talisman-estate",
        "name": "Talisman Estate",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2022"
      },
      {
        "id": "kwid",
        "name": "Kwid",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2019"
      },
      {
        "id": "duster-oroch",
        "name": "Duster OROCH",
        "fuel": "Gasolina / Etanol",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2022"
      },
      {
        "id": "logan",
        "name": "Logan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2022"
      },
      {
        "id": "scala",
        "name": "Scala",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "pulse",
        "name": "Pulse",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2017"
      },
      {
        "id": "sandero-gt",
        "name": "Sandero GT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2015"
      },
      {
        "id": "spider",
        "name": "Spider",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–1998"
      },
      {
        "id": "wind",
        "name": "Wind",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2013"
      },
      {
        "id": "twingo-rs",
        "name": "Twingo RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2013"
      }
    ]
  },
  {
    "id": "rolls-royce",
    "name": "Rolls-Royce",
    "logo": "👑",
    "description": "Strive for Perfection",
    "models": [
      {
        "id": "cullinan",
        "name": "Cullinan",
        "fuel": "Gasolina",
        "power": "571",
        "length": "5.341",
        "width": "2.164",
        "height": "1.835",
        "trunk": "560–1.930",
        "price": "290.000€"
      },
      {
        "id": "ghost",
        "name": "Ghost",
        "fuel": "Gasolina",
        "power": "563",
        "length": "5.399",
        "width": "1.948",
        "height": "1.550",
        "trunk": "490",
        "price": "304.352€"
      },
      {
        "id": "ghost-extended-wheelbase",
        "name": "Ghost Extended Wheelbase",
        "fuel": "Gasolina",
        "power": "563",
        "length": "5.569",
        "width": "1.948",
        "height": "1.550",
        "trunk": "490",
        "price": "304.352€"
      },
      {
        "id": "phantom",
        "name": "Phantom",
        "fuel": "Gasolina",
        "power": "570",
        "length": "5.982",
        "width": "2.018",
        "height": "1.656",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "wraith",
        "name": "Wraith",
        "fuel": "Gasolina",
        "power": "563",
        "length": "5.269",
        "width": "1.947",
        "height": "1.507",
        "trunk": "490",
        "price": "340.176€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "silver-dawn",
        "name": "Silver Dawn",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1949–1999"
      },
      {
        "id": "silver-shadow",
        "name": "Silver Shadow",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1965–1980"
      },
      {
        "id": "corniche",
        "name": "Corniche",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1971–2003"
      },
      {
        "id": "camargue",
        "name": "Camargue",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1986"
      },
      {
        "id": "silver-shadow-coupe",
        "name": "Silver Shadow Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1977–1982"
      },
      {
        "id": "silver-spirit",
        "name": "Silver Spirit",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1980–1998"
      },
      {
        "id": "flying-spur",
        "name": "Flying Spur",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1995"
      },
      {
        "id": "silver-spur",
        "name": "Silver Spur",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–1998"
      },
      {
        "id": "park-ward",
        "name": "Park Ward",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1995–2002"
      },
      {
        "id": "silver-seraph",
        "name": "Silver Seraph",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1998–2002"
      },
      {
        "id": "dawn",
        "name": "Dawn",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2023"
      }
    ]
  },
  {
    "id": "santana-motors",
    "name": "Santana Motors",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "400-d",
        "name": "400 D",
        "fuel": "Dièsel",
        "power": "190",
        "length": "5.520",
        "width": "1.960",
        "height": "1.950",
        "trunk": "N.D.",
        "price": "29.900€"
      },
      {
        "id": "400-phev",
        "name": "400 PHEV",
        "fuel": "PHEV",
        "power": "429",
        "length": "5.494",
        "width": "1.960",
        "height": "1.950",
        "trunk": "N.D.",
        "price": "29.900€"
      }
    ]
  },
  {
    "id": "seat",
    "name": "Seat",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "arona",
        "name": "Arona",
        "fuel": "Gasolina",
        "power": "95 / 110 / 150",
        "length": "4.154",
        "width": "1.780",
        "height": "1.537",
        "trunk": "400–1.280",
        "price": "22.290€"
      },
      {
        "id": "ateca",
        "name": "Ateca",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.381",
        "width": "1.841",
        "height": "1.615",
        "trunk": "510–1.604",
        "price": "28.570€"
      },
      {
        "id": "ateca",
        "name": "Ateca",
        "fuel": "Gasolina",
        "power": "110 / 150",
        "length": "4.381",
        "width": "1.841",
        "height": "1.615",
        "trunk": "510–1.604",
        "price": "28.570€"
      },
      {
        "id": "ibiza",
        "name": "Ibiza",
        "fuel": "Gasolina",
        "power": "80 / 110 / 150",
        "length": "4.059",
        "width": "1.780",
        "height": "1.447",
        "trunk": "355–1.165",
        "price": "17.650€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.368",
        "width": "1.799",
        "height": "1.456",
        "trunk": "380",
        "price": "26.090€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "Gasolina",
        "power": "110 / 130",
        "length": "4.368",
        "width": "1.799",
        "height": "1.456",
        "trunk": "380",
        "price": "26.090€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "GLP",
        "power": "130",
        "length": "4.368",
        "width": "1.799",
        "height": "1.442",
        "trunk": "300",
        "price": "26.090€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "Híbrid",
        "power": "110",
        "length": "4.368",
        "width": "1.799",
        "height": "1.456",
        "trunk": "380",
        "price": "26.090€"
      },
      {
        "id": "leon",
        "name": "León",
        "fuel": "PHEV",
        "power": "204",
        "length": "4.368",
        "width": "1.799",
        "height": "1.460",
        "trunk": "270–1.191",
        "price": "26.090€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.642",
        "width": "1.799",
        "height": "1.450",
        "trunk": "620",
        "price": "26.090€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "Gasolina",
        "power": "110 / 130",
        "length": "4.642",
        "width": "1.799",
        "height": "1.450",
        "trunk": "620",
        "price": "26.090€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "GLP",
        "power": "130",
        "length": "4.642",
        "width": "1.799",
        "height": "1.448",
        "trunk": "480",
        "price": "26.090€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "Híbrid",
        "power": "110",
        "length": "4.642",
        "width": "1.799",
        "height": "1.456",
        "trunk": "620",
        "price": "26.090€"
      },
      {
        "id": "leon-sportstourer",
        "name": "León Sportstourer",
        "fuel": "PHEV",
        "power": "204",
        "length": "4.642",
        "width": "1.799",
        "height": "1.456",
        "trunk": "470",
        "price": "26.090€"
      },
      {
        "id": "mii-electric",
        "name": "Mii Electric",
        "fuel": "Elèctric",
        "power": "83",
        "length": "3.556",
        "width": "1.645",
        "height": "1.481",
        "trunk": "251–923",
        "price": "21.230€"
      },
      {
        "id": "tarraco",
        "name": "Tarraco",
        "fuel": "Dièsel",
        "power": "150 / 200",
        "length": "4.735",
        "width": "1.839",
        "height": "1.658",
        "trunk": "N.D.",
        "price": "33.530€"
      },
      {
        "id": "tarraco",
        "name": "Tarraco",
        "fuel": "Gasolina",
        "power": "150 / 190",
        "length": "4.735",
        "width": "1.839",
        "height": "1.658",
        "trunk": "N.D.",
        "price": "33.530€"
      },
      {
        "id": "tarraco-fr",
        "name": "Tarraco FR",
        "fuel": "Dièsel",
        "power": "150 / 200",
        "length": "4.735",
        "width": "1.839",
        "height": "1.658",
        "trunk": "N.D.",
        "price": "33.530€"
      },
      {
        "id": "tarraco-fr",
        "name": "Tarraco FR",
        "fuel": "Gasolina",
        "power": "150 / 190",
        "length": "4.735",
        "width": "1.839",
        "height": "1.658",
        "trunk": "N.D.",
        "price": "33.530€"
      },
      {
        "id": "toledo",
        "name": "Toledo",
        "fuel": "Dièsel",
        "power": "115",
        "length": "4.482",
        "width": "1.706",
        "height": "1.461",
        "trunk": "550–1.490",
        "price": "17.510€"
      },
      {
        "id": "toledo",
        "name": "Toledo",
        "fuel": "Gasolina",
        "power": "95 / 110 / 125",
        "length": "4.482",
        "width": "1.706",
        "height": "1.461",
        "trunk": "550–1.490",
        "price": "17.510€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "alhambra",
        "name": "Alhambra",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1996–2020"
      },
      {
        "id": "altea",
        "name": "Altea",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "2004–2015"
      },
      {
        "id": "arosa",
        "name": "Arosa",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2004"
      },
      {
        "id": "cordoba",
        "name": "Cordoba",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1996–2009"
      },
      {
        "id": "cordoba-cupra",
        "name": "Cordoba Cupra",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2003"
      },
      {
        "id": "cordoba-sx",
        "name": "Cordoba SX",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2003"
      },
      {
        "id": "cordoba-vario",
        "name": "Cordoba Vario",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2003"
      },
      {
        "id": "exeo",
        "name": "Exeo",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2013"
      },
      {
        "id": "exeo-st",
        "name": "Exeo ST",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2013"
      },
      {
        "id": "ibiza-3-doors",
        "name": "Ibiza 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1993–2017"
      },
      {
        "id": "ibiza-bocanegra",
        "name": "Ibiza Bocanegra",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2017"
      },
      {
        "id": "ibiza-cupra",
        "name": "Ibiza Cupra",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1996–2017"
      },
      {
        "id": "ibiza-fr",
        "name": "Ibiza FR",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2017"
      },
      {
        "id": "ibiza-st",
        "name": "Ibiza ST",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2017"
      },
      {
        "id": "leon-cupra",
        "name": "Leon Cupra",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2001–2018"
      },
      {
        "id": "leon-cupra-r",
        "name": "Leon Cupra R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2002–2018"
      },
      {
        "id": "leon-fr-topsport",
        "name": "Leon FR / Topsport",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2012"
      },
      {
        "id": "leon-sc",
        "name": "Leon SC",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2020"
      },
      {
        "id": "leon-st-cupra",
        "name": "Leon ST Cupra",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2020"
      },
      {
        "id": "leon-x-perience",
        "name": "Leon X-Perience",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2017"
      },
      {
        "id": "malaga",
        "name": "Malaga",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1992"
      },
      {
        "id": "marbella",
        "name": "Marbella",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1998"
      },
      {
        "id": "mii",
        "name": "Mii",
        "fuel": "Gasolina · GNC",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2011–2021"
      }
    ]
  },
  {
    "id": "seres",
    "name": "Seres",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "5",
        "name": "5",
        "fuel": "Elèctric",
        "power": "584",
        "length": "4.710",
        "width": "1.930",
        "height": "1.620",
        "trunk": "67–723",
        "price": "60.995€"
      },
      {
        "id": "seres-3",
        "name": "Seres 3",
        "fuel": "Elèctric",
        "power": "163",
        "length": "4.380",
        "width": "1.850",
        "height": "1.650",
        "trunk": "310–1.247",
        "price": "25.995€"
      }
    ]
  },
  {
    "id": "smart",
    "name": "Smart",
    "logo": "💡",
    "description": "Open your mind",
    "models": [
      {
        "id": "1",
        "name": "#1",
        "fuel": "Elèctric",
        "power": "272 / 430",
        "length": "4.270",
        "width": "1.822",
        "height": "1.636",
        "trunk": "323",
        "price": "42.100€"
      },
      {
        "id": "3",
        "name": "#3",
        "fuel": "Elèctric",
        "power": "272 / 428",
        "length": "4.400",
        "width": "1.844",
        "height": "1.556",
        "trunk": "370–1.160",
        "price": "N.D.€"
      },
      {
        "id": "forfour",
        "name": "ForFour",
        "fuel": "Elèctric",
        "power": "82",
        "length": "3.495",
        "width": "1.665",
        "height": "1.554",
        "trunk": "185–975",
        "price": "24.535€"
      },
      {
        "id": "fortwo",
        "name": "Fortwo",
        "fuel": "Elèctric",
        "power": "82",
        "length": "2.695",
        "width": "1.663",
        "height": "1.555",
        "trunk": "260–350",
        "price": "23.820€"
      },
      {
        "id": "fortwo-cabrio",
        "name": "Fortwo Cabrio",
        "fuel": "Elèctric",
        "power": "82",
        "length": "2.695",
        "width": "1.663",
        "height": "1.553",
        "trunk": "260–340",
        "price": "23.820€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "crossblade",
        "name": "Crossblade",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2003"
      },
      {
        "id": "electric-drive",
        "name": "Electric Drive",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2012–2021"
      },
      {
        "id": "forfour-brabus",
        "name": "Forfour Brabus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2006"
      },
      {
        "id": "fortwo-brabus",
        "name": "Fortwo Brabus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2003–2019"
      },
      {
        "id": "fortwo-cabrio-brabus",
        "name": "Fortwo Cabrio Brabus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2003–2014"
      },
      {
        "id": "roadster",
        "name": "Roadster",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2005"
      },
      {
        "id": "roadster-brabus",
        "name": "Roadster Brabus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2003"
      },
      {
        "id": "roadster-coupe",
        "name": "Roadster Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2006"
      },
      {
        "id": "roadster-coupe-brabus",
        "name": "Roadster Coupe Brabus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2003"
      }
    ]
  },
  {
    "id": "subaru",
    "name": "Subaru",
    "logo": "⭐",
    "description": "Love. It's what makes Subaru",
    "models": [
      {
        "id": "brz",
        "name": "BRZ",
        "fuel": "Gasolina",
        "power": "234",
        "length": "4.265",
        "width": "1.775",
        "height": "1.310",
        "trunk": "237",
        "price": "39.500€"
      },
      {
        "id": "crosstrek",
        "name": "Crosstrek",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.495",
        "width": "1.800",
        "height": "1.600",
        "trunk": "315–1.314",
        "price": "32.000€"
      },
      {
        "id": "forester",
        "name": "Forester",
        "fuel": "Híbrid",
        "power": "153",
        "length": "4.670",
        "width": "1.830",
        "height": "1.730",
        "trunk": "N.D.",
        "price": "40.400€"
      },
      {
        "id": "impreza",
        "name": "Impreza",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.475",
        "width": "1.775",
        "height": "1.515",
        "trunk": "N.D.",
        "price": "31.250€"
      },
      {
        "id": "levorg",
        "name": "Levorg",
        "fuel": "Gasolina",
        "power": "150",
        "length": "4.690",
        "width": "1.780",
        "height": "1.485",
        "trunk": "N.D.",
        "price": "34.350€"
      },
      {
        "id": "levorg",
        "name": "Levorg",
        "fuel": "GLP",
        "power": "150",
        "length": "4.690",
        "width": "1.780",
        "height": "1.485",
        "trunk": "N.D.",
        "price": "34.350€"
      },
      {
        "id": "outback",
        "name": "Outback",
        "fuel": "Gasolina",
        "power": "169",
        "length": "4.870",
        "width": "1.875",
        "height": "1.675",
        "trunk": "561–1.822",
        "price": "39.500€"
      },
      {
        "id": "outback",
        "name": "Outback",
        "fuel": "GLP",
        "power": "169",
        "length": "4.870",
        "width": "1.875",
        "height": "1.675",
        "trunk": "561–1.822",
        "price": "39.500€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "360",
        "name": "360",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1958–1971"
      },
      {
        "id": "baja",
        "name": "Baja",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2003–2006"
      },
      {
        "id": "exiga-liberty",
        "name": "Exiga Liberty",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2018"
      },
      {
        "id": "impreza-wrx-sti",
        "name": "Impreza WRX STi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1998–2014"
      },
      {
        "id": "justy",
        "name": "Justy",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1989–2016"
      },
      {
        "id": "legacy-wagon",
        "name": "Legacy Wagon",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1998–2014"
      },
      {
        "id": "liberty",
        "name": "Liberty",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2015"
      },
      {
        "id": "mini-jumbo",
        "name": "Mini Jumbo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1988–1992"
      },
      {
        "id": "r1",
        "name": "R1",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2010"
      },
      {
        "id": "r2",
        "name": "R2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1969–2010"
      },
      {
        "id": "stella",
        "name": "Stella",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2011"
      },
      {
        "id": "svx",
        "name": "SVX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1997"
      },
      {
        "id": "trezia",
        "name": "Trezia",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2014"
      },
      {
        "id": "tribeca",
        "name": "Tribeca",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2013"
      },
      {
        "id": "vivio",
        "name": "Vivio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–2000"
      },
      {
        "id": "xv",
        "name": "XV",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2015"
      }
    ]
  },
  {
    "id": "suzuki",
    "name": "Suzuki",
    "logo": "🅂",
    "description": "Way of Life",
    "models": [
      {
        "id": "across",
        "name": "Across",
        "fuel": "PHEV",
        "power": "306",
        "length": "4.635",
        "width": "1.855",
        "height": "1.690",
        "trunk": "490–1.604",
        "price": "53.700€"
      },
      {
        "id": "e-vitara",
        "name": "e Vitara",
        "fuel": "Elèctric",
        "power": "144 / 174",
        "length": "4.275",
        "width": "1.800",
        "height": "1.635",
        "trunk": "238–562",
        "price": "35.550€"
      },
      {
        "id": "ignis",
        "name": "Ignis",
        "fuel": "Híbrid",
        "power": "83",
        "length": "3.700",
        "width": "1.690",
        "height": "1.605",
        "trunk": "260–1.100",
        "price": "15.225€"
      },
      {
        "id": "jimny-pro",
        "name": "Jimny Pro",
        "fuel": "Gasolina",
        "power": "102",
        "length": "3.480",
        "width": "1.645",
        "height": "1.720",
        "trunk": "863",
        "price": "23.568€"
      },
      {
        "id": "s-cross",
        "name": "S-Cross",
        "fuel": "Híbrid",
        "power": "116 / 129",
        "length": "4.300",
        "width": "1.785",
        "height": "1.580",
        "trunk": "430–1.230",
        "price": "23.550€"
      },
      {
        "id": "swace",
        "name": "Swace",
        "fuel": "Híbrid",
        "power": "122",
        "length": "4.655",
        "width": "1.790",
        "height": "1.460",
        "trunk": "596–1.232",
        "price": "23.545€"
      },
      {
        "id": "swift",
        "name": "Swift",
        "fuel": "Híbrid",
        "power": "82",
        "length": "3.890",
        "width": "1.735",
        "height": "1.495",
        "trunk": "N.D.",
        "price": "20.100€"
      },
      {
        "id": "vitara",
        "name": "Vitara",
        "fuel": "Híbrid",
        "power": "116 / 129",
        "length": "4.175",
        "width": "1.775",
        "height": "1.610",
        "trunk": "289–1.046",
        "price": "24.870€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "aerio-liana-hatchback",
        "name": "Aerio / Liana Hatchback",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2007"
      },
      {
        "id": "aerio-liana-sedan",
        "name": "Aerio / Liana Sedan",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2007"
      },
      {
        "id": "alto",
        "name": "Alto",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2002–2013"
      },
      {
        "id": "apv",
        "name": "APV",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2009"
      },
      {
        "id": "baleno",
        "name": "Baleno",
        "fuel": "Gasolina · Mild hybrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2019"
      },
      {
        "id": "equator",
        "name": "Equator",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2012"
      },
      {
        "id": "ertiga",
        "name": "Ertiga",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2015"
      },
      {
        "id": "escudo-grand-vitara-3-doors",
        "name": "Escudo / Grand Vitara 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2019"
      },
      {
        "id": "escudo-grand-vitara-5-doors",
        "name": "Escudo / Grand Vitara 5 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1991–2014"
      },
      {
        "id": "escudo-vitara-3-doors",
        "name": "Escudo / Vitara 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1989–2008"
      },
      {
        "id": "forenza-sedan",
        "name": "Forenza Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2008"
      },
      {
        "id": "forenza-wagon",
        "name": "Forenza Wagon",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2008"
      },
      {
        "id": "kizashi",
        "name": "Kizashi",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2009–2016"
      },
      {
        "id": "reno",
        "name": "Reno",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2008"
      },
      {
        "id": "splash",
        "name": "Splash",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2007–2014"
      },
      {
        "id": "swift-3-doors",
        "name": "Swift 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1991–2017"
      },
      {
        "id": "swift-cabriolet",
        "name": "Swift Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1992–1995"
      },
      {
        "id": "swift-sedan",
        "name": "Swift Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1996"
      },
      {
        "id": "sx4-crossover",
        "name": "SX4 Crossover",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2006–2021"
      },
      {
        "id": "sx4-sedan",
        "name": "SX4 Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2014"
      },
      {
        "id": "verona",
        "name": "Verona",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2006"
      },
      {
        "id": "wagon-r",
        "name": "Wagon R",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1997–2007"
      },
      {
        "id": "x90",
        "name": "X90",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–1997"
      },
      {
        "id": "xl7",
        "name": "XL7",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2009"
      }
    ]
  },
  {
    "id": "tesla",
    "name": "Tesla",
    "logo": "⚡",
    "description": "Electric Revolution",
    "models": [
      {
        "id": "cybertruck",
        "name": "Cybertruck",
        "fuel": "Elèctric",
        "power": "607",
        "length": "5.683",
        "width": "2.201",
        "height": "1.791",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "model-3",
        "name": "Model 3",
        "fuel": "Elèctric",
        "power": "264 / 462",
        "length": "4.720",
        "width": "1.850",
        "height": "1.441",
        "trunk": "425–542",
        "price": "39.990€"
      },
      {
        "id": "model-y",
        "name": "Model Y",
        "fuel": "Elèctric",
        "power": "514",
        "length": "4.790",
        "width": "2.129",
        "height": "1.624",
        "trunk": "N.D.",
        "price": "61.970€"
      }
    ]
  },
  {
    "id": "toyota",
    "name": "Toyota",
    "logo": "🚗",
    "description": "Let's Go Places",
    "models": [
      {
        "id": "5-puertas",
        "name": "5 puertas",
        "fuel": "Híbrid",
        "power": "140 / 193",
        "length": "4.370",
        "width": "1.790",
        "height": "1.460",
        "trunk": "313–1.004",
        "price": "25.500€"
      },
      {
        "id": "aygo",
        "name": "Aygo",
        "fuel": "Gasolina",
        "power": "72",
        "length": "3.465",
        "width": "1.615",
        "height": "1.460",
        "trunk": "168–198",
        "price": "11.875€"
      },
      {
        "id": "bz4x",
        "name": "bZ4X",
        "fuel": "Elèctric",
        "power": "224 / 343",
        "length": "4.690",
        "width": "1.860",
        "height": "1.650",
        "trunk": "452",
        "price": "43.000€"
      },
      {
        "id": "c-hr",
        "name": "C-HR",
        "fuel": "Híbrid",
        "power": "140 / 197",
        "length": "4.360",
        "width": "1.830",
        "height": "1.570",
        "trunk": "388",
        "price": "31.750€"
      },
      {
        "id": "c-hr",
        "name": "C-HR",
        "fuel": "PHEV",
        "power": "223",
        "length": "4.360",
        "width": "1.830",
        "height": "1.570",
        "trunk": "310",
        "price": "31.750€"
      },
      {
        "id": "c-hr",
        "name": "C-HR+",
        "fuel": "Elèctric",
        "power": "224 / 343",
        "length": "N.D.",
        "width": "N.D.",
        "height": "N.D.",
        "trunk": "416",
        "price": "40.000€"
      },
      {
        "id": "camry-hybrid",
        "name": "Camry Hybrid",
        "fuel": "Híbrid",
        "power": "218",
        "length": "4.885",
        "width": "1.840",
        "height": "1.445",
        "trunk": "524",
        "price": "36.500€"
      },
      {
        "id": "corolla-cross",
        "name": "Corolla Cross",
        "fuel": "Híbrid",
        "power": "140 / 197",
        "length": "4.460",
        "width": "1.825",
        "height": "1.620",
        "trunk": "N.D.",
        "price": "35.649€"
      },
      {
        "id": "gr-86",
        "name": "GR 86",
        "fuel": "Gasolina",
        "power": "234",
        "length": "4.265",
        "width": "1.775",
        "height": "1.310",
        "trunk": "226",
        "price": "34.900€"
      },
      {
        "id": "gr-supra",
        "name": "GR Supra",
        "fuel": "Gasolina",
        "power": "258 / 340",
        "length": "4.379",
        "width": "1.854",
        "height": "1.292",
        "trunk": "290",
        "price": "60.800€"
      },
      {
        "id": "gr-yaris",
        "name": "GR Yaris",
        "fuel": "Gasolina",
        "power": "261 / 280",
        "length": "3.995",
        "width": "1.805",
        "height": "1.455",
        "trunk": "174",
        "price": "22.300€"
      },
      {
        "id": "highlander",
        "name": "Highlander",
        "fuel": "Híbrid",
        "power": "248",
        "length": "4.966",
        "width": "1.930",
        "height": "1.755",
        "trunk": "268–1.909",
        "price": "60.500€"
      },
      {
        "id": "hilux",
        "name": "Hilux",
        "fuel": "Dièsel",
        "power": "150",
        "length": "5.325",
        "width": "1.855",
        "height": "1.815",
        "trunk": "N.D.",
        "price": "51.250€"
      },
      {
        "id": "hilux",
        "name": "Hilux",
        "fuel": "Híbrid",
        "power": "220",
        "length": "5.325",
        "width": "1.855",
        "height": "1.815",
        "trunk": "N.D.",
        "price": "51.250€"
      },
      {
        "id": "land-cruiser",
        "name": "Land Cruiser",
        "fuel": "Gasolina",
        "power": "204",
        "length": "4.920",
        "width": "1.980",
        "height": "1.870",
        "trunk": "N.D.",
        "price": "85.950€"
      },
      {
        "id": "mirai",
        "name": "Mirai",
        "fuel": "Elèctric",
        "power": "182",
        "length": "4.975",
        "width": "1.885",
        "height": "1.470",
        "trunk": "321",
        "price": "65.000€"
      },
      {
        "id": "prius-hybrid",
        "name": "Prius hybrid",
        "fuel": "PHEV",
        "power": "122",
        "length": "4.645",
        "width": "1.760",
        "height": "1.470",
        "trunk": "N.D.",
        "price": "25.330€"
      },
      {
        "id": "prius",
        "name": "Prius+",
        "fuel": "Híbrid",
        "power": "136",
        "length": "4.645",
        "width": "1.775",
        "height": "1.575",
        "trunk": "200–505",
        "price": "25.330€"
      },
      {
        "id": "proace-city-verso",
        "name": "Proace City Verso",
        "fuel": "Dièsel",
        "power": "102 / 131",
        "length": "4.403",
        "width": "1.848",
        "height": "1.880",
        "trunk": "N.D.",
        "price": "14.532€"
      },
      {
        "id": "proace-city-verso",
        "name": "Proace City Verso",
        "fuel": "Gasolina",
        "power": "110 / 130",
        "length": "4.753",
        "width": "1.848",
        "height": "1.880",
        "trunk": "N.D.",
        "price": "14.532€"
      },
      {
        "id": "rav4",
        "name": "RAV4",
        "fuel": "Híbrid",
        "power": "183",
        "length": "N.D.",
        "width": "N.D.",
        "height": "N.D.",
        "trunk": "514",
        "price": "38.000€"
      },
      {
        "id": "rav4",
        "name": "RAV4",
        "fuel": "PHEV",
        "power": "268",
        "length": "4.600",
        "width": "1.855",
        "height": "1.700",
        "trunk": "446",
        "price": "38.000€"
      },
      {
        "id": "sedan",
        "name": "Sedan",
        "fuel": "Híbrid",
        "power": "140",
        "length": "4.630",
        "width": "1.780",
        "height": "1.435",
        "trunk": "471",
        "price": "25.500€"
      },
      {
        "id": "touring-sports",
        "name": "Touring Sports",
        "fuel": "Híbrid",
        "power": "140 / 196",
        "length": "4.650",
        "width": "1.790",
        "height": "1.460",
        "trunk": "581–1.591",
        "price": "25.500€"
      },
      {
        "id": "yaris",
        "name": "Yaris",
        "fuel": "Gasolina",
        "power": "125",
        "length": "3.940",
        "width": "1.745",
        "height": "1.500",
        "trunk": "286",
        "price": "22.300€"
      },
      {
        "id": "yaris",
        "name": "Yaris",
        "fuel": "Híbrid",
        "power": "116 / 130",
        "length": "3.940",
        "width": "1.745",
        "height": "1.500",
        "trunk": "286",
        "price": "22.300€"
      },
      {
        "id": "yaris-cross",
        "name": "Yaris Cross",
        "fuel": "Híbrid",
        "power": "116 / 130",
        "length": "4.172",
        "width": "1.765",
        "height": "1.595",
        "trunk": "297",
        "price": "26.450€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "agya",
        "name": "Agya",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "alphard",
        "name": "Alphard",
        "fuel": "Gasolina · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2002–2007"
      },
      {
        "id": "aurion",
        "name": "Aurion",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2017"
      },
      {
        "id": "auris-3-doors",
        "name": "Auris 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2006–2010"
      },
      {
        "id": "auris-5-doors",
        "name": "Auris 5 Doors",
        "fuel": "Gasolina · Dièsel · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2006–2023"
      },
      {
        "id": "auris-touring",
        "name": "Auris Touring",
        "fuel": "Gasolina · Dièsel · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2015"
      },
      {
        "id": "avalon",
        "name": "Avalon",
        "fuel": "Gasolina · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2005–2022"
      },
      {
        "id": "avensis-sedan",
        "name": "Avensis Sedan",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1997–2018"
      },
      {
        "id": "avensis-liftback",
        "name": "Avensis Liftback",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1997–2011"
      },
      {
        "id": "avensis-verso",
        "name": "Avensis Verso",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2001–2006"
      },
      {
        "id": "avensis-wagon",
        "name": "Avensis Wagon",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1997–2018"
      },
      {
        "id": "aygo-3-doors",
        "name": "Aygo 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2014"
      },
      {
        "id": "aygo-5-doors",
        "name": "Aygo 5 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2005–2022"
      },
      {
        "id": "celica",
        "name": "Celica",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1990–2006"
      },
      {
        "id": "celica-convertible",
        "name": "Celica Convertible",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1991–1999"
      },
      {
        "id": "corolla-hatchback",
        "name": "Corolla Hatchback",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2020"
      },
      {
        "id": "corolla-us-sedan",
        "name": "Corolla (US) Sedan",
        "fuel": "Gasolina · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2013–2023"
      },
      {
        "id": "corolla-3-doors",
        "name": "Corolla 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1987–2007"
      },
      {
        "id": "corolla-5-doors",
        "name": "Corolla 5 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1987–2007"
      },
      {
        "id": "corolla-liftback",
        "name": "Corolla Liftback",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1987–1997"
      },
      {
        "id": "corolla-verso",
        "name": "Corolla Verso",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2002–2009"
      },
      {
        "id": "corolla-wagon",
        "name": "Corolla Wagon",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1997–2007"
      },
      {
        "id": "etios-sedan",
        "name": "Etios Sedan",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2022"
      },
      {
        "id": "etios-liva",
        "name": "Etios Liva",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2020"
      },
      {
        "id": "fj-cruiser",
        "name": "FJ Cruiser",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2016"
      },
      {
        "id": "gt-86",
        "name": "GT 86",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2021"
      },
      {
        "id": "harrier",
        "name": "Harrier",
        "fuel": "Gasolina · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2020"
      },
      {
        "id": "hilux-extra-cab",
        "name": "Hilux Extra Cab",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2017"
      },
      {
        "id": "hilux-single-cab",
        "name": "Hilux Single Cab",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2018"
      },
      {
        "id": "innova",
        "name": "Innova",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2011–2013"
      },
      {
        "id": "iq",
        "name": "iQ",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2015"
      },
      {
        "id": "land-cruiser-v8",
        "name": "Land Cruiser V8",
        "fuel": "Diesel · Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "8",
        "years": "1984–2021"
      },
      {
        "id": "matrix",
        "name": "Matrix",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2014"
      },
      {
        "id": "mr2",
        "name": "MR2",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1985–1999"
      },
      {
        "id": "mr2-cabriolet",
        "name": "MR2 Cabriolet",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2000–2005"
      },
      {
        "id": "paseo",
        "name": "Paseo",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2000"
      },
      {
        "id": "picnic",
        "name": "Picnic",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2001"
      },
      {
        "id": "previa-estima",
        "name": "Previa / Estima",
        "fuel": "Gasolina · Dièsel · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1992–2016"
      },
      {
        "id": "prius-c-aqua",
        "name": "Prius C (Aqua)",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2012–2021"
      },
      {
        "id": "prius-prime",
        "name": "Prius Prime",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2022"
      },
      {
        "id": "prius-v-prius",
        "name": "Prius v / Prius+",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2011–2021"
      },
      {
        "id": "rav4-3-doors",
        "name": "RAV4 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2000–2006"
      },
      {
        "id": "rukus",
        "name": "Rukus",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2015"
      },
      {
        "id": "solara-convertible",
        "name": "Solara Convertible",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2004–2008"
      },
      {
        "id": "starlet-3-doors",
        "name": "Starlet 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1984–1999"
      },
      {
        "id": "starlet-5-doors",
        "name": "Starlet 5 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1990–1999"
      },
      {
        "id": "verso",
        "name": "Verso",
        "fuel": "Diesel · Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2018"
      },
      {
        "id": "verso-s",
        "name": "Verso-S",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2017"
      },
      {
        "id": "vios",
        "name": "Vios",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2017"
      },
      {
        "id": "yaris-3-doors",
        "name": "Yaris 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1999–2020"
      },
      {
        "id": "yaris-hatchback",
        "name": "Yaris Hatchback",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2020"
      },
      {
        "id": "yaris-sedan",
        "name": "Yaris Sedan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2016–2020"
      },
      {
        "id": "yaris-ts-3-doors",
        "name": "Yaris TS 3 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2010"
      },
      {
        "id": "yaris-ts-5-doors",
        "name": "Yaris TS 5 Doors",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2010"
      },
      {
        "id": "yaris-verso",
        "name": "Yaris Verso",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1999–2007"
      }
    ]
  },
  {
    "id": "volkswagen",
    "name": "Volkswagen",
    "logo": "🚙",
    "description": "Das Auto",
    "models": [
      {
        "id": "amarok",
        "name": "Amarok",
        "fuel": "Dièsel",
        "power": "170 / 205 / 241",
        "length": "5.350",
        "width": "1.910",
        "height": "1.871",
        "trunk": "N.D.",
        "price": "54.980€"
      },
      {
        "id": "caddy",
        "name": "Caddy",
        "fuel": "Dièsel",
        "power": "102 / 122",
        "length": "4.500",
        "width": "1.855",
        "height": "1.833",
        "trunk": "N.D.",
        "price": "22.102€"
      },
      {
        "id": "caddy",
        "name": "Caddy",
        "fuel": "Gasolina",
        "power": "114",
        "length": "4.500",
        "width": "1.855",
        "height": "1.798",
        "trunk": "N.D.",
        "price": "22.102€"
      },
      {
        "id": "california",
        "name": "California",
        "fuel": "Dièsel",
        "power": "102 / 150 / 204",
        "length": "5.006",
        "width": "1.904",
        "height": "1.990",
        "trunk": "N.D.",
        "price": "36.240€"
      },
      {
        "id": "caravelle",
        "name": "Caravelle",
        "fuel": "Dièsel",
        "power": "102 / 150 / 204",
        "length": "5.006",
        "width": "1.904",
        "height": "1.990",
        "trunk": "N.D.",
        "price": "27.080€"
      },
      {
        "id": "e-up",
        "name": "e-Up!",
        "fuel": "Elèctric",
        "power": "82",
        "length": "3.600",
        "width": "1.645",
        "height": "1.492",
        "trunk": "250–923",
        "price": "10.580€"
      },
      {
        "id": "e-up",
        "name": "e-up!",
        "fuel": "Elèctric",
        "power": "83",
        "length": "3.600",
        "width": "1.645",
        "height": "1.492",
        "trunk": "195",
        "price": "10.580€"
      },
      {
        "id": "golf",
        "name": "Golf",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.282",
        "width": "1.789",
        "height": "1.483",
        "trunk": "381–1.237",
        "price": "28.050€"
      },
      {
        "id": "golf",
        "name": "Golf",
        "fuel": "Gasolina",
        "power": "115 / 150",
        "length": "4.282",
        "width": "1.789",
        "height": "1.483",
        "trunk": "381–1.237",
        "price": "28.050€"
      },
      {
        "id": "golf",
        "name": "Golf",
        "fuel": "Híbrid",
        "power": "115 / 150",
        "length": "4.282",
        "width": "1.789",
        "height": "1.483",
        "trunk": "381–1.237",
        "price": "28.050€"
      },
      {
        "id": "golf",
        "name": "Golf",
        "fuel": "PHEV",
        "power": "272",
        "length": "4.282",
        "width": "1.789",
        "height": "1.483",
        "trunk": "273–1.129",
        "price": "28.050€"
      },
      {
        "id": "golf-gti",
        "name": "Golf GTI",
        "fuel": "Gasolina",
        "power": "265 / 300",
        "length": "4.289",
        "width": "1.789",
        "height": "1.471",
        "trunk": "374–1.230",
        "price": "28.050€"
      },
      {
        "id": "golf-r",
        "name": "Golf R",
        "fuel": "Gasolina",
        "power": "333",
        "length": "4.296",
        "width": "1.789",
        "height": "1.454",
        "trunk": "341–1.197",
        "price": "28.050€"
      },
      {
        "id": "grand-california",
        "name": "Grand California",
        "fuel": "Dièsel",
        "power": "163",
        "length": "5.986",
        "width": "2.040",
        "height": "2.971",
        "trunk": "N.D.",
        "price": "36.240€"
      },
      {
        "id": "id-buzz",
        "name": "ID. Buzz",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.712",
        "width": "1.985",
        "height": "1.927",
        "trunk": "1.121",
        "price": "55.575€"
      },
      {
        "id": "id-buzz-gtx",
        "name": "ID. Buzz GTX",
        "fuel": "Elèctric",
        "power": "340",
        "length": "4.712",
        "width": "1.985",
        "height": "1.927",
        "trunk": "1.340–2.469",
        "price": "55.575€"
      },
      {
        "id": "id-polo",
        "name": "ID. Polo",
        "fuel": "Elèctric",
        "power": "116 / 135",
        "length": "4.053",
        "width": "1.816",
        "height": "1.530",
        "trunk": "441–1.240",
        "price": "22.800€"
      },
      {
        "id": "id3",
        "name": "ID.3",
        "fuel": "Elèctric",
        "power": "204",
        "length": "4.261",
        "width": "1.809",
        "height": "1.562",
        "trunk": "385–1.267",
        "price": "42.740€"
      },
      {
        "id": "id4",
        "name": "ID.4",
        "fuel": "Elèctric",
        "power": "170 / 286 / 340",
        "length": "4.584",
        "width": "1.852",
        "height": "1.612",
        "trunk": "543–1.575",
        "price": "39.010€"
      },
      {
        "id": "id5",
        "name": "ID.5",
        "fuel": "Elèctric",
        "power": "174 / 204",
        "length": "4.599",
        "width": "1.852",
        "height": "1.613",
        "trunk": "549–1.561",
        "price": "53.185€"
      },
      {
        "id": "id5-gtx",
        "name": "ID.5 GTX",
        "fuel": "Elèctric",
        "power": "299",
        "length": "4.582",
        "width": "1.853",
        "height": "1.619",
        "trunk": "549–1.561",
        "price": "53.185€"
      },
      {
        "id": "id7-gtx-tourer",
        "name": "ID.7 GTX Tourer",
        "fuel": "Elèctric",
        "power": "340",
        "length": "4.961",
        "width": "1.862",
        "height": "1.551",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "multivan",
        "name": "Multivan",
        "fuel": "PHEV",
        "power": "218",
        "length": "4.973",
        "width": "2.252",
        "height": "1.907",
        "trunk": "469–3.710",
        "price": "51.200€"
      },
      {
        "id": "passat",
        "name": "Passat",
        "fuel": "Dièsel",
        "power": "120 / 150 / 190",
        "length": "4.775",
        "width": "1.832",
        "height": "1.483",
        "trunk": "586",
        "price": "27.395€"
      },
      {
        "id": "passat",
        "name": "Passat",
        "fuel": "Gasolina",
        "power": "150 / 190",
        "length": "4.775",
        "width": "1.832",
        "height": "1.483",
        "trunk": "586",
        "price": "27.395€"
      },
      {
        "id": "passat",
        "name": "Passat",
        "fuel": "Híbrid",
        "power": "218",
        "length": "4.775",
        "width": "1.832",
        "height": "1.483",
        "trunk": "402",
        "price": "27.395€"
      },
      {
        "id": "passat-variant",
        "name": "Passat Variant",
        "fuel": "Dièsel",
        "power": "122 / 150 / 193",
        "length": "4.917",
        "width": "1.849",
        "height": "1.521",
        "trunk": "690–1.920",
        "price": "27.395€"
      },
      {
        "id": "passat-variant",
        "name": "Passat Variant",
        "fuel": "Gasolina",
        "power": "190",
        "length": "4.773",
        "width": "1.832",
        "height": "1.516",
        "trunk": "650–1.780",
        "price": "27.395€"
      },
      {
        "id": "passat-variant",
        "name": "Passat Variant",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.917",
        "width": "1.849",
        "height": "1.521",
        "trunk": "690–1.920",
        "price": "27.395€"
      },
      {
        "id": "passat-variant",
        "name": "Passat Variant",
        "fuel": "PHEV",
        "power": "204",
        "length": "4.917",
        "width": "1.849",
        "height": "1.521",
        "trunk": "510–1.920",
        "price": "27.395€"
      },
      {
        "id": "sharan",
        "name": "Sharan",
        "fuel": "Dièsel",
        "power": "115 / 150 / 184",
        "length": "4.854",
        "width": "1.904",
        "height": "1.720",
        "trunk": "955–2.430",
        "price": "36.670€"
      },
      {
        "id": "sharan",
        "name": "Sharan",
        "fuel": "Gasolina",
        "power": "220",
        "length": "4.854",
        "width": "1.904",
        "height": "1.720",
        "trunk": "955–2.430",
        "price": "36.670€"
      },
      {
        "id": "t-cross",
        "name": "T-Cross",
        "fuel": "Gasolina",
        "power": "95 / 115 / 150",
        "length": "4.127",
        "width": "1.760",
        "height": "1.573",
        "trunk": "385–1.281",
        "price": "23.970€"
      },
      {
        "id": "t-roc",
        "name": "T-Roc",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.236",
        "width": "1.819",
        "height": "1.584",
        "trunk": "445–1.290",
        "price": "29.220€"
      },
      {
        "id": "t-roc",
        "name": "T-Roc",
        "fuel": "Gasolina",
        "power": "110 / 150 / 300",
        "length": "4.236",
        "width": "1.819",
        "height": "1.584",
        "trunk": "445–1.290",
        "price": "29.220€"
      },
      {
        "id": "t-roc-cabrio",
        "name": "T-Roc Cabrio",
        "fuel": "Gasolina",
        "power": "110 / 150",
        "length": "4.271",
        "width": "1.819",
        "height": "1.584",
        "trunk": "284",
        "price": "29.220€"
      },
      {
        "id": "taigo",
        "name": "Taigo",
        "fuel": "Gasolina",
        "power": "95 / 110 / 150",
        "length": "4.266",
        "width": "1.757",
        "height": "1.515",
        "trunk": "440–1.222",
        "price": "24.675€"
      },
      {
        "id": "tayron",
        "name": "Tayron",
        "fuel": "Dièsel",
        "power": "150 / 193",
        "length": "4.792",
        "width": "1.852",
        "height": "1.660",
        "trunk": "885–2.090",
        "price": "48.155€"
      },
      {
        "id": "tayron",
        "name": "Tayron",
        "fuel": "Gasolina",
        "power": "204",
        "length": "4.792",
        "width": "1.852",
        "height": "1.660",
        "trunk": "885–2.090",
        "price": "48.155€"
      },
      {
        "id": "tayron",
        "name": "Tayron",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.792",
        "width": "1.852",
        "height": "1.660",
        "trunk": "885–2.090",
        "price": "48.155€"
      },
      {
        "id": "tayron",
        "name": "Tayron",
        "fuel": "PHEV",
        "power": "204",
        "length": "4.792",
        "width": "1.852",
        "height": "1.660",
        "trunk": "705–1.915",
        "price": "48.155€"
      },
      {
        "id": "tiguan",
        "name": "Tiguan",
        "fuel": "Dièsel",
        "power": "122 / 150 / 200",
        "length": "4.509",
        "width": "1.839",
        "height": "1.675",
        "trunk": "615–1.510",
        "price": "39.650€"
      },
      {
        "id": "tiguan",
        "name": "Tiguan",
        "fuel": "Gasolina",
        "power": "131 / 150 / 320",
        "length": "4.509",
        "width": "1.839",
        "height": "1.675",
        "trunk": "615–1.510",
        "price": "39.650€"
      },
      {
        "id": "tiguan",
        "name": "Tiguan",
        "fuel": "PHEV",
        "power": "245",
        "length": "N.D.",
        "width": "N.D.",
        "height": "N.D.",
        "trunk": "N.D.",
        "price": "39.650€"
      },
      {
        "id": "touareg",
        "name": "Touareg",
        "fuel": "Dièsel",
        "power": "231 / 286",
        "length": "4.878",
        "width": "1.984",
        "height": "1.720",
        "trunk": "810–1.800",
        "price": "77.020€"
      },
      {
        "id": "touareg",
        "name": "Touareg",
        "fuel": "PHEV",
        "power": "381 / 462",
        "length": "4.878",
        "width": "1.984",
        "height": "1.720",
        "trunk": "655–1.675",
        "price": "77.020€"
      },
      {
        "id": "touran",
        "name": "Touran",
        "fuel": "Dièsel",
        "power": "115 / 150 / 190",
        "length": "4.527",
        "width": "1.829",
        "height": "1.659",
        "trunk": "137–1.857",
        "price": "27.115€"
      },
      {
        "id": "touran",
        "name": "Touran",
        "fuel": "Gasolina",
        "power": "110 / 150",
        "length": "4.527",
        "width": "1.829",
        "height": "1.659",
        "trunk": "137–1.857",
        "price": "27.115€"
      },
      {
        "id": "up-3p",
        "name": "Up! 3P",
        "fuel": "Gasolina",
        "power": "60 / 75 / 90",
        "length": "3.540",
        "width": "1.641",
        "height": "1.489",
        "trunk": "251–951",
        "price": "10.580€"
      },
      {
        "id": "up-3p",
        "name": "Up! 3P",
        "fuel": "GLP",
        "power": "68",
        "length": "3.600",
        "width": "1.645",
        "height": "1.504",
        "trunk": "213–913",
        "price": "10.580€"
      },
      {
        "id": "up-5p",
        "name": "Up! 5P",
        "fuel": "Gasolina",
        "power": "60 / 75 / 90",
        "length": "3.540",
        "width": "1.641",
        "height": "1.478",
        "trunk": "251–951",
        "price": "10.580€"
      },
      {
        "id": "up-5p",
        "name": "Up! 5P",
        "fuel": "GLP",
        "power": "68",
        "length": "3.600",
        "width": "1.645",
        "height": "1.504",
        "trunk": "213–913",
        "price": "10.580€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "ameo",
        "name": "Ameo",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2016–2020"
      },
      {
        "id": "beetle",
        "name": "Beetle",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "7",
        "years": "1945–2019"
      },
      {
        "id": "beetle-cabrio",
        "name": "Beetle Cabrio",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2003–2019"
      },
      {
        "id": "cc",
        "name": "CC",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2017"
      },
      {
        "id": "corrado",
        "name": "Corrado",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1995"
      },
      {
        "id": "cross-up",
        "name": "Cross UP!",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2019"
      },
      {
        "id": "derby",
        "name": "Derby",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1977–1981"
      },
      {
        "id": "e-golf",
        "name": "e-Golf",
        "fuel": "Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2021"
      },
      {
        "id": "eos",
        "name": "Eos",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2016"
      },
      {
        "id": "fox",
        "name": "Fox",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2009"
      },
      {
        "id": "gol",
        "name": "Gol",
        "fuel": "Ethanol",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2016"
      },
      {
        "id": "golf-3-doors",
        "name": "Golf 3 Doors",
        "fuel": "Gasolina · Dièsel · Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "8",
        "years": "1974–2019"
      },
      {
        "id": "golf-cabrio",
        "name": "Golf Cabrio",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1993–2016"
      },
      {
        "id": "golf-gtd-variant",
        "name": "Golf GTD Variant",
        "fuel": "Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2021"
      },
      {
        "id": "golf-gti-cabrio",
        "name": "Golf GTI Cabrio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2012–2015"
      },
      {
        "id": "golf-plus",
        "name": "Golf Plus",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2005–2013"
      },
      {
        "id": "golf-r-cabrio",
        "name": "Golf R Cabrio",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2017"
      },
      {
        "id": "golf-sportsvan",
        "name": "Golf Sportsvan",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2020"
      },
      {
        "id": "lavida-china",
        "name": "Lavida (China)",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2012"
      },
      {
        "id": "lupo",
        "name": "Lupo",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "1998–2005"
      },
      {
        "id": "passat-sedan",
        "name": "Passat Sedan",
        "fuel": "Gasolina · Dièsel · Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "12",
        "years": "1981–2022"
      },
      {
        "id": "passat-3-doors",
        "name": "Passat 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1973–1981"
      },
      {
        "id": "passat-alltrack",
        "name": "Passat Alltrack",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2012–2023"
      },
      {
        "id": "passat-gte",
        "name": "Passat GTE",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2015–2022"
      },
      {
        "id": "passat-hatchback",
        "name": "Passat Hatchback",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1981–1987"
      },
      {
        "id": "passat-r",
        "name": "Passat R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2008–2010"
      },
      {
        "id": "passat-variant-gte",
        "name": "Passat Variant GTE",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2015–2023"
      },
      {
        "id": "phaeton",
        "name": "Phaeton",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2002–2016"
      },
      {
        "id": "pointer",
        "name": "Pointer",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1996"
      },
      {
        "id": "polo-3-doors",
        "name": "Polo 3 Doors",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "9",
        "years": "1975–2017"
      },
      {
        "id": "polo-bluegt",
        "name": "Polo BlueGT",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2019"
      },
      {
        "id": "polo-coupe",
        "name": "Polo Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1982–1990"
      },
      {
        "id": "polo-sedan",
        "name": "Polo Sedan",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1996–2022"
      },
      {
        "id": "polo-variant",
        "name": "Polo Variant",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2001"
      },
      {
        "id": "routan",
        "name": "Routan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2008–2013"
      },
      {
        "id": "santana",
        "name": "Santana",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1982–1985"
      },
      {
        "id": "scirocco",
        "name": "Scirocco",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1977–2018"
      },
      {
        "id": "scirocco-r",
        "name": "Scirocco R",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2009–2018"
      },
      {
        "id": "transporter-kombi",
        "name": "Transporter Kombi",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2024"
      },
      {
        "id": "up",
        "name": "up!",
        "fuel": "Gasolina · Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2012–2023"
      },
      {
        "id": "up-gti",
        "name": "up! GTI",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2023"
      },
      {
        "id": "vento",
        "name": "Vento",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2019"
      },
      {
        "id": "xl1",
        "name": "XL1",
        "fuel": "Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2016"
      }
    ]
  },
  {
    "id": "volvo",
    "name": "Volvo",
    "logo": "⚪",
    "description": "For Life",
    "models": [
      {
        "id": "c40-recharge",
        "name": "C40 Recharge",
        "fuel": "Elèctric",
        "power": "252 / 408",
        "length": "4.440",
        "width": "1.873",
        "height": "1.591",
        "trunk": "413–1.205",
        "price": "52.380€"
      },
      {
        "id": "es90",
        "name": "ES90",
        "fuel": "Elèctric",
        "power": "333",
        "length": "5.000",
        "width": "1.942",
        "height": "1.546",
        "trunk": "494–1.256",
        "price": "72.752€"
      },
      {
        "id": "ex30",
        "name": "EX30",
        "fuel": "Elèctric",
        "power": "272 / 428",
        "length": "4.233",
        "width": "1.837",
        "height": "1.555",
        "trunk": "400",
        "price": "36.770€"
      },
      {
        "id": "ex60",
        "name": "EX60",
        "fuel": "Elèctric",
        "power": "374 / 510 / 680",
        "length": "4.803",
        "width": "1.899",
        "height": "1.639",
        "trunk": "523–1.647",
        "price": "64.900€"
      },
      {
        "id": "ex60-cross-country",
        "name": "EX60 Cross Country",
        "fuel": "Elèctric",
        "power": "510",
        "length": "4.811",
        "width": "1.899",
        "height": "1.660",
        "trunk": "634–1.647",
        "price": "64.900€"
      },
      {
        "id": "ex90",
        "name": "EX90",
        "fuel": "Elèctric",
        "power": "279 / 408 / 517",
        "length": "5.037",
        "width": "1.964",
        "height": "1.747",
        "trunk": "377–2.107",
        "price": "83.127€"
      },
      {
        "id": "s60",
        "name": "S60",
        "fuel": "Gasolina",
        "power": "190 / 250",
        "length": "4.761",
        "width": "1.850",
        "height": "1.431",
        "trunk": "442",
        "price": "41.950€"
      },
      {
        "id": "s60",
        "name": "S60",
        "fuel": "Híbrid",
        "power": "88 / 197 / 250",
        "length": "4.761",
        "width": "1.850",
        "height": "1.431",
        "trunk": "390",
        "price": "41.950€"
      },
      {
        "id": "s60-recharge",
        "name": "S60 Recharge",
        "fuel": "PHEV",
        "power": "390 / 405",
        "length": "4.761",
        "width": "2.040",
        "height": "1.431",
        "trunk": "391",
        "price": "41.950€"
      },
      {
        "id": "s90",
        "name": "S90",
        "fuel": "Híbrid",
        "power": "197 / 235",
        "length": "4.969",
        "width": "2.019",
        "height": "1.440",
        "trunk": "461",
        "price": "53.950€"
      },
      {
        "id": "s90-recharge",
        "name": "S90 Recharge",
        "fuel": "PHEV",
        "power": "390",
        "length": "4.969",
        "width": "2.019",
        "height": "1.440",
        "trunk": "461",
        "price": "53.950€"
      },
      {
        "id": "v60",
        "name": "V60",
        "fuel": "Híbrid",
        "power": "163 / 197",
        "length": "4.761",
        "width": "2.040",
        "height": "1.432",
        "trunk": "529–1.441",
        "price": "43.333€"
      },
      {
        "id": "v60-cross-country",
        "name": "V60 Cross Country",
        "fuel": "Híbrid",
        "power": "197 / 250",
        "length": "4.784",
        "width": "2.040",
        "height": "1.499",
        "trunk": "529–1.441",
        "price": "43.333€"
      },
      {
        "id": "v60-recharge",
        "name": "V60 Recharge",
        "fuel": "PHEV",
        "power": "340 / 405",
        "length": "4.761",
        "width": "2.040",
        "height": "1.432",
        "trunk": "529–1.441",
        "price": "43.333€"
      },
      {
        "id": "v90",
        "name": "V90",
        "fuel": "Híbrid",
        "power": "197 / 235",
        "length": "4.945",
        "width": "2.019",
        "height": "1.478",
        "trunk": "560–1.526",
        "price": "55.734€"
      },
      {
        "id": "v90-cross-country",
        "name": "V90 Cross Country",
        "fuel": "Híbrid",
        "power": "197 / 235",
        "length": "4.959",
        "width": "2.052",
        "height": "1.537",
        "trunk": "560–1.526",
        "price": "55.734€"
      },
      {
        "id": "v90-recharge",
        "name": "V90 Recharge",
        "fuel": "PHEV",
        "power": "340 / 390",
        "length": "4.945",
        "width": "2.019",
        "height": "1.472",
        "trunk": "560–1.526",
        "price": "55.734€"
      },
      {
        "id": "xc40",
        "name": "XC40",
        "fuel": "Híbrid",
        "power": "163 / 197",
        "length": "4.440",
        "width": "1.863",
        "height": "1.657",
        "trunk": "443–1.432",
        "price": "39.450€"
      },
      {
        "id": "xc90",
        "name": "XC90",
        "fuel": "Híbrid",
        "power": "250",
        "length": "4.953",
        "width": "1.923",
        "height": "1.767",
        "trunk": "680–1.856",
        "price": "82.200€"
      },
      {
        "id": "xc90",
        "name": "XC90",
        "fuel": "PHEV",
        "power": "455",
        "length": "4.953",
        "width": "1.923",
        "height": "1.767",
        "trunk": "680–1.856",
        "price": "82.200€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "142",
        "name": "142",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1967–1974"
      },
      {
        "id": "144",
        "name": "144",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1966–1974"
      },
      {
        "id": "145",
        "name": "145",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1967–1974"
      },
      {
        "id": "244",
        "name": "244",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1990"
      },
      {
        "id": "245",
        "name": "245",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1990"
      },
      {
        "id": "262",
        "name": "262",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1977–1981"
      },
      {
        "id": "264",
        "name": "264",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1980–1982"
      },
      {
        "id": "265",
        "name": "265",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1980–1982"
      },
      {
        "id": "343",
        "name": "343",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–1982"
      },
      {
        "id": "345",
        "name": "345",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1979–1982"
      },
      {
        "id": "440",
        "name": "440",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1988–1996"
      },
      {
        "id": "460",
        "name": "460",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1990–1996"
      },
      {
        "id": "480",
        "name": "480",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1995"
      },
      {
        "id": "66",
        "name": "66",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1975–1981"
      },
      {
        "id": "760",
        "name": "760",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1982–1990"
      },
      {
        "id": "760-estate",
        "name": "760 Estate",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1985–1990"
      },
      {
        "id": "780",
        "name": "780",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1986–1990"
      },
      {
        "id": "850",
        "name": "850",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1992–1997"
      },
      {
        "id": "850-estate",
        "name": "850 Estate",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1993–1997"
      },
      {
        "id": "940",
        "name": "940",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1997"
      },
      {
        "id": "940-estate",
        "name": "940 Estate",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1990–1998"
      },
      {
        "id": "960",
        "name": "960",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1990–1997"
      },
      {
        "id": "960-estate",
        "name": "960 Estate",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1994–1997"
      },
      {
        "id": "c30",
        "name": "C30",
        "fuel": "Gasolina · Dièsel · Etanol",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2013"
      },
      {
        "id": "c70",
        "name": "C70",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2013"
      },
      {
        "id": "c70-convertible",
        "name": "C70 Convertible",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1999–2005"
      },
      {
        "id": "c70-coupe",
        "name": "C70 Coupe",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1996–2002"
      },
      {
        "id": "p1800",
        "name": "P1800",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1961–1973"
      },
      {
        "id": "s40",
        "name": "S40",
        "fuel": "Gasolina · Dièsel · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1996–2012"
      },
      {
        "id": "s60-cross-country",
        "name": "S60 Cross Country",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2015–2018"
      },
      {
        "id": "s60-polestar",
        "name": "S60 Polestar",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2014–2018"
      },
      {
        "id": "s70",
        "name": "S70",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1997–2000"
      },
      {
        "id": "s80",
        "name": "S80",
        "fuel": "Gasolina · Dièsel · Etanol",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1998–2016"
      },
      {
        "id": "v40",
        "name": "V40",
        "fuel": "Gasolina · Dièsel · Híbrid",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "1996–2019"
      },
      {
        "id": "v40-cross-country",
        "name": "V40 Cross Country",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2012–2019"
      },
      {
        "id": "v50",
        "name": "V50",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2004–2011"
      },
      {
        "id": "v60-polestar",
        "name": "V60 Polestar",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2018"
      },
      {
        "id": "v70",
        "name": "V70",
        "fuel": "Gasolina · Dièsel · Etanol · Gas natural",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "1997–2016"
      },
      {
        "id": "xc60-polestar",
        "name": "XC60 Polestar",
        "fuel": "Híbrid gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2021"
      }
    ]
  },
  {
    "id": "voyah",
    "name": "Voyah",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "dream",
        "name": "Dream",
        "fuel": "Elèctric",
        "power": "435",
        "length": "5.315",
        "width": "1.985",
        "height": "1.800",
        "trunk": "N.D.",
        "price": "94.600€"
      },
      {
        "id": "free",
        "name": "Free",
        "fuel": "Elèctric",
        "power": "490",
        "length": "4.905",
        "width": "1.950",
        "height": "1.645",
        "trunk": "560–1.320",
        "price": "77.790€"
      }
    ]
  },
  {
    "id": "wey",
    "name": "WEY",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "coffee-01",
        "name": "Coffee 01",
        "fuel": "PHEV",
        "power": "475",
        "length": "4.870",
        "width": "1.960",
        "height": "1.690",
        "trunk": "N.D.",
        "price": "N.D.€"
      },
      {
        "id": "coffee-03",
        "name": "Coffee 03",
        "fuel": "PHEV",
        "power": "442",
        "length": "4.668",
        "width": "1.890",
        "height": "1.730",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ]
  },
  {
    "id": "xiaomi",
    "name": "Xiaomi",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "su7",
        "name": "SU7",
        "fuel": "Elèctric",
        "power": "673",
        "length": "4.997",
        "width": "1.963",
        "height": "1.440",
        "trunk": "N.D.",
        "price": "N.D.€"
      }
    ]
  },
  {
    "id": "xpeng",
    "name": "Xpeng",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "p7",
        "name": "P7+",
        "fuel": "Elèctric",
        "power": "245 / 313 / 503",
        "length": "5.071",
        "width": "1.937",
        "height": "1.512",
        "trunk": "573–1.931",
        "price": "40.800€"
      }
    ]
  },
  {
    "id": "zeekr",
    "name": "Zeekr",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "001",
        "name": "001",
        "fuel": "Elèctric",
        "power": "272 / 544",
        "length": "4.955",
        "width": "1.999",
        "height": "1.560",
        "trunk": "N.D.",
        "price": "59.490€"
      },
      {
        "id": "7gt",
        "name": "7GT",
        "fuel": "Elèctric",
        "power": "421 / 646",
        "length": "4.817",
        "width": "1.910",
        "height": "1.456",
        "trunk": "456",
        "price": "45.600€"
      },
      {
        "id": "x",
        "name": "X",
        "fuel": "Elèctric",
        "power": "272 / 428",
        "length": "4.432",
        "width": "1.836",
        "height": "1.566",
        "trunk": "N.D.",
        "price": "44.900€"
      }
    ]
  },
  {
    "id": "skoda",
    "name": "Škoda",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [
      {
        "id": "citigo-e-iv",
        "name": "Citigo e iV",
        "fuel": "Elèctric",
        "power": "83",
        "length": "3.597",
        "width": "1.645",
        "height": "1.484",
        "trunk": "250–923",
        "price": "19.850€"
      },
      {
        "id": "elroq",
        "name": "Elroq",
        "fuel": "Elèctric",
        "power": "170 / 204 / 286",
        "length": "4.488",
        "width": "1.884",
        "height": "1.625",
        "trunk": "470–1.580",
        "price": "34.490€"
      },
      {
        "id": "elroq-rs",
        "name": "Elroq RS",
        "fuel": "Elèctric",
        "power": "340",
        "length": "4.488",
        "width": "1.884",
        "height": "1.608",
        "trunk": "470–1.580",
        "price": "34.490€"
      },
      {
        "id": "enyaq-coupe",
        "name": "Enyaq Coupé",
        "fuel": "Elèctric",
        "power": "204 / 286",
        "length": "4.658",
        "width": "1.879",
        "height": "1.620",
        "trunk": "585–1.710",
        "price": "49.300€"
      },
      {
        "id": "fabia",
        "name": "Fabia",
        "fuel": "Gasolina",
        "power": "80 / 95 / 110 / 150",
        "length": "4.108",
        "width": "1.780",
        "height": "1.459",
        "trunk": "380–1.190",
        "price": "17.160€"
      },
      {
        "id": "kamiq",
        "name": "Kamiq",
        "fuel": "Gasolina",
        "power": "95 / 115 / 150",
        "length": "4.241",
        "width": "1.793",
        "height": "1.531",
        "trunk": "400–1.395",
        "price": "26.200€"
      },
      {
        "id": "karoq",
        "name": "Karoq",
        "fuel": "Dièsel",
        "power": "116 / 150",
        "length": "4.390",
        "width": "1.841",
        "height": "1.603",
        "trunk": "521–1.810",
        "price": "28.200€"
      },
      {
        "id": "karoq",
        "name": "Karoq",
        "fuel": "Gasolina",
        "power": "110 / 150",
        "length": "4.390",
        "width": "1.841",
        "height": "1.603",
        "trunk": "521–1.810",
        "price": "28.200€"
      },
      {
        "id": "kodiaq",
        "name": "Kodiaq",
        "fuel": "Dièsel",
        "power": "150 / 193",
        "length": "4.758",
        "width": "1.864",
        "height": "1.657",
        "trunk": "910–2.105",
        "price": "48.915€"
      },
      {
        "id": "kodiaq",
        "name": "Kodiaq",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.758",
        "width": "1.864",
        "height": "1.659",
        "trunk": "910–2.105",
        "price": "48.915€"
      },
      {
        "id": "kodiaq",
        "name": "Kodiaq",
        "fuel": "PHEV",
        "power": "204",
        "length": "4.758",
        "width": "1.864",
        "height": "1.656",
        "trunk": "745–1.948",
        "price": "48.915€"
      },
      {
        "id": "octavia",
        "name": "Octavia",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.698",
        "width": "1.829",
        "height": "1.470",
        "trunk": "600–1.555",
        "price": "32.500€"
      },
      {
        "id": "octavia",
        "name": "Octavia",
        "fuel": "Híbrid",
        "power": "115 / 150",
        "length": "4.698",
        "width": "1.829",
        "height": "1.470",
        "trunk": "600–1.555",
        "price": "32.500€"
      },
      {
        "id": "octavia-combi",
        "name": "Octavia Combi",
        "fuel": "Dièsel",
        "power": "115 / 150",
        "length": "4.698",
        "width": "1.829",
        "height": "1.468",
        "trunk": "640–1.700",
        "price": "32.500€"
      },
      {
        "id": "octavia-combi",
        "name": "Octavia Combi",
        "fuel": "Híbrid",
        "power": "115 / 150",
        "length": "4.698",
        "width": "1.829",
        "height": "1.468",
        "trunk": "640–1.700",
        "price": "32.500€"
      },
      {
        "id": "rapid",
        "name": "Rapid",
        "fuel": "Dièsel",
        "power": "90 / 115",
        "length": "4.483",
        "width": "1.706",
        "height": "1.461",
        "trunk": "550–1.490",
        "price": "18.500€"
      },
      {
        "id": "rapid",
        "name": "Rapid",
        "fuel": "Gasolina",
        "power": "95 / 110 / 125",
        "length": "4.483",
        "width": "1.706",
        "height": "1.461",
        "trunk": "550–1.490",
        "price": "18.500€"
      },
      {
        "id": "scala",
        "name": "Scala",
        "fuel": "Gasolina",
        "power": "95 / 116 / 150",
        "length": "4.362",
        "width": "1.793",
        "height": "1.471",
        "trunk": "467–1.510",
        "price": "24.930€"
      },
      {
        "id": "scout",
        "name": "Scout",
        "fuel": "Dièsel",
        "power": "150 / 184",
        "length": "4.687",
        "width": "1.814",
        "height": "1.531",
        "trunk": "610–1.740",
        "price": "32.030€"
      },
      {
        "id": "spaceback",
        "name": "Spaceback",
        "fuel": "Dièsel",
        "power": "90 / 115",
        "length": "4.304",
        "width": "1.706",
        "height": "1.459",
        "trunk": "415–1.381",
        "price": "18.060€"
      },
      {
        "id": "spaceback",
        "name": "Spaceback",
        "fuel": "Gasolina",
        "power": "90 / 110 / 125",
        "length": "4.304",
        "width": "1.706",
        "height": "1.459",
        "trunk": "415–1.381",
        "price": "18.060€"
      },
      {
        "id": "superb-combi",
        "name": "Superb Combi",
        "fuel": "Dièsel",
        "power": "150 / 193",
        "length": "4.902",
        "width": "1.849",
        "height": "1.482",
        "trunk": "690–1.920",
        "price": "41.900€"
      },
      {
        "id": "superb-combi",
        "name": "Superb Combi",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.902",
        "width": "1.849",
        "height": "1.482",
        "trunk": "690–1.920",
        "price": "41.900€"
      },
      {
        "id": "superb-combi",
        "name": "Superb Combi",
        "fuel": "PHEV",
        "power": "204",
        "length": "4.902",
        "width": "1.849",
        "height": "1.482",
        "trunk": "510–1.770",
        "price": "41.900€"
      },
      {
        "id": "superb-limo",
        "name": "Superb Limo",
        "fuel": "Dièsel",
        "power": "150 / 193",
        "length": "4.912",
        "width": "1.849",
        "height": "1.481",
        "trunk": "645–1.795",
        "price": "41.900€"
      },
      {
        "id": "superb-limo",
        "name": "Superb Limo",
        "fuel": "Híbrid",
        "power": "150",
        "length": "4.912",
        "width": "1.849",
        "height": "1.481",
        "trunk": "645–1.795",
        "price": "41.900€"
      },
      {
        "id": "yeti",
        "name": "Yeti",
        "fuel": "Dièsel",
        "power": "110 / 150",
        "length": "4.222",
        "width": "1.793",
        "height": "1.691",
        "trunk": "416–1.760",
        "price": "21.360€"
      },
      {
        "id": "yeti",
        "name": "Yeti",
        "fuel": "Gasolina",
        "power": "110 / 125 / 150",
        "length": "4.222",
        "width": "1.793",
        "height": "1.691",
        "trunk": "416–1.760",
        "price": "21.360€"
      },
      {
        "id": "yeti-outdoor",
        "name": "Yeti Outdoor",
        "fuel": "Dièsel",
        "power": "110 / 150",
        "length": "4.222",
        "width": "1.793",
        "height": "1.691",
        "trunk": "416–1.760",
        "price": "21.360€"
      },
      {
        "id": "yeti-outdoor",
        "name": "Yeti Outdoor",
        "fuel": "Gasolina",
        "power": "110 / 125 / 150",
        "length": "4.222",
        "width": "1.793",
        "height": "1.691",
        "trunk": "416–1.760",
        "price": "21.360€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "100-series",
        "name": "100 series",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1969–1982"
      },
      {
        "id": "860",
        "name": "860",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1929–1933"
      },
      {
        "id": "citigo",
        "name": "Citigo",
        "fuel": "Gasolina · GNC · Elèctric",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "2011–2020"
      },
      {
        "id": "fabia-combi",
        "name": "Fabia Combi",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "4",
        "years": "2000–2021"
      },
      {
        "id": "fabia-combi-rs",
        "name": "Fabia Combi RS",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2010–2014"
      },
      {
        "id": "fabia-rs",
        "name": "Fabia RS",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2003–2014"
      },
      {
        "id": "fabia-sedan",
        "name": "Fabia Sedan",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2001–2006"
      },
      {
        "id": "favorit",
        "name": "Favorit",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1989–1995"
      },
      {
        "id": "favorit-estate",
        "name": "Favorit Estate",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1991–1994"
      },
      {
        "id": "felicia",
        "name": "Felicia",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2001"
      },
      {
        "id": "felicia-combi",
        "name": "Felicia Combi",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1995–2001"
      },
      {
        "id": "octavia-combi-4x4",
        "name": "Octavia Combi 4x4",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "3",
        "years": "2009–2020"
      },
      {
        "id": "rapid-spaceback",
        "name": "Rapid Spaceback",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2013–2019"
      },
      {
        "id": "roomster",
        "name": "Roomster",
        "fuel": "Gasolina · Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2006–2015"
      }
    ]
  },
  {
    "id": "land-rover",
    "name": "Land Rover",
    "logo": "🌲",
    "description": "Above and Beyond",
    "models": [
      {
        "id": "defender-110",
        "name": "Defender 110",
        "fuel": "Híbrid",
        "power": "635",
        "length": "5.003",
        "width": "2.064",
        "height": "1.995",
        "trunk": "543–1.835",
        "price": "210.050€"
      },
      {
        "id": "discovery",
        "name": "Discovery",
        "fuel": "Dièsel",
        "power": "180 / 240 / 258",
        "length": "4.970",
        "width": "2.073",
        "height": "1.888",
        "trunk": "723–2.500",
        "price": "57.600€"
      },
      {
        "id": "discovery",
        "name": "Discovery",
        "fuel": "Gasolina",
        "power": "300 / 340",
        "length": "4.970",
        "width": "2.073",
        "height": "1.888",
        "trunk": "723–2.500",
        "price": "57.600€"
      },
      {
        "id": "discovery-sport",
        "name": "Discovery Sport",
        "fuel": "Dièsel",
        "power": "150 / 179 / 241",
        "length": "4.597",
        "width": "1.894",
        "height": "1.727",
        "trunk": "1.574",
        "price": "39.400€"
      },
      {
        "id": "discovery-sport",
        "name": "Discovery Sport",
        "fuel": "Gasolina",
        "power": "200 / 250",
        "length": "4.597",
        "width": "1.894",
        "height": "1.727",
        "trunk": "1.574",
        "price": "39.400€"
      },
      {
        "id": "discovery-sport",
        "name": "Discovery Sport",
        "fuel": "PHEV",
        "power": "309",
        "length": "4.597",
        "width": "1.894",
        "height": "1.727",
        "trunk": "780–1.574",
        "price": "39.400€"
      },
      {
        "id": "range-rover",
        "name": "Range Rover",
        "fuel": "Gasolina",
        "power": "530",
        "length": "5.052",
        "width": "2.047",
        "height": "1.870",
        "trunk": "818–1.841",
        "price": "140.950€"
      },
      {
        "id": "range-rover",
        "name": "Range Rover",
        "fuel": "Híbrid",
        "power": "300 / 350",
        "length": "5.052",
        "width": "2.047",
        "height": "1.870",
        "trunk": "818–1.841",
        "price": "140.950€"
      },
      {
        "id": "range-rover",
        "name": "Range Rover",
        "fuel": "PHEV",
        "power": "440",
        "length": "5.052",
        "width": "2.047",
        "height": "1.870",
        "trunk": "575–1.841",
        "price": "140.950€"
      },
      {
        "id": "range-rover-electric",
        "name": "Range Rover Electric",
        "fuel": "Elèctric",
        "power": "550",
        "length": "5.052",
        "width": "2.209",
        "height": "1.867",
        "trunk": "N.D.",
        "price": "140.950€"
      },
      {
        "id": "range-rover-evoque",
        "name": "Range Rover Evoque",
        "fuel": "Híbrid",
        "power": "309",
        "length": "4.371",
        "width": "1.904",
        "height": "1.649",
        "trunk": "472–1.156",
        "price": "37.950€"
      },
      {
        "id": "range-rover-evoque-5p",
        "name": "Range Rover Evoque 5P",
        "fuel": "Dièsel",
        "power": "150 / 179 / 241",
        "length": "4.370",
        "width": "1.985",
        "height": "1.635",
        "trunk": "575–1.445",
        "price": "37.950€"
      },
      {
        "id": "range-rover-evoque-5p",
        "name": "Range Rover Evoque 5P",
        "fuel": "Gasolina",
        "power": "200 / 221 / 249 / 300",
        "length": "4",
        "width": "2",
        "height": "2",
        "trunk": "N.D.",
        "price": "37.950€"
      },
      {
        "id": "range-rover-evoque-convertible",
        "name": "Range Rover Evoque Convertible",
        "fuel": "Dièsel",
        "power": "150 / 180 / 240",
        "length": "4.370",
        "width": "1.980",
        "height": "1.609",
        "trunk": "251",
        "price": "37.950€"
      },
      {
        "id": "range-rover-evoque-convertible",
        "name": "Range Rover Evoque Convertible",
        "fuel": "Gasolina",
        "power": "240",
        "length": "4.370",
        "width": "1.980",
        "height": "1.609",
        "trunk": "251",
        "price": "37.950€"
      },
      {
        "id": "range-rover-sport",
        "name": "Range Rover Sport",
        "fuel": "Gasolina",
        "power": "530",
        "length": "4.946",
        "width": "2.047",
        "height": "1.820",
        "trunk": "647–1.491",
        "price": "102.700€"
      },
      {
        "id": "range-rover-sport",
        "name": "Range Rover Sport",
        "fuel": "Híbrid",
        "power": "249 / 300 / 615",
        "length": "4.946",
        "width": "2.047",
        "height": "1.820",
        "trunk": "450–1.491",
        "price": "102.700€"
      },
      {
        "id": "range-rover-sport",
        "name": "Range Rover Sport",
        "fuel": "PHEV",
        "power": "440 / 550",
        "length": "4.946",
        "width": "2.047",
        "height": "1.820",
        "trunk": "450–1.491",
        "price": "102.700€"
      },
      {
        "id": "range-rover-velar",
        "name": "Range Rover Velar",
        "fuel": "Dièsel",
        "power": "180 / 240 / 300",
        "length": "4.803",
        "width": "2.032",
        "height": "1.665",
        "trunk": "673–1.731",
        "price": "59.250€"
      },
      {
        "id": "range-rover-velar",
        "name": "Range Rover Velar",
        "fuel": "Gasolina",
        "power": "250 / 300 / 380",
        "length": "4.803",
        "width": "2.032",
        "height": "1.665",
        "trunk": "673–1.731",
        "price": "59.250€"
      }
    ],
    "discontinuedModels": [
      {
        "id": "range-rover-3-doors",
        "name": "Range Rover 3 Doors",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1988–1993"
      },
      {
        "id": "freelander",
        "name": "Freelander",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "5",
        "years": "1998–2014"
      },
      {
        "id": "range-rover-phev",
        "name": "Range Rover PHEV",
        "fuel": "Híbrid / Híbrid dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2013–2022"
      },
      {
        "id": "range-rover-l",
        "name": "Range Rover L",
        "fuel": "Gasolina / Dièsel",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2014–2021"
      },
      {
        "id": "range-rover-sport-svr",
        "name": "Range Rover Sport SVR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "2015–2022"
      },
      {
        "id": "discovery-svx",
        "name": "Discovery SVX",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2020"
      },
      {
        "id": "range-rover-sport-phev",
        "name": "Range Rover Sport PHEV",
        "fuel": "Híbrid endollable",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2017–2022"
      }
    ]
  },
  {
    "id": "caterham",
    "name": "Caterham",
    "logo": "🚗",
    "description": "Quality Vehicles",
    "models": [],
    "discontinuedModels": [
      {
        "id": "classic",
        "name": "Classic",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2000–2005"
      },
      {
        "id": "csr",
        "name": "CSR",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2005–2024"
      },
      {
        "id": "roadsport",
        "name": "Roadsport",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2009"
      }
    ]
  },
  {
    "id": "lotus",
    "name": "Lotus",
    "logo": "🍀",
    "description": "For the Drivers",
    "models": [],
    "discontinuedModels": [
      {
        "id": "elite",
        "name": "Elite",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1957–1983"
      },
      {
        "id": "elan",
        "name": "Elan",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1962–1994"
      },
      {
        "id": "europa",
        "name": "Europa",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "2",
        "years": "1965–2010"
      },
      {
        "id": "esprit",
        "name": "Esprit",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1976–2004"
      },
      {
        "id": "excel",
        "name": "Excel",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "1982–1992"
      },
      {
        "id": "2-eleven",
        "name": "2 Eleven",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2007–2015"
      },
      {
        "id": "evora",
        "name": "Evora",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "6",
        "years": "2008–2021"
      },
      {
        "id": "3-eleven",
        "name": "3 Eleven",
        "fuel": "Gasolina",
        "power": "",
        "length": "",
        "width": "",
        "height": "",
        "trunk": "",
        "price": "",
        "discontinued": true,
        "generations": "1",
        "years": "2018–2018"
      }
    ]
  }
];
